// src/config.tsx
import { createContext, useContext } from "react";
import { jsx } from "react/jsx-runtime";
function defineGlobalSearch(input) {
  return { ...input, privileged: input.privileged ?? {}, options: input.options ?? {} };
}
var GlobalSearchConfigContext = createContext(null);
var useStaticPrivileged = () => void 0;
var PrivilegedReachContext = createContext(null);
var GlobalSearchProvider = ({ config, children }) => {
  const usePrivileged = config.usePrivileged ?? useStaticPrivileged;
  const resolved = usePrivileged() ?? config.privileged;
  return /* @__PURE__ */ jsx(GlobalSearchConfigContext.Provider, { value: config, children: /* @__PURE__ */ jsx(PrivilegedReachContext.Provider, { value: resolved, children }) });
};
function usePrivilegedReach() {
  const resolved = useContext(PrivilegedReachContext);
  const config = useGlobalSearchConfig();
  return resolved ?? config.privileged;
}
function useGlobalSearchConfig() {
  const config = useContext(GlobalSearchConfigContext);
  if (!config) {
    throw new Error(
      "Global search is not configured. Wrap the search surface in <GlobalSearchProvider config={\u2026}> with a config built by defineGlobalSearch()."
    );
  }
  return config;
}
var useAlwaysEnabled = () => true;
var useOpenRunAccess = () => OPEN_RUN_ACCESS;
var OPEN_RUN_ACCESS = {};
var useNoHref = () => void 0;
var useOpenTrainingScope = () => void 0;
var useNoCompletedKeys = () => void 0;
var useNoScopeOptions = () => EMPTY_SCOPE;
var EMPTY_SCOPE = [];
var useNoHintTerms = () => EMPTY_HINTS;
var EMPTY_HINTS = {};
var useDefaultResultNavigate = () => noopNavigate;
var noopNavigate = (_item, _event) => void 0;
function isEntityModule(registration) {
  return typeof registration !== "string";
}

// src/pages/GlobalSearchResultsPage.tsx
import React5, { useCallback as useCallback8, useEffect as useEffect5, useMemo as useMemo15, useState as useState6 } from "react";
import { useLocation, useNavigate, useSearchParams as useSearchParams2 } from "react-router-dom";
import { Box as Box13, Button as Button2, Chip as Chip5, Divider, Stack, Typography as Typography11 } from "@mui/material";
import { BiArrowBack, BiSearchAlt } from "react-icons/bi";

// src/useGlobalSearch.ts
import { useMemo as useMemo12, useRef } from "react";

// src/entities/customers.tsx
import { useMemo as useMemo3 } from "react";

// src/gql/searchCustomers.query.generated.ts
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import { resolveExecutor } from "@hopdrive/sdk-core";
var defaultOptions = {};
var SearchCustomersDocument = gql`
    query searchCustomers($where: customers_bool_exp!, $limit: Int!, $offset: Int!, $withCount: Boolean!) {
  customers(where: $where, limit: $limit, offset: $offset, order_by: {name: asc}) {
    id
    updatedat
    name
    email
    phone
    address
    status
    active
    tier
    category
    organization {
      id
      name
    }
  }
  customers_aggregate(where: $where) @include(if: $withCount) {
    aggregate {
      count
    }
  }
}
    `;
function useSearchCustomersQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(SearchCustomersDocument, options);
}

// src/entities/entitySearch.ts
import { useMemo } from "react";
function pageVariables(where, { limit, offset = 0, withTotal = false }) {
  return { where: where ?? {}, limit: limit + 1, offset, withCount: withTotal };
}
function useEntityResult({ rows, total, skipped, limit, loading, error }, toItem3) {
  const items = useMemo(
    () => skipped ? [] : (rows ?? []).slice(0, limit).map(toItem3),
    [rows, skipped, limit, toItem3]
  );
  return {
    items,
    loading: !skipped && loading,
    hasMore: !skipped && (rows ?? []).length > limit,
    total,
    error
  };
}

// src/entities/countFallback.ts
import { useEffect, useSyncExternalStore } from "react";
var ROOT_AGGREGATE_MISSING = /field '\w+_aggregate' not found in type: 'query_root'|Cannot query field "\w+_aggregate" on type "query_root"/;
function messagesOf(error) {
  if (typeof error === "string") return [error];
  if (!error || typeof error !== "object") return [];
  const { message, graphQLErrors } = error;
  const messages = typeof message === "string" ? [message] : [];
  for (const nested of graphQLErrors ?? []) {
    if (typeof nested?.message === "string") messages.push(nested.message);
  }
  return messages;
}
function isRootAggregateValidationError(error) {
  return messagesOf(error).some((message) => ROOT_AGGREGATE_MISSING.test(message));
}
var blocked = /* @__PURE__ */ new Set();
var listeners = /* @__PURE__ */ new Set();
var countBlocklist = {
  has: (key) => blocked.has(key),
  add(key) {
    if (blocked.has(key)) return;
    blocked.add(key);
    console.warn(
      `[global-search] ${key}: this role can't aggregate, so exact totals are off for the session (allow_aggregations grant missing on the table).`
    );
    listeners.forEach((listener) => listener());
  },
  subscribe(listener) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  /** Test seam. */
  reset() {
    blocked.clear();
  }
};
function useCanCount(key) {
  const isBlocked = useSyncExternalStore(
    countBlocklist.subscribe,
    () => blocked.has(key),
    () => blocked.has(key)
  );
  return !isBlocked;
}
function useCountFallback(key, { error, loading }) {
  const aggregateError = isRootAggregateValidationError(error);
  const canCount = useCanCount(key);
  useEffect(() => {
    if (aggregateError) countBlocklist.add(key);
  }, [aggregateError, key]);
  if (!aggregateError) return error;
  if (canCount || loading) return void 0;
  return error;
}

// src/components/CustomerSearchCard.tsx
import { Box as Box3, Chip as Chip2, Typography as Typography3 } from "@mui/material";
import { BiBuildings, BiStore as BiStore2 } from "react-icons/bi";
import { allTokens as allTokens3 } from "@hopdrive/ui/tokens";

// src/components/SearchResultCard.tsx
import { useContext as useContext2 } from "react";
import { Link as RouterLink } from "react-router-dom";
import { alpha } from "@mui/material/styles";
import { Avatar, Box as Box2, ButtonBase, CardActionArea, Chip, Typography as Typography2 } from "@mui/material";
import { allTokens as allTokens2 } from "@hopdrive/ui/tokens";
import { BiBook, BiChevronDown, BiMap, BiSolidCar, BiSolidReceipt, BiStore, BiTrip, BiUser } from "react-icons/bi";
import { PiSteeringWheelFill } from "react-icons/pi";

// src/utils/moveId.ts
var DISPLAY_MOVE_ID = /^(?:l-|#)(\d+)$/i;
function stripMoveIdPrefix(term) {
  const match = DISPLAY_MOVE_ID.exec(term);
  return match ? match[1] : term;
}
function formatMoveIdLabel(id, lite, options = {}) {
  if (lite) return `L-${id}`;
  return options.hash ? `#${id}` : String(id);
}

// src/utils/searchQuery.ts
var VIN_MIN_LENGTH = 11;
var VIN_MAX_LENGTH = 17;
var PHONE_MIN_DIGITS = 7;
var PHONE_MAX_DIGITS = 11;
var MIN_TRGM_LENGTH = 3;
function extractDigits(value) {
  return value.replace(/\D/g, "");
}
function normalizePhoneDigits(digits) {
  const d = digits.length === PHONE_MAX_DIGITS && digits.startsWith("1") ? digits.slice(1) : digits;
  return d.length >= 12 ? d.slice(0, 10) : d;
}
function escapeLikePattern(value) {
  return value.replace(/[\\%_]/g, (char) => `\\${char}`);
}
function isPhoneLike(term, digits) {
  if (digits.length < PHONE_MIN_DIGITS || digits.length > PHONE_MAX_DIGITS) return false;
  return /^[\d\s\-().+]+$/.test(term);
}
function isVinLike(term) {
  if (term.length < VIN_MIN_LENGTH || term.length > VIN_MAX_LENGTH) return false;
  return /^[A-Za-z0-9]+$/.test(term) && /\d/.test(term) && /[A-Za-z]/.test(term);
}
function buildPhonePatterns(digits) {
  if (!digits) return [];
  const d = normalizePhoneDigits(digits);
  const patterns = /* @__PURE__ */ new Set([`%${d}%`]);
  if (d.length === 10) {
    const [area, prefix, line] = [d.slice(0, 3), d.slice(3, 6), d.slice(6)];
    patterns.add(`%(${area}) ${prefix}-${line}%`);
    patterns.add(`%${area}-${prefix}-${line}%`);
    patterns.add(`%${area}.${prefix}.${line}%`);
    patterns.add(`%${area} ${prefix} ${line}%`);
  }
  if (d.length === 7) {
    patterns.add(`%${d.slice(0, 3)}-${d.slice(3)}%`);
  }
  return [...patterns];
}
function parseSearchQuery(raw) {
  const term = stripMoveIdPrefix(raw.trim());
  const digits = extractDigits(term);
  let kind;
  if (!term) kind = "empty";
  else if (term.includes("@")) kind = "email";
  else if (/^\d+$/.test(term)) kind = "numeric";
  else if (isPhoneLike(term, digits)) kind = "phone";
  else if (isVinLike(term)) kind = "vin";
  else kind = "text";
  return {
    raw,
    term,
    kind,
    like: `%${escapeLikePattern(term)}%`,
    digits,
    phoneDigits: normalizePhoneDigits(digits),
    phonePatterns: kind === "phone" || kind === "numeric" ? buildPhonePatterns(digits) : []
  };
}
function meetsMinLength(query) {
  if (query.kind === "empty") return false;
  if (query.kind === "numeric") return query.term.length >= 1;
  return query.term.length >= MIN_TRGM_LENGTH;
}

// src/utils/matchFields.ts
function matchedFields(fields, query) {
  if (!fields?.length) return [];
  const term = query.term.trim().toLowerCase();
  if (!term) return [];
  return fields.filter((field) => field.value.toLowerCase() === term);
}
function scenarioMatchFields(scenarioIds) {
  const seen = /* @__PURE__ */ new Set();
  const fields = [];
  for (const id of scenarioIds) {
    if (id == null || seen.has(id)) continue;
    seen.add(id);
    fields.push({ label: "Scenario", value: String(id) });
  }
  return fields;
}

// src/components/DispatchNotesChip.tsx
import { Box, Tooltip, Typography } from "@mui/material";
import { BiNote } from "react-icons/bi";
import { allTokens } from "@hopdrive/ui/tokens";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var { palette, radius } = allTokens;
var NOTES_SHOWN = 6;
function noteDate(iso) {
  if (!iso) return "";
  const ms = Date.parse(iso);
  if (Number.isNaN(ms)) return "";
  return new Intl.DateTimeFormat("en-US", { month: "numeric", day: "numeric" }).format(ms);
}
var DispatchNotesChip = ({ item }) => {
  const notes = item.notes ?? [];
  const noteCount = item.noteCount ?? 0;
  if (noteCount < 1) return null;
  return /* @__PURE__ */ jsx2(
    Tooltip,
    {
      placement: "bottom-start",
      title: /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", flexDirection: "column", gap: 1, py: 0.5, maxWidth: 360 }, children: [
        notes.slice(0, NOTES_SHOWN).map((entry, index) => /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsxs(Typography, { sx: { fontSize: 12, whiteSpace: "pre-wrap" }, children: [
            "\u201C",
            entry.note,
            "\u201D"
          ] }),
          /* @__PURE__ */ jsx2(Typography, { sx: { fontSize: 10.5, opacity: 0.75 }, children: [entry.createdby, noteDate(entry.createdat), entry.moveId != null && `move #${entry.moveId}`].filter(Boolean).join(" \xB7 ") })
        ] }, `${entry.moveId ?? "subject"}-${index}`)),
        noteCount > Math.min(notes.length, NOTES_SHOWN) && /* @__PURE__ */ jsxs(Typography, { sx: { fontSize: 10.5, opacity: 0.75 }, children: [
          "+",
          noteCount - Math.min(notes.length, NOTES_SHOWN),
          " more on the record\u2019s pages"
        ] })
      ] }),
      children: /* @__PURE__ */ jsxs(
        Box,
        {
          sx: {
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            height: 20,
            px: 1,
            borderRadius: `${radius.full}px`,
            bgcolor: "rgba(32,36,48,0.12)",
            color: palette.grey[700],
            fontSize: 11,
            fontWeight: 600,
            cursor: "default"
          },
          children: [
            /* @__PURE__ */ jsx2(BiNote, { size: 11, "aria-hidden": true }),
            noteCount === 1 ? "1 note" : `${noteCount} notes`
          ]
        }
      )
    }
  );
};
var DispatchNotesChip_default = DispatchNotesChip;

// src/components/RelatedStripContext.tsx
import { createContext as createContext2 } from "react";
var RelatedStripContext = createContext2(null);

// src/utils/resultsView.ts
import { useState } from "react";

// src/utils/rankResults.ts
function fieldScore(field, needle, base) {
  const value = field.toLowerCase();
  if (!value || !needle) return 0;
  if (value === needle) return base + 40;
  if (value.startsWith(needle)) return base + 20;
  if (value.includes(needle)) return base;
  return 0;
}
function digitsScore(field, digits, base) {
  const value = extractDigits(field);
  if (!value || !digits) return 0;
  if (value === digits) return base + 40;
  if (value.startsWith(digits)) return base + 20;
  if (value.includes(digits)) return base;
  return 0;
}
function scoreItem(item, query) {
  if (query.kind === "phone" || query.kind === "numeric") {
    return Math.max(
      digitsScore(item.title, query.phoneDigits, 60),
      digitsScore(item.primaryLine ?? "", query.phoneDigits, 30),
      // Badges are labelled ids (`L-78553` for a Lite move) — score the digits (#2324).
      fieldScore(stripMoveIdPrefix(item.badge ?? ""), query.term, 60)
    );
  }
  const needle = query.term.toLowerCase();
  return Math.max(fieldScore(item.title, needle, 60), fieldScore(item.primaryLine ?? "", needle, 30));
}
function rankItems(items, query) {
  if (items.length < 2) return items;
  return [...items].sort((a, b) => scoreItem(b, query) - scoreItem(a, query));
}

// src/utils/searchScoring.ts
var SEARCH_RANKING_ALGORITHMS = {
  V1_0_0: "v1.0.0"
};
var SEARCH_RANKING_VARIABLES = {
  [SEARCH_RANKING_ALGORITHMS.V1_0_0]: {
    /** Match quality dominates: real evidence beats priors and freshness */
    MATCH_WEIGHT: 3,
    RECENCY_WEIGHT: 1,
    ENTITY_PRIOR_WEIGHT: 1,
    /** 10 today → 0 at the cliff, clamped (dispatch's distance-cliff shape) */
    RECENCY_CLIFF_DAYS: 90,
    /** Entities without a surfaced timestamp sit mid-scale, never buried */
    UNDATED_RECENCY_SCORE: 5,
    /**
     * Floor for a record the query hit through a hidden identifier (a move in
     * scenario 48213): exact evidence, just not on the record's own id, so it
     * ranks under own-id exacts (10) and above prefix hits (7).
     */
    MATCHED_FIELD_SCORE: 8
  }
};
var V1 = SEARCH_RANKING_VARIABLES[SEARCH_RANKING_ALGORITHMS.V1_0_0];
var round2 = (n) => Math.round(n * 100) / 100;
var clamp10 = (n) => Math.max(0, Math.min(10, n));
function scoreRecency(recency, now = /* @__PURE__ */ new Date()) {
  if (!recency) return V1.UNDATED_RECENCY_SCORE;
  const t = Date.parse(recency);
  if (Number.isNaN(t)) return V1.UNDATED_RECENCY_SCORE;
  const days = (now.getTime() - t) / (24 * 60 * 60 * 1e3);
  return round2(clamp10(10 - days * (10 / V1.RECENCY_CLIFF_DAYS)));
}
function defaultMatchScore10(item, query) {
  return Math.max(2, clamp10(scoreItem(item, query) / 10));
}
function scoreSearchItem(item, query, entity, now = /* @__PURE__ */ new Date()) {
  const entityScore = entity.scoreItem?.(item, query) ?? defaultMatchScore10(item, query);
  const fieldScore2 = matchedFields(item.matchFields, query).length > 0 ? V1.MATCHED_FIELD_SCORE : 0;
  const matchScore = round2(clamp10(Math.max(entityScore, fieldScore2)));
  return {
    matchScore,
    recencyScore: scoreRecency(item.recency, now),
    entityPriorScore: round2(clamp10(entity.priorityFor(query.kind) / 10))
  };
}
function combineScoreFactors(factors) {
  const totalWeight = V1.MATCH_WEIGHT + V1.RECENCY_WEIGHT + V1.ENTITY_PRIOR_WEIGHT;
  return round2(
    (factors.matchScore * V1.MATCH_WEIGHT + factors.recencyScore * V1.RECENCY_WEIGHT + factors.entityPriorScore * V1.ENTITY_PRIOR_WEIGHT) / totalWeight
  );
}

// src/utils/resultsView.ts
var SEARCH_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
var DEFAULT_PAGE_SIZE = 25;
var MAX_FETCH_PER_ENTITY = 500;
var REFINE_NUDGE_PAGE = 3;
function fetchDepthFor(page, rowsPerPage) {
  return Math.min((page + 1) * rowsPerPage, MAX_FETCH_PER_ENTITY);
}
function isFetchCapped(page, rowsPerPage) {
  return (page + 1) * rowsPerPage > MAX_FETCH_PER_ENTITY;
}
function reachableBounds({
  displayTotal,
  pooledRows,
  page,
  rowsPerPage
}) {
  const capped = isFetchCapped(page, rowsPerPage);
  const reachableTotal = capped ? Math.min(displayTotal, pooledRows) : displayTotal;
  const lastPage = Math.max(0, Math.ceil(reachableTotal / rowsPerPage) - 1);
  return { reachableTotal, page: Math.min(page, lastPage), capped };
}
var PAGE_SIZE_KEY = "global-search-page-size";
function matchesRefine(item, term) {
  return [
    item.title,
    item.primaryLine,
    item.secondaryLine,
    item.badge,
    item.status,
    ...item.titleChips?.map((chip) => chip.label) ?? [],
    ...item.footChips?.map((chip) => chip.label) ?? []
  ].filter(Boolean).join(" ").toLowerCase().includes(term.trim().toLowerCase());
}
function refineSections(sections, refine) {
  const term = refine.trim().toLowerCase();
  if (!term) return sections;
  const matched = /* @__PURE__ */ new Set();
  for (const section of sections) {
    for (const item of section.items) {
      if (matchesRefine(item, term)) matched.add(item.key);
    }
  }
  const keptRelatives = /* @__PURE__ */ new Set();
  const keptAnchors = /* @__PURE__ */ new Map();
  for (const section of sections) {
    for (const item of section.items) {
      if (!item.relatedKeys?.length && !item.relatedItems?.length) continue;
      if (matched.has(item.key)) {
        for (const key of item.relatedKeys ?? []) keptRelatives.add(key);
        continue;
      }
      const matchedKeys = (item.relatedKeys ?? []).filter((key) => matched.has(key));
      const matchedCarried = (item.relatedItems ?? []).filter((carried) => matchesRefine(carried, term));
      if (matchedKeys.length || matchedCarried.length) {
        keptAnchors.set(item.key, { ...item, relatedKeys: matchedKeys, relatedItems: matchedCarried });
      }
    }
  }
  return sections.map((section) => ({
    ...section,
    items: section.items.filter((item) => matched.has(item.key) || keptRelatives.has(item.key) || keptAnchors.has(item.key)).map((item) => keptAnchors.get(item.key) ?? item),
    hasMore: false,
    total: void 0
  }));
}
function computeDisplayTotals(sections) {
  return {
    total: sections.reduce((n, s) => n + (s.total ?? s.items.length), 0),
    hasMore: sections.some((s) => s.total == null && s.hasMore)
  };
}
function readStored(read, fallback) {
  try {
    return read();
  } catch {
    return fallback;
  }
}
function writeStored(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
  }
}
function useStoredSearchPageSize() {
  const [size, setSize] = useState(
    () => readStored(() => {
      const stored = Number(localStorage.getItem(PAGE_SIZE_KEY));
      return SEARCH_PAGE_SIZE_OPTIONS.includes(stored) ? stored : DEFAULT_PAGE_SIZE;
    }, DEFAULT_PAGE_SIZE)
  );
  const change = (next) => {
    setSize(next);
    writeStored(PAGE_SIZE_KEY, String(next));
  };
  return [size, change];
}
function sectionsSignature(sections) {
  return sections.map(
    (section) => `${section.entity.key}:${section.error ? "e" : ""}${section.loading ? "l" : ""}:` + section.items.map((item) => `${item.key}~${item.recency ?? ""}${item.secondaryLine ? "s" : ""}${item.contextLine ? "c" : ""}`).join(",")
  ).join("|");
}
function mergeSections(sections, query, now = /* @__PURE__ */ new Date()) {
  return sections.filter((section) => !section.error).flatMap(
    (section) => section.items.map((item) => {
      const scoreFactors = scoreSearchItem(item, query, section.entity, now);
      const chip = section.entity.itemLabel ? { label: section.entity.itemLabel, tone: "identity", icon: section.entity.itemIcon } : null;
      return {
        ...item,
        ...chip ? { titleChips: [chip, ...item.titleChips ?? []] } : {},
        score: combineScoreFactors(scoreFactors),
        scoreFactors
      };
    })
  ).sort((a, b) => (b.score ?? 0) - (a.score ?? 0)).reduce(hoistRelatedReducer(), []);
}
function recencyMs(entry) {
  const parsed = entry.recency ? Date.parse(entry.recency) : NaN;
  return Number.isNaN(parsed) ? -Infinity : parsed;
}
function hoistRelatedReducer() {
  const consumed = /* @__PURE__ */ new Set();
  let sorted = [];
  let poolKeys = null;
  return (out, item, index, all) => {
    if (index === 0) {
      sorted = all;
      poolKeys = new Set(all.map((entry) => entry.key));
    }
    if (consumed.has(item.key)) return out;
    const asRelated = (relative) => ({
      ...relative,
      relatedTo: item.key
    });
    const relatives = [];
    if (item.relatedKeys?.length) {
      const wanted = new Set(item.relatedKeys);
      for (let i = index + 1; i < sorted.length; i++) {
        const candidate = sorted[i];
        if (!consumed.has(candidate.key) && wanted.has(candidate.key)) {
          consumed.add(candidate.key);
          relatives.push(candidate);
        }
      }
    }
    for (const carried of item.relatedItems ?? []) {
      if (!poolKeys?.has(carried.key) && !consumed.has(carried.key)) {
        consumed.add(carried.key);
        relatives.push(carried);
      }
    }
    relatives.sort((a, b) => recencyMs(b) - recencyMs(a));
    out.push(relatives.length ? { ...item, relatedCount: relatives.length } : item);
    for (const relative of relatives) out.push(asRelated(relative));
    return out;
  };
}
function normalizePagedStrips(items) {
  const present = new Set(items.map((item) => item.key));
  const anchorsWithRelatives = new Set(
    items.filter((item) => item.relatedTo && present.has(item.relatedTo)).map((item) => item.relatedTo)
  );
  return items.map((item) => {
    const orphanedRelative = item.relatedTo != null && !present.has(item.relatedTo);
    const strandedAnchor = item.relatedCount != null && !anchorsWithRelatives.has(item.key);
    if (!orphanedRelative && !strandedAnchor) return item;
    const repaired = { ...item };
    if (orphanedRelative) {
      delete repaired.relatedTo;
      delete repaired.relatedLast;
    }
    if (strandedAnchor) delete repaired.relatedCount;
    return repaired;
  });
}
var RELATED_VISIBLE_CAP = 1;
function collapseRelatedRows(items, expandedAnchors, cap = RELATED_VISIBLE_CAP) {
  const shown = /* @__PURE__ */ new Map();
  const visible = items.filter((item) => {
    if (!item.relatedTo) return true;
    if (expandedAnchors.has(item.relatedTo)) return true;
    const count = (shown.get(item.relatedTo) ?? 0) + 1;
    shown.set(item.relatedTo, count);
    return count <= cap;
  });
  return visible.map(
    (item, i) => item.relatedTo && visible[i + 1]?.relatedTo !== item.relatedTo ? { ...item, relatedLast: true } : item
  );
}
function resolveEntityCard(entities, item) {
  const entity = entities.find((candidate) => candidate.key === item.entityKey);
  if (entity?.Card && (!entity.cardRequiresPayload || item.payload != null)) return entity.Card;
  return SearchResultCard_default;
}

// src/components/SearchResultCard.tsx
import { Fragment, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var { palette: palette2, typography, radius: radius2 } = allTokens2;
var LEVEL_STYLES = {
  // What the row IS — role/type identity chips, itemLabel chips
  strong: { bg: "rgba(32,36,48,0.12)", color: palette2.grey[700], border: "none" },
  // Attributes — tier, product, location type
  mid: { bg: palette2.grey[100], color: palette2.grey[600], border: "none" },
  // Context — rooftop, region, inactive
  light: { bg: palette2.grey[50], color: palette2.grey[500], border: `1px solid ${palette2.grey[200]}` }
};
var TONE_LEVEL = {
  identity: "strong",
  portal: "strong",
  internal: "strong",
  guest: "strong",
  driver: "strong",
  saas: "mid",
  fullservice: "mid",
  hybrid: "mid",
  concierge: "mid",
  shuttle: "mid",
  service: "mid",
  parts: "mid",
  neutral: "light"
};
var CHIP_ICONS = {
  person: BiUser,
  driver: PiSteeringWheelFill,
  move: BiSolidCar,
  lane: BiTrip,
  location: BiMap,
  store: BiStore,
  book: BiBook,
  invoice: BiSolidReceipt
};
var ToneChip = ({ chip }) => {
  const style = LEVEL_STYLES[TONE_LEVEL[chip.tone ?? "neutral"]];
  const Icon = chip.icon ? CHIP_ICONS[chip.icon] : null;
  return /* @__PURE__ */ jsx3(
    Chip,
    {
      label: Icon ? /* @__PURE__ */ jsxs2(Box2, { component: "span", sx: { display: "inline-flex", alignItems: "center", gap: "4px" }, children: [
        /* @__PURE__ */ jsx3(Icon, { size: 11, "aria-hidden": true }),
        chip.label
      ] }) : chip.label,
      size: "small",
      sx: {
        height: 20,
        fontSize: 11,
        fontWeight: 600,
        borderRadius: `${radius2.full}px`,
        backgroundColor: style.bg,
        color: style.color,
        border: style.border,
        "& .MuiChip-label": { px: 1, display: "inline-flex", alignItems: "center" }
      }
    }
  );
};
var MatchChips = ({ item, query }) => /* @__PURE__ */ jsx3(Fragment, { children: matchedFields(item.matchFields, query).map((field) => /* @__PURE__ */ jsx3(
  Chip,
  {
    size: "small",
    label: /* @__PURE__ */ jsxs2(Box2, { component: "span", sx: { display: "inline-flex", alignItems: "center", gap: "4px" }, children: [
      field.label,
      /* @__PURE__ */ jsx3(
        Box2,
        {
          component: "mark",
          sx: {
            bgcolor: alpha(palette2.warning.main, 0.3),
            color: "inherit",
            borderRadius: "2px",
            fontFamily: typography.fontFamily.mono,
            fontWeight: 700
          },
          children: field.value
        }
      )
    ] }),
    sx: {
      height: 20,
      fontSize: 11,
      fontWeight: 500,
      borderRadius: `${radius2.full}px`,
      bgcolor: "background.paper",
      color: palette2.grey[700],
      border: `1px dashed ${palette2.grey[400]}`,
      "& .MuiChip-label": { px: 1, display: "inline-flex", alignItems: "center" }
    }
  },
  `${field.label}-${field.value}`
)) });
var hasMatchChips = (item, query) => matchedFields(item.matchFields, query).length > 0;
function statusStyle(status) {
  switch (status.toLowerCase()) {
    case "dispatched":
    case "pickup started":
    case "delivery started":
    case "in_transit":
    case "in transit":
      return { bg: palette2.info[50], color: palette2.info[700] };
    case "pickup successful":
    case "delivery successful":
    case "completed":
      return { bg: palette2.success[50], color: palette2.success[700] };
    case "pending":
    case "pending cancel":
      return { bg: palette2.warning[50], color: palette2.warning[700] };
    // Recently released (the Learning Center's 14-day badge) — informational, like in-progress.
    case "new":
      return { bg: palette2.info[50], color: palette2.info[700] };
    // An invoice still collecting charges for its billing period.
    case "open":
      return { bg: palette2.info[50], color: palette2.info[700] };
    case "failed":
    case "canceled":
      return { bg: palette2.error[50], color: palette2.error.main };
    default:
      return { bg: palette2.grey[100], color: palette2.grey[600] };
  }
}
var StatusChip = ({ status }) => {
  const style = statusStyle(status);
  return /* @__PURE__ */ jsx3(
    Chip,
    {
      label: status.replace(/_/g, " "),
      size: "small",
      sx: {
        height: 20,
        fontSize: 11,
        fontWeight: 600,
        textTransform: "capitalize",
        borderRadius: `${radius2.full}px`,
        backgroundColor: style.bg,
        color: style.color,
        border: "none",
        "& .MuiChip-label": { px: 1 }
      }
    }
  );
};
var HighlightedText = ({ text, query }) => {
  if (!text) return null;
  const mark = (content) => /* @__PURE__ */ jsx3(
    Box2,
    {
      component: "mark",
      sx: { bgcolor: alpha(palette2.warning.main, 0.3), color: "inherit", borderRadius: "2px" },
      children: content
    }
  );
  if ((query.kind === "phone" || query.kind === "numeric") && query.phoneDigits) {
    return extractDigits(text).includes(query.phoneDigits) ? mark(text) : /* @__PURE__ */ jsx3(Fragment, { children: text });
  }
  const needle = query.term.toLowerCase();
  const index = needle ? text.toLowerCase().indexOf(needle) : -1;
  if (index === -1) return /* @__PURE__ */ jsx3(Fragment, { children: text });
  return /* @__PURE__ */ jsxs2(Fragment, { children: [
    text.slice(0, index),
    mark(text.slice(index, index + needle.length)),
    text.slice(index + needle.length)
  ] });
};
var SearchResultCardShell = ({ item, onNavigate, children }) => {
  const relatedStrip = useContext2(RelatedStripContext);
  const relatedLinks = item.relatedLinks && item.relatedLinks.length > 0 ? /* @__PURE__ */ jsxs2(Box2, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap", px: 2, pb: 1.5, mt: -0.5 }, children: [
    /* @__PURE__ */ jsx3(Typography2, { sx: { fontSize: 11, color: "text.disabled" }, children: "Moves:" }),
    item.relatedLinks.map((link) => /* @__PURE__ */ jsx3(
      Chip,
      {
        label: link.label,
        size: "small",
        clickable: true,
        component: RouterLink,
        to: link.href,
        onClick: onNavigate,
        sx: {
          height: 22,
          fontSize: 12,
          fontFamily: typography.fontFamily.mono,
          fontWeight: 600,
          borderRadius: `${radius2.full}px`,
          bgcolor: palette2.grey[100],
          color: palette2.secondaryAccent.main,
          border: "none",
          "&:hover": { bgcolor: palette2.grey[200] },
          "& .MuiChip-label": { px: 1.25 }
        }
      },
      link.href
    ))
  ] }) : null;
  const body = item.href ? /* @__PURE__ */ jsx3(CardActionArea, { component: RouterLink, to: item.href, onClick: onNavigate, children }) : children;
  if (item.relatedTo) {
    return /* @__PURE__ */ jsxs2(Box2, { sx: { display: "flex", alignItems: "stretch" }, children: [
      /* @__PURE__ */ jsxs2(Box2, { sx: { width: 52, flexShrink: 0, position: "relative" }, "aria-hidden": true, children: [
        /* @__PURE__ */ jsx3(
          Box2,
          {
            sx: {
              position: "absolute",
              left: 37,
              top: 0,
              width: "2px",
              bgcolor: palette2.grey[200],
              ...item.relatedLast ? { height: "50%" } : { bottom: 0 }
            }
          }
        ),
        /* @__PURE__ */ jsx3(Box2, { sx: { position: "absolute", left: 37, top: "50%", width: 11, height: "2px", bgcolor: palette2.grey[200] } })
      ] }),
      /* @__PURE__ */ jsxs2(Box2, { sx: { flex: 1, minWidth: 0 }, children: [
        body,
        relatedLinks
      ] })
    ] });
  }
  if (item.relatedCount) {
    const hiddenCount = item.relatedCount - RELATED_VISIBLE_CAP;
    const expanded = relatedStrip?.expandedAnchors.has(item.key) ?? false;
    return /* @__PURE__ */ jsxs2(Box2, { sx: { position: "relative" }, children: [
      body,
      /* @__PURE__ */ jsx3(
        Box2,
        {
          "aria-hidden": true,
          sx: {
            position: "absolute",
            left: 37,
            top: "calc(50% + 26px)",
            bottom: 0,
            width: "2px",
            bgcolor: palette2.grey[200],
            pointerEvents: "none"
          }
        }
      ),
      relatedStrip && hiddenCount > 0 && /* @__PURE__ */ jsxs2(
        ButtonBase,
        {
          onClick: () => relatedStrip.onToggle(item.key),
          "aria-expanded": expanded,
          sx: {
            position: "absolute",
            top: "50%",
            right: 16,
            transform: "translateY(-50%)",
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
            height: 28,
            px: 1,
            borderRadius: 1,
            color: palette2.secondaryAccent.main,
            fontSize: 12,
            fontWeight: 600,
            whiteSpace: "nowrap",
            "&:hover": { bgcolor: "rgba(32,36,48,0.04)" }
          },
          children: [
            /* @__PURE__ */ jsx3(
              BiChevronDown,
              {
                size: 15,
                "aria-hidden": true,
                style: { transform: expanded ? "rotate(180deg)" : "none", transition: "transform 120ms ease" }
              }
            ),
            expanded ? "Hide" : `${hiddenCount} more`
          ]
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs2(Box2, { children: [
    body,
    relatedLinks
  ] });
};
var LEADING_SLOT_WIDTH = 44;
var SearchResultLeading = ({ item }) => {
  const size = LEADING_SLOT_WIDTH;
  const Icon = item.leadingIcon ? CHIP_ICONS[item.leadingIcon] : null;
  if (Icon) {
    return /* @__PURE__ */ jsx3(
      Box2,
      {
        "aria-hidden": true,
        sx: {
          width: size,
          height: size,
          flexShrink: 0,
          borderRadius: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "rgba(32,36,48,0.06)",
          color: palette2.grey[600]
        },
        children: /* @__PURE__ */ jsx3(Icon, { size: 20 })
      }
    );
  }
  return item.badge ? /* @__PURE__ */ jsx3(
    Box2,
    {
      sx: {
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(32,36,48,0.06)",
        color: palette2.grey[600],
        fontWeight: 700,
        fontFamily: typography.fontFamily.mono,
        fontSize: 12
      },
      children: item.badge
    }
  ) : /* @__PURE__ */ jsx3(Avatar, { src: item.avatar?.src ?? void 0, sx: { width: size, height: size, fontSize: 15 }, children: item.avatar?.initials });
};
var RankDebugLine = ({ item }) => item.score != null && item.scoreFactors ? /* @__PURE__ */ jsxs2(Typography2, { sx: { fontSize: 11, fontFamily: '"JetBrains Mono", monospace', color: "text.disabled", mt: 0.5 }, children: [
  "score ",
  item.score,
  " \xB7 match ",
  item.scoreFactors.matchScore,
  " \xB7 recency ",
  item.scoreFactors.recencyScore,
  " \xB7 prior",
  " ",
  item.scoreFactors.entityPriorScore
] }) : null;
var SearchResultCard = ({ item, query, onNavigate, showRankDebug = false }) => /* @__PURE__ */ jsx3(SearchResultCardShell, { item, onNavigate, children: /* @__PURE__ */ jsxs2(Box2, { sx: { display: "flex", alignItems: "center", gap: 2, p: 2, minWidth: 0 }, children: [
  /* @__PURE__ */ jsx3(SearchResultLeading, { item }),
  /* @__PURE__ */ jsxs2(Box2, { sx: { flex: 1, minWidth: 0 }, children: [
    /* @__PURE__ */ jsxs2(Box2, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }, children: [
      /* @__PURE__ */ jsx3(Typography2, { noWrap: true, sx: { fontSize: 15, fontWeight: 600 }, children: /* @__PURE__ */ jsx3(HighlightedText, { text: item.title, query }) }),
      item.status && /* @__PURE__ */ jsx3(StatusChip, { status: item.status }),
      item.titleChips?.map((chip) => /* @__PURE__ */ jsx3(ToneChip, { chip }, chip.label)),
      /* @__PURE__ */ jsx3(DispatchNotesChip_default, { item })
    ] }),
    item.primaryLine && /* @__PURE__ */ jsx3(Typography2, { noWrap: true, sx: { fontSize: 13, color: "text.secondary", mt: 0.25 }, children: /* @__PURE__ */ jsx3(HighlightedText, { text: item.primaryLine, query }) }),
    item.secondaryLine && /* @__PURE__ */ jsx3(Typography2, { noWrap: true, sx: { fontSize: 12, color: "text.disabled", mt: 0.25 }, children: item.secondaryLine }),
    item.contextLine && /* @__PURE__ */ jsxs2(Typography2, { noWrap: true, sx: { fontSize: 12, fontStyle: "italic", color: "text.secondary", mt: 0.25 }, children: [
      "\u201C",
      item.contextLine,
      "\u201D"
    ] }),
    (item.footChips && item.footChips.length > 0 || hasMatchChips(item, query)) && /* @__PURE__ */ jsxs2(Box2, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap", mt: 0.75 }, children: [
      /* @__PURE__ */ jsx3(MatchChips, { item, query }),
      item.footChips?.map((chip) => /* @__PURE__ */ jsx3(ToneChip, { chip }, chip.label))
    ] }),
    showRankDebug && /* @__PURE__ */ jsx3(RankDebugLine, { item })
  ] }),
  item.stat && /* @__PURE__ */ jsx3(Typography2, { sx: { fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", color: "text.secondary" }, children: item.stat })
] }) });
var SearchResultCard_default = SearchResultCard;

// src/components/CustomerSearchCard.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var { palette: palette3, radius: radius3 } = allTokens3;
var STATUS_STYLES = {
  live: { bg: palette3.success[50], color: palette3.success.main },
  onboarding: { bg: "#fff9f3", color: "#a6681f" },
  deactivated: { bg: palette3.error[50], color: palette3.error.main }
};
var STATUS_FALLBACK = { bg: palette3.grey[100], color: palette3.grey[600] };
var CustomerSearchCard = ({ item, query, onNavigate, showRankDebug }) => {
  const payload = item.payload;
  if (!payload) {
    return /* @__PURE__ */ jsx4(SearchResultCard_default, { item, query, onNavigate, showRankDebug });
  }
  const status = payload.status?.toLowerCase();
  const statusStyle2 = status && STATUS_STYLES[status] || STATUS_FALLBACK;
  return /* @__PURE__ */ jsx4(SearchResultCardShell, { item, onNavigate, children: /* @__PURE__ */ jsxs3(Box3, { sx: { display: "flex", alignItems: "center", gap: 2, p: 2, minWidth: 0 }, children: [
    /* @__PURE__ */ jsx4(
      Box3,
      {
        sx: {
          width: LEADING_SLOT_WIDTH,
          height: LEADING_SLOT_WIDTH,
          flexShrink: 0,
          borderRadius: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "rgba(32,36,48,0.06)",
          color: palette3.grey[600]
        },
        children: /* @__PURE__ */ jsx4(BiStore2, { size: 22 })
      }
    ),
    /* @__PURE__ */ jsxs3(Box3, { sx: { flex: 1, minWidth: 0 }, children: [
      /* @__PURE__ */ jsxs3(Box3, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }, children: [
        /* @__PURE__ */ jsx4(Typography3, { noWrap: true, sx: { fontSize: 15, fontWeight: 600 }, children: /* @__PURE__ */ jsx4(HighlightedText, { text: item.title, query }) }),
        status && /* @__PURE__ */ jsx4(
          Chip2,
          {
            label: status,
            size: "small",
            sx: {
              height: 20,
              fontSize: 11,
              fontWeight: 600,
              textTransform: "capitalize",
              borderRadius: `${radius3.full}px`,
              backgroundColor: statusStyle2.bg,
              color: statusStyle2.color,
              border: "none",
              "& .MuiChip-label": { px: 1 }
            }
          }
        ),
        item.titleChips?.map((chip) => /* @__PURE__ */ jsx4(ToneChip, { chip }, chip.label))
      ] }),
      payload.organizationName && /* @__PURE__ */ jsxs3(Box3, { sx: { display: "flex", alignItems: "center", gap: 0.5, mt: 0.25 }, children: [
        /* @__PURE__ */ jsx4(BiBuildings, { size: 13, color: palette3.grey[400], style: { flexShrink: 0 } }),
        /* @__PURE__ */ jsx4(Typography3, { noWrap: true, sx: { fontSize: 12, color: "text.secondary" }, children: /* @__PURE__ */ jsx4(HighlightedText, { text: payload.organizationName, query }) })
      ] }),
      item.primaryLine && /* @__PURE__ */ jsx4(Typography3, { noWrap: true, sx: { fontSize: 13, color: "text.secondary", mt: 0.25 }, children: /* @__PURE__ */ jsx4(HighlightedText, { text: item.primaryLine, query }) }),
      item.secondaryLine && /* @__PURE__ */ jsx4(Typography3, { noWrap: true, sx: { fontSize: 12, color: "text.disabled", mt: 0.25 }, children: /* @__PURE__ */ jsx4(HighlightedText, { text: item.secondaryLine, query }) }),
      showRankDebug && /* @__PURE__ */ jsx4(RankDebugLine, { item })
    ] })
  ] }) });
};
var CustomerSearchCard_default = CustomerSearchCard;

// src/utils/format.ts
function initialsOf(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  const first = parts[0][0] ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] ?? "" : "";
  return `${first}${last}`.toUpperCase() || "?";
}
function titleCase(value) {
  if (!value) return "";
  return value.replace(/[_-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
function formatPhone(value) {
  if (!value) return "";
  const d = normalizePhoneDigits(extractDigits(value));
  if (d.length !== 10) return value;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
function formatDateTime(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString(void 0, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}
function tierChip(tier) {
  switch (tier) {
    case "lite":
      return { label: "SaaS", tone: "saas" };
    case "standard":
      return { label: "Full Service", tone: "fullservice" };
    case "hybrid":
      return { label: "Hybrid", tone: "hybrid" };
    default:
      return null;
  }
}
function metaLine(...parts) {
  return parts.filter(Boolean).join("  \xB7  ");
}

// src/utils/searchFilters.ts
import { useCallback, useMemo as useMemo2 } from "react";
import { useSearchParams } from "react-router-dom";
var MOVE_STATUS_FILTER_OPTIONS = [
  { key: "not_started", label: "Not started" },
  { key: "in_progress", label: "In progress" },
  { key: "delivered", label: "Delivered" },
  { key: "canceled", label: "Canceled" }
];
var DATE_WINDOW_FILTER_OPTIONS = [
  // Calendar-aligned, matching the move dashboards' vocabulary and order.
  { key: "tomorrow", label: "Tomorrow", group: "calendar" },
  { key: "today", label: "Today", group: "calendar" },
  { key: "yesterday", label: "Yesterday", group: "calendar" },
  { key: "nextweek", label: "Next Week", group: "calendar" },
  { key: "thisweek", label: "This Week", group: "calendar" },
  { key: "lastweek", label: "Last Week", group: "calendar" },
  { key: "nextmonth", label: "Next Month", group: "calendar" },
  { key: "thismonth", label: "This Month", group: "calendar" },
  { key: "lastmonth", label: "Last Month", group: "calendar" },
  // Rolling, anchored on now — kept for the backward-looking entities.
  { key: "24h", label: "Last 24 hours", group: "rolling", hours: 24 },
  { key: "3d", label: "Last 3 days", group: "rolling", hours: 3 * 24 },
  { key: "7d", label: "Last 7 days", group: "rolling", hours: 7 * 24 },
  { key: "30d", label: "Last 30 days", group: "rolling", hours: 30 * 24 },
  { key: "90d", label: "Last 90 days", group: "rolling", hours: 90 * 24 }
];
var VEHICLE_COLOR_FILTER_OPTIONS = [
  { key: "black", label: "Black", matches: ["black", "blk"] },
  { key: "white", label: "White", matches: ["white", "wht"] },
  { key: "gray", label: "Gray", matches: ["gray", "grey", "charcoal", "graphite"] },
  { key: "silver", label: "Silver", matches: ["silver", "sliver"] },
  { key: "blue", label: "Blue", matches: ["blue", "navy"] },
  { key: "red", label: "Red", matches: ["red"] },
  { key: "green", label: "Green", matches: ["green"] },
  { key: "brown", label: "Brown", matches: ["brown"] },
  { key: "beige", label: "Beige / Tan", matches: ["beige", "tan", "cream", "khaki"] },
  { key: "gold", label: "Gold", matches: ["gold"] },
  { key: "orange", label: "Orange", matches: ["orange"] },
  { key: "yellow", label: "Yellow", matches: ["yellow"] },
  { key: "purple", label: "Purple", matches: ["purple"] },
  { key: "maroon", label: "Maroon", matches: ["maroon", "burgundy"] }
];
var startOfDay = (now, plusDays = 0) => new Date(now.getFullYear(), now.getMonth(), now.getDate() + plusDays);
var startOfWeek = (now, plusWeeks = 0) => new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + plusWeeks * 7);
var startOfMonth = (now, plusMonths = 0) => new Date(now.getFullYear(), now.getMonth() + plusMonths, 1);
function windowBoundsIso(key, now = /* @__PURE__ */ new Date()) {
  const span = (from, to) => ({ start: from.toISOString(), end: to.toISOString() });
  switch (key) {
    case "tomorrow":
      return span(startOfDay(now, 1), startOfDay(now, 2));
    case "today":
      return span(startOfDay(now), startOfDay(now, 1));
    case "yesterday":
      return span(startOfDay(now, -1), startOfDay(now));
    case "nextweek":
      return span(startOfWeek(now, 1), startOfWeek(now, 2));
    case "thisweek":
      return span(startOfWeek(now), startOfWeek(now, 1));
    case "lastweek":
      return span(startOfWeek(now, -1), startOfWeek(now));
    case "nextmonth":
      return span(startOfMonth(now, 1), startOfMonth(now, 2));
    case "thismonth":
      return span(startOfMonth(now), startOfMonth(now, 1));
    case "lastmonth":
      return span(startOfMonth(now, -1), startOfMonth(now));
    default: {
      const hours = DATE_WINDOW_FILTER_OPTIONS.find((option) => option.key === key)?.hours ?? 0;
      return { start: new Date(now.getTime() - hours * 60 * 60 * 1e3).toISOString() };
    }
  }
}
var DATE_SHAPE = /^\d{4}-\d{2}-\d{2}$/;
function localMidnight(isoDate, plusDays = 0) {
  const [year, month, day] = isoDate.split("-").map(Number);
  return new Date(year, month - 1, day + plusDays);
}
function validIsoDate(value) {
  if (!value || !DATE_SHAPE.test(value)) return void 0;
  const [year, month, day] = value.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? value : void 0;
}
function dateBoundsIso(filters, now = /* @__PURE__ */ new Date()) {
  if (filters.from || filters.to) {
    return {
      ...filters.from ? { start: localMidnight(filters.from).toISOString() } : {},
      ...filters.to ? { end: localMidnight(filters.to, 1).toISOString() } : {}
    };
  }
  if (filters.window) return windowBoundsIso(filters.window, now);
  return {};
}
function recencyAnchorDate(filters, now = /* @__PURE__ */ new Date()) {
  const end = dateBoundsIso(filters, now).end;
  if (!end) return now;
  const anchor = new Date(end);
  return anchor < now ? anchor : now;
}
function dateRangeLabel(filters, now = /* @__PURE__ */ new Date()) {
  if (!filters.from && !filters.to) return void 0;
  const format = (isoDate) => {
    const date = localMidnight(isoDate);
    return date.toLocaleDateString(void 0, {
      month: "short",
      day: "numeric",
      ...date.getFullYear() === now.getFullYear() ? {} : { year: "numeric" }
    });
  };
  if (filters.from && filters.to) return `${format(filters.from)} \u2013 ${format(filters.to)}`;
  return filters.from ? `From ${format(filters.from)}` : `Through ${format(filters.to)}`;
}
function moveStatusClause(key) {
  switch (key) {
    case "not_started":
      return { _and: [{ status: { _is_null: true } }, { cancel_status: { _is_null: true } }] };
    case "in_progress":
      return {
        _and: [
          { cancel_status: { _is_null: true } },
          { status: { _in: ["dispatched", "pickup started", "pickup successful", "delivery started"] } }
        ]
      };
    case "delivered":
      return {
        _and: [{ cancel_status: { _is_null: true } }, { status: { _in: ["delivery successful", "completed"] } }]
      };
    case "canceled":
      return { cancel_status: { _is_null: false } };
  }
}
var STATUS_KEYS = new Set(MOVE_STATUS_FILTER_OPTIONS.map((option) => option.key));
var WINDOW_KEYS = new Set(DATE_WINDOW_FILTER_OPTIONS.map((option) => option.key));
var COLOR_KEYS = new Set(VEHICLE_COLOR_FILTER_OPTIONS.map((option) => option.key));
var MAX_TEXT_FILTER_LENGTH = 60;
function validTextFilter(value) {
  const trimmed = value?.trim();
  return trimmed && trimmed.length <= MAX_TEXT_FILTER_LENGTH ? trimmed : void 0;
}
var FILTER_DIMENSIONS = [
  {
    key: "status",
    label: "Status",
    group: "Move",
    // On demand, like the vehicle dimensions: most searches never touch it
    // (the design measurements had five of six controls empty), so it joins
    // the Add-filter catalog instead of holding permanent shelf width.
    pinned: false,
    support: "status",
    params: ["status"],
    isActive: (filters) => filters.status != null,
    parse: (params) => {
      const status = params.get("status");
      return status && STATUS_KEYS.has(status) ? { status } : {};
    },
    chipLabel: (filters) => filters.status ? `Status: ${MOVE_STATUS_FILTER_OPTIONS.find((o) => o.key === filters.status)?.label ?? filters.status}` : void 0,
    clearPatch: { status: void 0 },
    applyToken: (value) => ({ status: value })
  },
  {
    key: "date",
    label: "Date",
    group: "Date",
    pinned: true,
    support: "window",
    params: ["window", "from", "to"],
    isActive: (filters) => filters.window != null || filters.from != null || filters.to != null,
    parse: (params) => {
      const window2 = params.get("window");
      let from = validIsoDate(params.get("from"));
      let to = validIsoDate(params.get("to"));
      if (from && to && from > to) [from, to] = [to, from];
      const hasRange = from != null || to != null;
      return {
        // One date dimension: a valid custom range wins over a preset window.
        ...!hasRange && window2 && WINDOW_KEYS.has(window2) ? { window: window2 } : {},
        ...from ? { from } : {},
        ...to ? { to } : {}
      };
    },
    chipLabel: (filters) => {
      if (filters.window) {
        return `Date: ${DATE_WINDOW_FILTER_OPTIONS.find((o) => o.key === filters.window)?.label ?? filters.window}`;
      }
      const range = dateRangeLabel(filters);
      return range ? `Date: ${range}` : void 0;
    },
    clearPatch: { window: void 0, from: void 0, to: void 0 },
    applyToken: (value) => ({ window: value, from: void 0, to: void 0 })
  },
  {
    key: "customer",
    label: "Rooftop",
    group: "Scope",
    pinned: true,
    support: "customer",
    params: ["customer"],
    tokenPrefix: "rooftop",
    isActive: (filters) => filters.customerId != null,
    parse: (params) => {
      const customer = Number(params.get("customer"));
      return Number.isInteger(customer) && customer > 0 ? { customerId: customer } : {};
    },
    // The catalog can't know rooftop names — the page resolves the id against
    // its scope options and passes the name through context.
    chipLabel: (filters, context) => filters.customerId != null ? `Rooftop: ${context?.customerName ?? String(filters.customerId)}` : void 0,
    clearPatch: { customerId: void 0 },
    applyToken: (value) => ({ customerId: Number(value) })
  },
  {
    key: "make",
    label: "Make",
    group: "Vehicle",
    pinned: false,
    support: "vehicle",
    params: ["make"],
    isActive: (filters) => filters.make != null,
    parse: (params) => {
      const make = validTextFilter(params.get("make"));
      return make ? { make } : {};
    },
    chipLabel: (filters) => filters.make ? `Make: ${filters.make}` : void 0,
    clearPatch: { make: void 0 },
    applyToken: (value) => ({ make: value })
  },
  {
    key: "model",
    label: "Model",
    group: "Vehicle",
    pinned: false,
    support: "vehicle",
    params: ["model"],
    isActive: (filters) => filters.model != null,
    parse: (params) => {
      const model = validTextFilter(params.get("model"));
      return model ? { model } : {};
    },
    chipLabel: (filters) => filters.model ? `Model: ${filters.model}` : void 0,
    clearPatch: { model: void 0 },
    applyToken: (value) => ({ model: value })
  },
  {
    key: "color",
    label: "Color",
    group: "Vehicle",
    pinned: false,
    support: "vehicle",
    params: ["color"],
    isActive: (filters) => filters.color != null,
    parse: (params) => {
      const color = params.get("color")?.toLowerCase();
      return color && COLOR_KEYS.has(color) ? { color } : {};
    },
    chipLabel: (filters) => filters.color ? `Color: ${VEHICLE_COLOR_FILTER_OPTIONS.find((o) => o.key === filters.color)?.label ?? filters.color}` : void 0,
    clearPatch: { color: void 0 },
    applyToken: (value) => ({ color: value })
  }
];
function parseSearchFilters(params) {
  return FILTER_DIMENSIONS.reduce(
    (filters, dimension) => Object.assign(filters, dimension.parse(params)),
    {}
  );
}
function filtersKey(filters) {
  return [
    filters.status,
    filters.window,
    filters.from,
    filters.to,
    filters.customerId,
    filters.make,
    filters.model,
    filters.color
  ].map((value) => value ?? "").join("|");
}
function useSearchFilterParams() {
  const [params, setParams] = useSearchParams();
  const filters = useMemo2(() => parseSearchFilters(params), [params]);
  const patch = useCallback(
    (next) => {
      setParams((prev) => {
        const merged = new URLSearchParams(prev);
        for (const [key, value] of Object.entries(next)) {
          const param = key === "customerId" ? "customer" : key;
          if (value == null) merged.delete(param);
          else merged.set(param, String(value));
        }
        return merged;
      });
    },
    [setParams]
  );
  const clearAll = useCallback(() => {
    setParams((prev) => {
      const merged = new URLSearchParams(prev);
      for (const dimension of FILTER_DIMENSIONS) {
        for (const param of dimension.params) merged.delete(param);
      }
      return merged;
    });
  }, [setParams]);
  return [filters, patch, clearAll];
}
var DEFAULT_FILTER_SUPPORT = { status: false, window: false };
function unfilteredHintFor(filters, support) {
  const applied = support ?? DEFAULT_FILTER_SUPPORT;
  const APPLIES_BY_DEFAULT = {
    status: false,
    window: false,
    customer: true,
    vehicle: false
  };
  const HINT_NAME = {
    status: "status",
    window: "date",
    customer: "rooftop",
    vehicle: "vehicle"
  };
  const ignored = [
    ...new Set(
      FILTER_DIMENSIONS.filter(
        (dimension) => dimension.isActive(filters) && !(applied[dimension.support] ?? APPLIES_BY_DEFAULT[dimension.support])
      ).map((dimension) => HINT_NAME[dimension.support])
    )
  ];
  if (!ignored.length) return void 0;
  return ignored.length > 1 ? `${ignored.slice(0, -1).join(", ")} & ${ignored[ignored.length - 1]} filters don\u2019t apply` : `${ignored[0]} filter doesn\u2019t apply`;
}
function sanitizeCustomerFilter(filters, validIds) {
  if (filters.customerId == null || !validIds?.length || validIds.includes(filters.customerId)) return filters;
  const { customerId: _dropped, ...rest } = filters;
  return rest;
}

// src/utils/whereClauses.ts
var MAX_ID_DIGITS = 12;
function withScope(base, scope) {
  if (!base || !scope) return base;
  return { _and: [scope, base] };
}
var OWN_VEHICLE_COLUMNS = {
  make: "vehicle_make",
  model: "vehicle_model",
  color: "vehicle_color"
};
var RUN_VEHICLE_COLUMNS = { make: "make", model: "model", color: "color" };
function vehicleFilterClauses(filters, columns = OWN_VEHICLE_COLUMNS) {
  if (!filters) return [];
  const and = [];
  if (filters.make) and.push({ [columns.make]: { _ilike: `%${escapeLikePattern(filters.make)}%` } });
  if (filters.model) and.push({ [columns.model]: { _ilike: `${escapeLikePattern(filters.model)}%` } });
  const group = filters.color ? VEHICLE_COLOR_FILTER_OPTIONS.find((option) => option.key === filters.color) : void 0;
  if (group) and.push({ _or: group.matches.map((spelling) => ({ [columns.color]: { _ilike: `%${spelling}%` } })) });
  return and;
}
function withDriverVehicle(base, filters) {
  if (!base) return base;
  const clauses = vehicleFilterClauses(filters);
  return clauses.length ? { _and: [...clauses, base] } : base;
}
function withMoveFilters(base, filters) {
  if (!base || !filters) return base;
  const and = [];
  if (filters.status) and.push(moveStatusClause(filters.status));
  const dates = dateBoundsIso(filters);
  if (dates.start || dates.end) {
    const within = (column) => ({
      [column]: {
        ...dates.start ? { _gte: dates.start } : {},
        ...dates.end ? { _lt: dates.end } : {}
      }
    });
    and.push({ _or: [within("pickup_time"), within("ready_by")] });
  }
  and.push(...vehicleFilterClauses(filters));
  return and.length ? { _and: [...and, base] } : base;
}
function phoneDigitsProbe(query) {
  return query.phoneDigits.length >= MIN_TRGM_LENGTH ? `%${query.phoneDigits}%` : null;
}
function meetsTrgmLength(query) {
  return query.term.length >= MIN_TRGM_LENGTH;
}
function usersMatch(query) {
  const or = [];
  let probe;
  switch (query.kind) {
    case "email":
      or.push({ email: { _ilike: query.like } });
      break;
    case "phone":
    case "numeric":
      probe = phoneDigitsProbe(query);
      if (probe) or.push({ phone_digits: { _ilike: probe } });
      break;
    case "text":
      or.push({ display_name: { _ilike: query.like } });
      or.push({ email: { _ilike: query.like } });
      break;
    default:
      return null;
  }
  return or.length ? { _or: or } : null;
}
function guestMovesMatch(query) {
  const or = [];
  switch (query.kind) {
    case "phone":
    case "numeric": {
      const probe = phoneDigitsProbe(query);
      if (probe) or.push({ consumer_phone_digits: { _ilike: probe } });
      break;
    }
    case "text":
      if (meetsTrgmLength(query)) or.push({ consumer_name: { _ilike: query.like } });
      break;
    default:
      return null;
  }
  return or.length ? { _and: [{ consumer_name: { _is_null: false } }, { _or: or }] } : null;
}
function contactsMatch(query) {
  const or = [];
  switch (query.kind) {
    case "email":
      or.push({ email: { _ilike: query.like } });
      break;
    case "phone":
    case "numeric": {
      const probe = phoneDigitsProbe(query);
      if (probe) or.push({ mobile_number_digits: { _ilike: probe } });
      break;
    }
    case "text":
      or.push({ name: { _ilike: query.like } });
      break;
    default:
      return null;
  }
  return or.length ? { _or: or } : null;
}
function movesIndexedMatch(query) {
  const or = [];
  if (query.kind === "numeric" && query.term.length <= MAX_ID_DIGITS) {
    or.push({ id: { _eq: Number(query.term) } });
  }
  if (query.kind !== "email" && meetsTrgmLength(query)) {
    or.push({ search_text: { _ilike: query.like } });
  }
  return or.length ? { _or: or } : null;
}
function movesSubplanMatch(query) {
  const or = [];
  if (query.kind === "vin") {
    or.push({ pickup_workflow_data: { _cast: { String: { _ilike: query.like } } } });
  }
  const contacts = contactsMatch(query);
  if (contacts) or.push({ contactstomoves: { contact: contacts } });
  return or.length ? { _or: or } : null;
}
function scenarioIdOf(query) {
  return query.kind === "numeric" && query.term.length <= MAX_ID_DIGITS ? Number(query.term) : null;
}
function movesScenarioMatch(query) {
  const scenarioId = scenarioIdOf(query);
  return scenarioId == null ? null : { scenariotomoves: { scenario_id: { _eq: scenarioId } } };
}
function guestScenarioMovesMatch(query) {
  const scenario = movesScenarioMatch(query);
  return scenario ? { _and: [{ consumer_name: { _is_null: false } }, scenario] } : null;
}
function invoicesMatch(query) {
  if (query.kind !== "numeric" || query.term.length > MAX_ID_DIGITS) return null;
  return { id: { _eq: Number(query.term) } };
}
function learningModulesMatch(query) {
  if (query.kind !== "text") return null;
  return { status: { _in: ["published", "archived"] } };
}
function customersMatch(query) {
  const or = [];
  switch (query.kind) {
    case "email":
      or.push({ email: { _ilike: query.like } });
      break;
    case "phone":
    case "numeric": {
      const probe = phoneDigitsProbe(query);
      if (probe) or.push({ phone_digits: { _ilike: probe } });
      break;
    }
    case "text":
      or.push({ name: { _ilike: query.like } });
      or.push({ organization: { name: { _ilike: query.like } } });
      break;
    default:
      return null;
  }
  return or.length ? { _or: or } : null;
}
function driversMatch(query) {
  const or = [];
  switch (query.kind) {
    case "email":
      or.push({ user: { email: { _ilike: query.like } } });
      break;
    case "phone":
    case "numeric": {
      const probe = phoneDigitsProbe(query);
      if (probe) or.push({ user: { phone_digits: { _ilike: probe } } });
      break;
    }
    case "text":
      or.push({ user: { display_name: { _ilike: query.like } } });
      or.push({ user: { email: { _ilike: query.like } } });
      break;
    case "vin":
      or.push({ vehicle_vin: { _ilike: query.like } });
      break;
    default:
      return null;
  }
  return or.length ? { _or: or } : null;
}
function locationsMatch(query, { customerRef = false } = {}) {
  const or = [];
  switch (query.kind) {
    case "email":
      or.push({ email: { _ilike: query.like } });
      break;
    case "phone":
      query.phonePatterns.forEach((pattern) => or.push({ phone: { _ilike: pattern } }));
      or.push({ zip_code: { _ilike: query.like } });
      or.push({ address: { _ilike: query.like } });
      break;
    case "numeric":
      if (query.term.length <= MAX_ID_DIGITS) {
        or.push({ id: { _eq: Number(query.term) } });
      }
      or.push({ zip_code: { _ilike: query.like } });
      or.push({ address: { _ilike: query.like } });
      query.phonePatterns.forEach((pattern) => or.push({ phone: { _ilike: pattern } }));
      break;
    case "text":
      or.push({ name: { _ilike: query.like } });
      or.push({ nickname: { _ilike: query.like } });
      or.push({ address: { _ilike: query.like } });
      or.push({ city: { _ilike: query.like } });
      if (customerRef) or.push({ customer_ref: { _ilike: query.like } });
      break;
    default:
      return null;
  }
  return or.length ? { _or: or } : null;
}
function mobilityMatch(query) {
  const or = [];
  const stopPhones = (pattern) => {
    or.push({ stops: { delivery_stop_detail: { recipient_phone: { _ilike: pattern } } } });
    or.push({ stops: { service_stop_detail: { customer_phone: { _ilike: pattern } } } });
  };
  switch (query.kind) {
    case "numeric":
      if (query.term.length <= MAX_ID_DIGITS) {
        or.push({ id: { _eq: Number(query.term) } });
        or.push({ scenario_id: { _eq: Number(query.term) } });
      }
      or.push({ stops: { service_stop_detail: { ro_reference: { _ilike: query.like } } } });
      or.push({ stops: { address: { _ilike: query.like } } });
      query.phonePatterns.forEach(stopPhones);
      break;
    case "phone":
      query.phonePatterns.forEach(stopPhones);
      or.push({ stops: { service_stop_detail: { ro_reference: { _ilike: query.like } } } });
      or.push({ stops: { address: { _ilike: query.like } } });
      break;
    case "text":
      or.push({ name: { _ilike: query.like } });
      or.push({ stops: { address: { _ilike: query.like } } });
      or.push({
        stops: {
          delivery_stop_detail: {
            _or: [{ recipient_name: { _ilike: query.like } }, { recipient_business: { _ilike: query.like } }]
          }
        }
      });
      or.push({
        stops: {
          service_stop_detail: {
            _or: [
              { customer_name: { _ilike: query.like } },
              { service_description: { _ilike: query.like } },
              { ro_reference: { _ilike: query.like } }
            ]
          }
        }
      });
      break;
    default:
      return null;
  }
  return or.length ? { _or: or } : null;
}
function withRunWindow(base, filters, leading = []) {
  if (!base) return base;
  const dates = dateBoundsIso(filters ?? {});
  const vehicle = vehicleFilterClauses(filters, RUN_VEHICLE_COLUMNS);
  const clauses = [
    // `leading` stays ahead of the date bounds: dealer ANDs its product-access
    // gate first, and both portals' tests assert on _and[0].
    ...leading,
    ...dates.start ? [{ departure_time: { _gte: dates.start } }] : [],
    ...dates.end ? [{ departure_time: { _lt: dates.end } }] : [],
    ...vehicle.length ? [{ vehicle: { _and: vehicle } }] : []
  ];
  return clauses.length ? { _and: [...clauses, base] } : base;
}

// src/utils/whereBuilders.ts
var customerScope = (filters) => filters?.customerId != null ? { customer_id: { _eq: filters.customerId } } : null;
function buildUsersWhere(query, filters) {
  return withScope(usersMatch(query), customerScope(filters));
}
function buildGuestMovesWhere(query, filters) {
  return withScope(withMoveFilters(guestMovesMatch(query), filters), customerScope(filters));
}
function buildMovesIndexedWhere(query, filters) {
  return withScope(withMoveFilters(movesIndexedMatch(query), filters), customerScope(filters));
}
function buildMovesSubplanWhere(query, filters) {
  return withScope(withMoveFilters(movesSubplanMatch(query), filters), customerScope(filters));
}
function buildMovesScenarioWhere(query, filters) {
  return withScope(withMoveFilters(movesScenarioMatch(query), filters), customerScope(filters));
}
function buildGuestScenarioMovesWhere(query, filters) {
  return withScope(
    withMoveFilters(guestScenarioMovesMatch(query), filters),
    customerScope(filters)
  );
}
function buildCustomersWhere(query, filters) {
  return withScope(
    customersMatch(query),
    filters?.customerId != null ? { id: { _eq: filters.customerId } } : null
  );
}
function buildDriversWhere(query, filters) {
  return withScope(
    withDriverVehicle(driversMatch(query), filters),
    filters?.customerId != null ? { user: { customer_id: { _eq: filters.customerId } } } : null
  );
}
function buildLocationsWhere(query, filters, { customerRef = false } = {}) {
  return withScope(
    locationsMatch(query, { customerRef }),
    customerScope(filters)
  );
}
function buildLearningModulesWhere(query) {
  return learningModulesMatch(query);
}
function buildLanesWhere(filters) {
  return filters?.customerId != null ? { customer_id: { _eq: filters.customerId } } : {};
}
function buildMobilityWhere(query, filters, products) {
  if (products && products.length === 0) return null;
  return withScope(
    withRunWindow(
      mobilityMatch(query),
      filters,
      products ? [{ product_type: { _in: [...products] } }] : []
    ),
    customerScope(filters)
  );
}
function buildInvoicesWhere(query, filters) {
  return withScope(invoicesMatch(query), customerScope(filters));
}

// src/entities/customers.tsx
function toItem(customer) {
  const titleChips = [{ label: "Customer", tone: "identity", icon: "store" }];
  const tier = tierChip(customer.tier);
  if (tier) titleChips.push(tier);
  if (!customer.active) titleChips.push({ label: "Inactive", tone: "neutral" });
  return {
    key: `customers-${customer.id}`,
    entityKey: "customers",
    payload: {
      status: customer.status ?? null,
      organizationName: customer.organization?.name ?? null
    },
    recency: customer.updatedat ?? null,
    customerId: customer.id,
    href: `/customers/${customer.id}`,
    title: customer.name ?? `Customer #${customer.id}`,
    titleChips,
    avatar: { initials: initialsOf(customer.name) },
    primaryLine: customer.address ?? "",
    secondaryLine: metaLine(formatPhone(customer.phone), customer.email)
  };
}
function useSearch(query, { limit, skip, offset = 0, withTotal = false, filters }) {
  const { options } = useGlobalSearchConfig();
  const useEnabled = options.customers?.useEnabled ?? useAlwaysEnabled;
  const enabled = useEnabled();
  const where = useMemo3(() => buildCustomersWhere(query, filters), [query, filters]);
  const skipped = skip || !enabled || !where;
  const canCount = useCanCount("customers");
  const { data, loading, error: queryError } = useSearchCustomersQuery({
    variables: pageVariables(where, { limit, offset, withTotal: withTotal && canCount }),
    skip: skipped,
    errorPolicy: "all"
  });
  const error = useCountFallback("customers", { error: queryError, loading });
  return useEntityResult(
    { rows: data?.customers, total: data?.customers_aggregate?.aggregate?.count, skipped, limit, loading, error },
    toItem
  );
}
var PRIORITY = { email: 70, phone: 50, text: 70, numeric: 20 };
var customersEntity = {
  key: "customers",
  label: "Customers",
  searchHint: "Rooftop name, organization, phone number, email address",
  priorityFor: (kind) => PRIORITY[kind] ?? 0,
  filterSupport: { status: false, window: false },
  useSearch,
  // #991: entity-owned renderer, composed from the shared shell.
  Card: CustomerSearchCard_default,
  cardRequiresPayload: true
};

// src/entities/drivers.tsx
import { useCallback as useCallback2, useMemo as useMemo4 } from "react";

// src/gql/searchDrivers.query.generated.ts
import { gql as gql2 } from "@apollo/client";
import * as Apollo2 from "@apollo/client";
import { resolveExecutor as resolveExecutor2 } from "@hopdrive/sdk-core";
var defaultOptions2 = {};
var SearchDriversDocument = gql2`
    query searchDrivers($where: drivers_bool_exp!, $limit: Int!, $offset: Int!, $withCount: Boolean!) {
  drivers(
    where: $where
    limit: $limit
    offset: $offset
    order_by: {user: {display_name: asc}}
  ) {
    id
    updated_at
    status
    tax_class
    vehicle_year
    vehicle_make
    vehicle_model
    vehicle_vin
    region {
      id
      name
    }
    user {
      id
      customer_id
      display_name
      email
      phone
      avatar_url
      active
    }
  }
  drivers_aggregate(where: $where) @include(if: $withCount) {
    aggregate {
      count
    }
  }
}
    `;
function useSearchDriversQuery(baseOptions) {
  const options = { ...defaultOptions2, ...baseOptions };
  return Apollo2.useQuery(SearchDriversDocument, options);
}

// src/components/DriverSearchCard.tsx
import { Box as Box4, Typography as Typography4 } from "@mui/material";
import { allTokens as allTokens4 } from "@hopdrive/ui/tokens";
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var { palette: palette4 } = allTokens4;
var DOT_COLORS = {
  online: "#30b448",
  offline: "#9e9e9e",
  training: "#ff9800"
};
var DriverSearchCard = ({ item, query, onNavigate, showRankDebug }) => {
  const payload = item.payload;
  if (!payload) {
    return /* @__PURE__ */ jsx5(SearchResultCard_default, { item, query, onNavigate, showRankDebug });
  }
  const dotColor = payload.status ? DOT_COLORS[payload.status.toLowerCase()] : void 0;
  return /* @__PURE__ */ jsx5(SearchResultCardShell, { item, onNavigate, children: /* @__PURE__ */ jsxs4(Box4, { sx: { display: "flex", alignItems: "center", gap: 2, p: 2, minWidth: 0 }, children: [
    /* @__PURE__ */ jsxs4(Box4, { sx: { position: "relative", flexShrink: 0 }, children: [
      /* @__PURE__ */ jsx5(SearchResultLeading, { item }),
      dotColor && /* @__PURE__ */ jsx5(
        Box4,
        {
          sx: {
            position: "absolute",
            bottom: 0,
            right: 0,
            width: 14,
            height: 14,
            borderRadius: "50%",
            bgcolor: dotColor,
            border: "3px solid #fff"
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsxs4(Box4, { sx: { flex: 1, minWidth: 0 }, children: [
      /* @__PURE__ */ jsxs4(Box4, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }, children: [
        /* @__PURE__ */ jsx5(Typography4, { noWrap: true, sx: { fontSize: 15, fontWeight: 600 }, children: /* @__PURE__ */ jsx5(HighlightedText, { text: item.title, query }) }),
        item.status && /* @__PURE__ */ jsx5(StatusChip, { status: item.status }),
        item.titleChips?.map((chip) => /* @__PURE__ */ jsx5(ToneChip, { chip }, chip.label))
      ] }),
      item.primaryLine && /* @__PURE__ */ jsx5(Typography4, { noWrap: true, sx: { fontSize: 13, color: "text.secondary", mt: 0.25 }, children: /* @__PURE__ */ jsx5(HighlightedText, { text: item.primaryLine, query }) }),
      item.secondaryLine && /* @__PURE__ */ jsx5(Typography4, { noWrap: true, sx: { fontSize: 12, color: "text.disabled", mt: 0.25 }, children: item.secondaryLine }),
      item.footChips && item.footChips.length > 0 && /* @__PURE__ */ jsx5(Box4, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap", mt: 0.75 }, children: item.footChips.map((chip) => /* @__PURE__ */ jsx5(ToneChip, { chip }, chip.label)) }),
      showRankDebug && /* @__PURE__ */ jsx5(RankDebugLine, { item })
    ] }),
    item.stat && /* @__PURE__ */ jsx5(Typography4, { sx: { fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", color: "text.secondary" }, children: item.stat })
  ] }) });
};
var DriverSearchCard_default = DriverSearchCard;

// src/items/drivers.ts
function driverToItem(driver, { taxClass = false, region = false } = {}) {
  const titleChips = [
    taxClass ? { label: driver.tax_class === "W-2" ? "W-2 Driver" : "Gig Driver", tone: "driver", icon: "driver" } : { label: "Driver", tone: "driver", icon: "driver" }
  ];
  if (driver.user && !driver.user.active) titleChips.push({ label: "Inactive", tone: "neutral" });
  const vehicle = [driver.vehicle_year, driver.vehicle_make, driver.vehicle_model].filter(Boolean).join(" ");
  return {
    key: `drivers-${driver.id}`,
    entityKey: "drivers",
    customerId: driver.user?.customer_id ?? void 0,
    payload: { status: driver.status ?? null },
    recency: driver.updated_at ?? null,
    href: `/drivers/${driver.id}`,
    title: driver.user?.display_name ?? `Driver #${driver.id}`,
    titleChips,
    avatar: { initials: initialsOf(driver.user?.display_name), src: driver.user?.avatar_url },
    primaryLine: metaLine(formatPhone(driver.user?.phone), driver.user?.email),
    secondaryLine: vehicle,
    footChips: region && driver.region?.name ? [{ label: driver.region.name, tone: "neutral" }] : []
  };
}

// src/entities/drivers.tsx
function useSearch2(query, { limit, skip, offset = 0, withTotal = false, filters }) {
  const { options } = useGlobalSearchConfig();
  const { region = false, taxClass = false, useEnabled = useAlwaysEnabled } = options.drivers ?? {};
  const enabled = useEnabled();
  const where = useMemo4(() => buildDriversWhere(query, filters), [query, filters]);
  const skipped = skip || !enabled || !where;
  const canCount = useCanCount("drivers");
  const { data, loading, error: queryError } = useSearchDriversQuery({
    variables: pageVariables(where, { limit, offset, withTotal: withTotal && canCount }),
    skip: skipped,
    errorPolicy: "all"
  });
  const error = useCountFallback("drivers", { error: queryError, loading });
  const toItem3 = useCallback2((row) => driverToItem(row, { region, taxClass }), [region, taxClass]);
  return useEntityResult(
    { rows: data?.drivers, total: data?.drivers_aggregate?.aggregate?.count, skipped, limit, loading, error },
    toItem3
  );
}
var PRIORITY2 = { email: 80, phone: 70, text: 50, numeric: 15, vin: 50 };
var driversEntity = {
  key: "drivers",
  label: "Drivers",
  searchHint: "Name, email address, phone number, vehicle VIN",
  priorityFor: (kind) => PRIORITY2[kind] ?? 0,
  // Vehicle filters reach the driver's personal vehicle (withDriverVehicle).
  filterSupport: { status: false, window: false, vehicle: true },
  useSearch: useSearch2,
  // #991: entity-owned renderer, composed from the shared shell.
  Card: DriverSearchCard_default,
  cardRequiresPayload: true
};

// src/entities/guests.tsx
import { useMemo as useMemo5 } from "react";

// src/gql/searchGuestMoves.query.generated.ts
import { gql as gql3 } from "@apollo/client";
import * as Apollo3 from "@apollo/client";
import { resolveExecutor as resolveExecutor3 } from "@hopdrive/sdk-core";
var defaultOptions3 = {};
var GuestMoveSearchRowFragmentDoc = gql3`
    fragment GuestMoveSearchRow on moves {
  id
  lite
  status
  cancel_status
  move_type
  consumer_name
  consumer_phone
  consumer_phone_digits
  consumer_type
  usecase_key
  pickup_time
  consumer_at_pickup
  reference_num
  vehicle_year
  vehicle_make
  vehicle_model
  vehicle_vin
  vehicle_stock
  lane {
    id
    distance_miles
    duration_sec
    pickup {
      id
      name
    }
    delivery {
      id
      name
    }
  }
  customer {
    id
    name
    tier
  }
}
    `;
var SearchGuestMovesDocument = gql3`
    query searchGuestMoves($where: moves_bool_exp!, $limit: Int!) {
  moves(where: $where, limit: $limit, order_by: {id: desc}) {
    ...GuestMoveSearchRow
  }
}
    ${GuestMoveSearchRowFragmentDoc}`;
function useSearchGuestMovesQuery(baseOptions) {
  const options = { ...defaultOptions3, ...baseOptions };
  return Apollo3.useQuery(SearchGuestMovesDocument, options);
}

// src/gql/privileged/searchGuestMovesWithNotes.query.generated.ts
import { gql as gql4 } from "@apollo/client";
import * as Apollo4 from "@apollo/client";
import { resolveExecutor as resolveExecutor4 } from "@hopdrive/sdk-core";
var defaultOptions4 = {};
var SearchGuestMovesWithNotesDocument = gql4`
    query searchGuestMovesWithNotes($where: moves_bool_exp!, $limit: Int!) {
  moves(where: $where, limit: $limit, order_by: {id: desc}) {
    ...GuestMoveSearchRow
    dispatchnotes(order_by: {id: desc}, limit: 5) {
      id
      note
      createdat
      createdby
    }
    dispatchnotes_aggregate {
      aggregate {
        count
      }
    }
  }
}
    ${GuestMoveSearchRowFragmentDoc}`;
function useSearchGuestMovesWithNotesQuery(baseOptions) {
  const options = { ...defaultOptions4, ...baseOptions };
  return Apollo4.useQuery(SearchGuestMovesWithNotesDocument, options);
}

// src/gql/searchScenarioGuestMoves.query.generated.ts
import { gql as gql5 } from "@apollo/client";
import * as Apollo5 from "@apollo/client";
import { resolveExecutor as resolveExecutor5 } from "@hopdrive/sdk-core";
var defaultOptions5 = {};
var SearchScenarioGuestMovesDocument = gql5`
    query searchScenarioGuestMoves($where: moves_bool_exp!, $limit: Int!) {
  moves(where: $where, limit: $limit, order_by: {id: desc}) {
    ...GuestMoveSearchRow
  }
}
    ${GuestMoveSearchRowFragmentDoc}`;
function useSearchScenarioGuestMovesQuery(baseOptions) {
  const options = { ...defaultOptions5, ...baseOptions };
  return Apollo5.useQuery(SearchScenarioGuestMovesDocument, options);
}

// src/entities/scenarioReach.ts
import { useEffect as useEffect2, useSyncExternalStore as useSyncExternalStore2 } from "react";
var SCENARIO_FIELD_MISSING = /field 'scenariotomoves' not found in type: '\w+'|Cannot query field "scenariotomoves"|'scenariotomoves' not found/;
function messagesOf2(error) {
  if (typeof error === "string") return [error];
  if (!error || typeof error !== "object") return [];
  const { message, graphQLErrors } = error;
  const messages = typeof message === "string" ? [message] : [];
  for (const nested of graphQLErrors ?? []) {
    if (typeof nested?.message === "string") messages.push(nested.message);
  }
  return messages;
}
function isScenarioReachError(error) {
  return messagesOf2(error).some((message) => SCENARIO_FIELD_MISSING.test(message));
}
var unreachable = false;
var listeners2 = /* @__PURE__ */ new Set();
var scenarioReach = {
  isOff: () => unreachable,
  turnOff() {
    if (unreachable) return;
    unreachable = true;
    console.warn(
      "[global-search] scenario search is off for the session: this role cannot read scenariotomoves."
    );
    listeners2.forEach((listener) => listener());
  },
  subscribe(listener) {
    listeners2.add(listener);
    return () => {
      listeners2.delete(listener);
    };
  },
  /** Test seam. */
  reset() {
    unreachable = false;
  }
};
function useScenarioReach() {
  const off = useSyncExternalStore2(scenarioReach.subscribe, scenarioReach.isOff, scenarioReach.isOff);
  return !off;
}
function useScenarioFallback(error) {
  const reachError = isScenarioReachError(error);
  useEffect2(() => {
    if (reachError) scenarioReach.turnOff();
  }, [reachError]);
  return reachError ? void 0 : error;
}

// src/components/GuestSearchCard.tsx
import { Box as Box5, Typography as Typography5 } from "@mui/material";
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var GuestSearchCard = ({ item, query, onNavigate, showRankDebug }) => /* @__PURE__ */ jsx6(SearchResultCardShell, { item, onNavigate, children: /* @__PURE__ */ jsxs5(Box5, { sx: { display: "flex", alignItems: "center", gap: 2, px: 2, py: 1.25, minWidth: 0, minHeight: 56 }, children: [
  /* @__PURE__ */ jsx6(SearchResultLeading, { item }),
  /* @__PURE__ */ jsxs5(Box5, { sx: { flex: 1, minWidth: 0 }, children: [
    /* @__PURE__ */ jsxs5(Box5, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }, children: [
      /* @__PURE__ */ jsx6(Typography5, { noWrap: true, sx: { fontSize: 15, fontWeight: 600 }, children: /* @__PURE__ */ jsx6(HighlightedText, { text: item.title, query }) }),
      item.titleChips?.map((chip) => /* @__PURE__ */ jsx6(ToneChip, { chip }, chip.label)),
      /* @__PURE__ */ jsx6(MatchChips, { item, query }),
      item.footChips?.map((chip) => /* @__PURE__ */ jsx6(ToneChip, { chip }, chip.label)),
      /* @__PURE__ */ jsx6(DispatchNotesChip_default, { item })
    ] }),
    item.primaryLine && /* @__PURE__ */ jsx6(Typography5, { noWrap: true, sx: { fontSize: 13, color: "text.secondary", mt: 0.25 }, children: /* @__PURE__ */ jsx6(HighlightedText, { text: item.primaryLine, query }) }),
    showRankDebug && /* @__PURE__ */ jsx6(RankDebugLine, { item })
  ] })
] }) });
var GuestSearchCard_default = GuestSearchCard;

// src/components/MoveSearchCard.tsx
import { Box as Box6, Chip as Chip3, Tooltip as Tooltip2, Typography as Typography6 } from "@mui/material";
import { alpha as alpha2 } from "@mui/material/styles";
import {
  BiBarcode,
  BiFingerprint,
  BiSolidCheckCircle,
  BiSolidPencil,
  BiSolidRightArrowCircle,
  BiSolidTime,
  BiSolidXCircle,
  BiSubdirectoryRight
} from "react-icons/bi";
import { PiSteeringWheelFill as PiSteeringWheelFill2 } from "react-icons/pi";
import { allTokens as allTokens5 } from "@hopdrive/ui/tokens";
import { Fragment as Fragment2, jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var { palette: palette5, typography: typography2 } = allTokens5;
function resolveMoveTypeIdentity(move) {
  if (move.move_type === "ride") return "ride";
  if (move.consumer_type === "loaner") return "loaner";
  if (move.consumer_type === "customer") return move.consumer_at_pickup === 1 ? "pickup" : "return";
  return "operational";
}
var TYPE_LABELS = {
  pickup: "Valet Pickup",
  return: "Valet Return",
  loaner: "Loaner",
  operational: "One-Way",
  ride: "Ride"
};
var PHASES = {
  upcoming: { color: palette5.grey[500], Icon: BiSolidTime, label: "Upcoming" },
  dispatched: { color: palette5.info.main, Icon: BiSolidPencil, label: "Dispatched" },
  driving: { color: palette5.warning[600], Icon: BiSolidRightArrowCircle, label: "Driving" },
  done: { color: palette5.success.main, Icon: BiSolidCheckCircle, label: "Completed" },
  cancelPending: { color: palette5.error.main, Icon: BiSolidXCircle, label: "Cancel Pending" },
  cancelled: { color: palette5.error.main, Icon: BiSolidXCircle, label: "Canceled" }
};
var STATUS_INDEX = {
  dispatched: 0,
  "pickup started": 1,
  "pickup arrived": 2,
  "pickup successful": 3,
  "delivery started": 4,
  "delivery arrived": 5,
  "delivery successful": 6,
  completed: 6
};
function movePhase(status, cancelStatus) {
  if (cancelStatus) return cancelStatus === "pending" ? PHASES.cancelPending : PHASES.cancelled;
  const index = status ? STATUS_INDEX[status.toLowerCase()] : void 0;
  if (index == null) return PHASES.upcoming;
  if (index >= 6) return PHASES.done;
  if (index >= 1) return PHASES.driving;
  return PHASES.dispatched;
}
function formatDatedClock(iso) {
  if (!iso) return null;
  const ms = Date.parse(iso);
  if (Number.isNaN(ms)) return null;
  const date = new Intl.DateTimeFormat("en-US", { month: "numeric", day: "numeric" }).format(ms);
  const clock = new Intl.DateTimeFormat("en-US", { hour: "numeric", minute: "2-digit" }).format(ms);
  return `${date}, ${clock}`;
}
function queryMatches(text, query) {
  if ((query.kind === "phone" || query.kind === "numeric") && query.phoneDigits) {
    return extractDigits(text).includes(query.phoneDigits);
  }
  const needle = query.term.toLowerCase();
  return needle.length >= 2 && text.toLowerCase().includes(needle);
}
var VinChip = ({ vin, driverEntered, hasMoveVin, confirmed, query }) => {
  const matched = queryMatches(vin, query);
  const Icon = driverEntered ? PiSteeringWheelFill2 : BiBarcode;
  const title = driverEntered ? hasMoveVin ? "Entered by the driver during the pickup workflow \u2014 differs from the VIN on the move" : "Entered by the driver during the pickup workflow" : confirmed ? "VIN on the move \u2014 matches the VIN the driver entered during the pickup workflow" : "VIN on the move record";
  return /* @__PURE__ */ jsx7(Tooltip2, { title, arrow: true, children: /* @__PURE__ */ jsx7(
    Chip3,
    {
      label: /* @__PURE__ */ jsxs6(Box6, { component: "span", sx: { display: "inline-flex", alignItems: "center", gap: "4px" }, children: [
        /* @__PURE__ */ jsx7(Icon, { size: 11, "aria-hidden": true }),
        driverEntered ? `Driver-entered VIN ${vin}` : `VIN ${vin}`,
        confirmed && /* @__PURE__ */ jsx7(BiSolidCheckCircle, { size: 11, color: palette5.success.main, "aria-label": "Driver-confirmed" })
      ] }),
      size: "small",
      sx: {
        height: 20,
        fontSize: 11,
        fontWeight: 600,
        borderRadius: "9999px",
        backgroundColor: matched ? alpha2(palette5.warning.main, 0.3) : palette5.grey[100],
        color: palette5.grey[600],
        "& .MuiChip-label": { px: 1, display: "inline-flex", alignItems: "center" }
      }
    }
  ) });
};
var TRACKER_SKEW = "skewX(-22.5deg)";
var MiniTracker = ({ statusIndex, color }) => /* @__PURE__ */ jsx7(Box6, { sx: { display: "flex", gap: "3px", width: "100%", overflow: "hidden" }, children: [2, 5].map((threshold, index) => /* @__PURE__ */ jsx7(
  Box6,
  {
    sx: {
      flex: 1,
      height: "5px",
      backgroundColor: statusIndex >= threshold ? color : "rgba(32,36,48,0.12)",
      transform: TRACKER_SKEW,
      ...index === 0 ? { marginLeft: "-2px" } : {},
      ...index === 1 ? { marginRight: "-2px" } : {}
    }
  },
  threshold
)) });
var cellSx = (size, bold = false, color) => ({
  display: "block",
  fontSize: size,
  lineHeight: 1.25,
  fontWeight: bold ? 700 : size === 11 ? 500 : 400,
  ...color ? { color } : {},
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
});
var CELL_EMPTY = "\u2014";
var MoveSearchCard = ({ item, query, onNavigate, showRankDebug }) => {
  const payload = item.payload;
  if (!payload) {
    return /* @__PURE__ */ jsx7(SearchResultCard_default, { item, query, onNavigate, showRankDebug });
  }
  const phase = movePhase(payload.status, payload.cancelStatus);
  const statusIndex = payload.status ? STATUS_INDEX[payload.status.toLowerCase()] ?? -1 : -1;
  const vehicleText = [payload.vehicle, payload.stock && `Stock ${payload.stock}`].filter(Boolean).join("  \xB7  ");
  const showVehicle = vehicleText.length > 0 && queryMatches(vehicleText, query);
  const moveVin = payload.vin?.trim().toUpperCase() ?? null;
  const workflowVins = payload.workflowVins ?? [];
  const vinConfirmed = moveVin != null && workflowVins.includes(moveVin);
  const driverOnlyVins = workflowVins.filter((vin) => vin !== moveVin);
  const hasVinChips = Boolean(payload.vin) || driverOnlyVins.length > 0;
  const appt = formatDatedClock(payload.readyBy ?? payload.pickupTime);
  return /* @__PURE__ */ jsx7(SearchResultCardShell, { item, onNavigate, children: /* @__PURE__ */ jsxs6(Box6, { sx: { display: "flex", alignItems: "center", gap: 2, px: 2, py: "8px", minWidth: 0, minHeight: 56 }, children: [
    /* @__PURE__ */ jsx7(
      Box6,
      {
        "aria-hidden": true,
        sx: {
          flex: "none",
          width: LEADING_SLOT_WIDTH,
          height: LEADING_SLOT_WIDTH,
          borderRadius: "8px",
          position: "relative",
          overflow: "hidden",
          ...payload.photoUrl ? {
            bgcolor: "rgba(32,36,48,0.06)",
            // ScenarioLegPhoto's inset vignette: a pale photo still reads
            // as a distinct square against the row.
            "&::after": {
              content: '""',
              position: "absolute",
              inset: 0,
              boxShadow: "inset 0 0 4px rgba(0,0,0,0.18)"
            }
          } : {
            background: "repeating-linear-gradient(135deg, rgba(32,36,48,0.12) 0 8px, rgba(32,36,48,0.04) 8px 16px)"
          }
        },
        children: payload.photoUrl && /* @__PURE__ */ jsx7(
          Box6,
          {
            component: "img",
            src: payload.photoUrl,
            alt: "",
            sx: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", display: "block" }
          }
        )
      }
    ),
    /* @__PURE__ */ jsxs6(Box6, { sx: { display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }, children: [
      /* @__PURE__ */ jsxs6(Box6, { sx: { display: "flex", alignItems: "center", gap: "10px", minWidth: 0 }, children: [
        /* @__PURE__ */ jsxs6(Box6, { sx: { display: "flex", flexDirection: "column", lineHeight: 1.25, flex: "1.1 1 0", minWidth: 110 }, children: [
          /* @__PURE__ */ jsx7(Typography6, { component: "span", sx: cellSx(12, true), children: TYPE_LABELS[payload.typeIdentity] ?? TYPE_LABELS.operational }),
          /* @__PURE__ */ jsxs6(Box6, { sx: { display: "inline-flex", alignItems: "center", gap: "3px", color: palette5.grey[600], minWidth: 0 }, children: [
            /* @__PURE__ */ jsx7(BiFingerprint, { size: 10, "aria-hidden": true, style: { flex: "none" } }),
            /* @__PURE__ */ jsxs6(Typography6, { component: "span", sx: cellSx(11, false, palette5.grey[600]), children: [
              /* @__PURE__ */ jsx7(HighlightedText, { text: formatMoveIdLabel(payload.moveId, payload.lite), query }),
              payload.reference ? /* @__PURE__ */ jsxs6(Fragment2, { children: [
                " \xB7 ",
                /* @__PURE__ */ jsx7(HighlightedText, { text: payload.reference, query })
              ] }) : null
            ] })
          ] }),
          showVehicle && /* @__PURE__ */ jsx7(Typography6, { component: "span", sx: cellSx(11, false, palette5.grey[600]), children: /* @__PURE__ */ jsx7(HighlightedText, { text: vehicleText, query }) })
        ] }),
        /* @__PURE__ */ jsx7(Box6, { sx: { flex: "0.9 1 0", minWidth: 100, display: { xs: "none", sm: "block" } }, children: payload.consumerName ? /* @__PURE__ */ jsxs6(Box6, { sx: { display: "flex", flexDirection: "column", lineHeight: 1.25, minWidth: 0 }, children: [
          /* @__PURE__ */ jsx7(Typography6, { component: "span", sx: cellSx(12, true), children: /* @__PURE__ */ jsx7(HighlightedText, { text: payload.consumerName, query }) }),
          payload.consumerPhone && /* @__PURE__ */ jsx7(Typography6, { component: "span", sx: cellSx(11, false, palette5.grey[600]), children: /* @__PURE__ */ jsx7(HighlightedText, { text: payload.consumerPhone, query }) })
        ] }) : /* @__PURE__ */ jsx7(Typography6, { component: "span", sx: cellSx(12, false, palette5.grey[400]), children: CELL_EMPTY }) }),
        /* @__PURE__ */ jsxs6(Box6, { sx: { flex: "1.3 1 0", minWidth: 140, display: "flex", flexDirection: "column", fontSize: 11, lineHeight: 1.25 }, children: [
          payload.pickupName ? /* @__PURE__ */ jsx7(Typography6, { component: "span", sx: { ...cellSx(11), display: "inline-flex", alignItems: "center", gap: "3px" }, children: /* @__PURE__ */ jsx7(HighlightedText, { text: payload.pickupName, query }) }) : /* @__PURE__ */ jsx7(Typography6, { component: "span", sx: cellSx(11, false, palette5.grey[400]), children: CELL_EMPTY }),
          payload.deliveryName && /* @__PURE__ */ jsxs6(Typography6, { component: "span", sx: { ...cellSx(11), display: "inline-flex", alignItems: "center", gap: "3px" }, children: [
            /* @__PURE__ */ jsx7(BiSubdirectoryRight, { size: 10, color: palette5.grey[400], "aria-hidden": true, style: { flex: "none" } }),
            /* @__PURE__ */ jsx7(HighlightedText, { text: payload.deliveryName, query })
          ] })
        ] }),
        /* @__PURE__ */ jsx7(Box6, { sx: { width: 92, flexShrink: 0 }, children: appt ? /* @__PURE__ */ jsx7(Typography6, { component: "span", sx: cellSx(12, true), children: appt }) : /* @__PURE__ */ jsx7(Typography6, { component: "span", sx: cellSx(12, false, palette5.grey[400]), children: CELL_EMPTY }) }),
        /* @__PURE__ */ jsxs6(Box6, { sx: { display: "flex", flexDirection: "column", gap: "5px", width: 118, flexShrink: 0 }, children: [
          /* @__PURE__ */ jsxs6(
            Box6,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
                borderRadius: "9999px",
                padding: "2px 10px",
                border: `1px solid ${phase.color}`,
                backgroundColor: `color-mix(in srgb, ${phase.color} 12%, #ffffff)`,
                color: phase.color,
                fontSize: 11,
                fontWeight: 600,
                whiteSpace: "nowrap"
              },
              children: [
                /* @__PURE__ */ jsx7(phase.Icon, { size: 11, "aria-hidden": true }),
                phase.label
              ]
            }
          ),
          /* @__PURE__ */ jsx7(MiniTracker, { statusIndex, color: phase.color })
        ] })
      ] }),
      (item.titleChips?.length || item.footChips?.length || hasVinChips || hasMatchChips(item, query) || showRankDebug) && /* @__PURE__ */ jsxs6(Box6, { sx: { mt: "6px" }, children: [
        /* @__PURE__ */ jsxs6(Box6, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }, children: [
          item.titleChips?.map((chip) => /* @__PURE__ */ jsx7(ToneChip, { chip }, chip.label)),
          /* @__PURE__ */ jsx7(MatchChips, { item, query }),
          payload.vin && /* @__PURE__ */ jsx7(VinChip, { vin: payload.vin, confirmed: vinConfirmed, query }),
          driverOnlyVins.map((vin) => /* @__PURE__ */ jsx7(VinChip, { vin, driverEntered: true, hasMoveVin: Boolean(payload.vin), query }, vin)),
          item.footChips?.map((chip) => /* @__PURE__ */ jsx7(ToneChip, { chip }, chip.label))
        ] }),
        showRankDebug && /* @__PURE__ */ jsx7(RankDebugLine, { item })
      ] })
    ] })
  ] }) });
};
var MoveSearchCard_default = MoveSearchCard;

// src/items/guests.ts
function guestCarriedMoveToItem(move) {
  const footChips = [];
  if (move.customer?.name) footChips.push({ label: move.customer.name, tone: "neutral" });
  return {
    key: `moves-${move.id}`,
    entityKey: "moves",
    customerId: move.customer?.id ?? void 0,
    recency: move.pickup_time ?? null,
    matchFields: scenarioMatchFields([move.matchedScenarioId]),
    href: `/moves/${move.id}`,
    title: titleCase(move.move_type) || "Move",
    status: move.cancel_status ?? move.status ?? "not started",
    badge: formatMoveIdLabel(move.id, move.lite),
    secondaryLine: formatDateTime(move.pickup_time),
    // The full move payload, so the resolver routes carried relatives to the
    // scenario-leg card just like pool moves (guests query fetches the fields).
    payload: {
      moveId: move.id,
      lite: move.lite ?? false,
      typeIdentity: resolveMoveTypeIdentity(move),
      vehicle: [move.vehicle_year, move.vehicle_make, move.vehicle_model].filter(Boolean).join(" ") || null,
      vin: move.vehicle_vin ?? null,
      stock: move.vehicle_stock ?? null,
      reference: move.reference_num ?? null,
      pickupName: move.lane?.pickup?.name ?? null,
      deliveryName: move.lane?.delivery?.name ?? null,
      // Consumer omitted on purpose — the guest anchor is right above the row.
      pickupTime: move.pickup_time ?? null,
      status: move.status ?? null,
      cancelStatus: move.cancel_status ?? null
    },
    footChips
  };
}
function guestGroupToItem(group) {
  const titleChips = [{ label: "Guest", tone: "guest", icon: "person" }];
  const footChips = [];
  if (group.rooftop) footChips.push({ label: group.rooftop, tone: "neutral" });
  const tier = tierChip(group.tier);
  if (tier) footChips.push(tier);
  const move = group.latestMove;
  return {
    key: `guests-${group.key}`,
    entityKey: "guests",
    recency: group.latestMove.pickup_time ?? null,
    customerId: group.latestMove.customer?.id ?? void 0,
    href: `/moves/${move.id}`,
    relatedKeys: group.moveIds.map((id) => `moves-${id}`),
    // Labelled as the portals label them — `L-<id>` for Lite, `#<id>` otherwise (#2324).
    relatedLinks: group.moveIds.slice(0, 5).map((id) => ({
      label: formatMoveIdLabel(id, group.liteMoveIds.includes(id), { hash: true }),
      href: `/moves/${id}`
    })),
    relatedItems: group.recentMoves.map(guestCarriedMoveToItem),
    title: group.name,
    matchFields: scenarioMatchFields(group.scenarioIds),
    // Dispatcher notes across the guest's grouped moves (#1018): the shared
    // hover chip renders them; full history lives on the move pages.
    notes: group.notes,
    noteCount: group.noteCount,
    titleChips,
    avatar: { initials: initialsOf(group.name) },
    primaryLine: formatPhone(group.phone),
    footChips
  };
}

// src/utils/groupGuestMoves.ts
function normalizedRawDigits(phone) {
  return normalizePhoneDigits(extractDigits(phone ?? ""));
}
function groupGuestMoves(moves, limit) {
  const groups = /* @__PURE__ */ new Map();
  for (const move of moves) {
    const digits = move.consumer_phone_digits || normalizedRawDigits(move.consumer_phone);
    const name = (move.consumer_name ?? "").trim();
    const key = digits || (name ? `${move.customer?.id ?? "none"}:${name.toLowerCase()}` : "");
    if (!key) continue;
    const moveNotes = (move.dispatchnotes ?? []).map((entry) => ({ ...entry, moveId: move.id }));
    const noteCount = move.dispatchnotes_aggregate?.aggregate?.count ?? 0;
    const existing = groups.get(key);
    if (existing) {
      existing.moveCount += 1;
      existing.moveIds.push(move.id);
      if (move.lite) existing.liteMoveIds.push(move.id);
      if (existing.recentMoves.length < 3) existing.recentMoves.push(move);
      existing.noteCount += noteCount;
      existing.notes.push(...moveNotes);
      if (move.matchedScenarioId != null && !existing.scenarioIds.includes(move.matchedScenarioId)) {
        existing.scenarioIds.push(move.matchedScenarioId);
      }
      continue;
    }
    groups.set(key, {
      key,
      name: name || "Unknown guest",
      phone: move.consumer_phone ?? "",
      rooftop: move.customer?.name ?? null,
      tier: move.customer?.tier ?? null,
      viaConciergeLink: (move.usecase_key ?? "").startsWith("concierge"),
      latestMove: move,
      moveCount: 1,
      moveIds: [move.id],
      liteMoveIds: move.lite ? [move.id] : [],
      recentMoves: [move],
      notes: moveNotes,
      noteCount,
      scenarioIds: move.matchedScenarioId != null ? [move.matchedScenarioId] : []
    });
  }
  const result = [...groups.values()].slice(0, limit);
  for (const group of result) group.notes.sort((a, b) => (b.createdat ?? "").localeCompare(a.createdat ?? ""));
  return result;
}

// src/utils/branchMerge.ts
function mergeBranchRows(a, b) {
  const merged = [];
  let i = 0;
  let j = 0;
  while (i < a.length || j < b.length) {
    const left = a[i];
    const right = b[j];
    if (left && right && left.id === right.id) {
      merged.push(left);
      i++;
      j++;
    } else if (!right || left && left.id > right.id) {
      merged.push(left);
      i++;
    } else {
      merged.push(right);
      j++;
    }
  }
  return merged;
}
function combineBranchTotals(idx, sub, both) {
  if (idx == null && sub == null) return void 0;
  return (idx ?? 0) + (sub ?? 0) - (both ?? 0);
}

// src/entities/guests.tsx
var OVERFETCH_FACTOR = 5;
function useSearch3(query, { limit, skip, offset = 0, filters }) {
  const { options } = useGlobalSearchConfig();
  const privileged = usePrivilegedReach();
  const useEnabled = options.guests?.useEnabled ?? useAlwaysEnabled;
  const enabled = useEnabled();
  const where = useMemo5(() => buildGuestMovesWhere(query, filters), [query, filters]);
  const scenarioReach2 = useScenarioReach();
  const whereScn = useMemo5(
    () => scenarioReach2 ? buildGuestScenarioMovesWhere(query, filters) : null,
    [query, filters, scenarioReach2]
  );
  const skipped = skip || !enabled || !where && !whereScn;
  const withNotes = privileged.dispatchNotes === true;
  const fetchLimit = (offset + limit + 1) * OVERFETCH_FACTOR;
  const variables = { where: where ?? {}, limit: fetchLimit };
  const plain = useSearchGuestMovesQuery({ variables, skip: skipped || !where || withNotes, errorPolicy: "all" });
  const noted = useSearchGuestMovesWithNotesQuery({
    variables,
    skip: skipped || !where || !withNotes,
    errorPolicy: "all"
  });
  const { data, loading, error } = withNotes ? noted : plain;
  const scn = useSearchScenarioGuestMovesQuery({
    variables: { where: whereScn ?? {}, limit: fetchLimit },
    skip: skipped || !whereScn,
    errorPolicy: "all"
  });
  const scnError = useScenarioFallback(scn.error);
  const scenarioId = scenarioIdOf(query);
  const groups = useMemo5(() => {
    if (skipped) return [];
    const main = data?.moves ?? [];
    const tagged = scenarioId == null ? [] : (scn.data?.moves ?? []).map((move) => ({ ...move, matchedScenarioId: scenarioId }));
    return groupGuestMoves(mergeBranchRows(tagged, main), offset + limit + 1);
  }, [data, scn.data, scenarioId, skipped, limit, offset]);
  const items = useMemo5(() => groups.slice(offset, offset + limit).map(guestGroupToItem), [groups, limit, offset]);
  return {
    items,
    loading: !skipped && (loading || scn.loading),
    hasMore: groups.length > offset + limit,
    error: error ?? scnError
  };
}
var PRIORITY3 = { phone: 85, text: 85, numeric: 35 };
var guestsEntity = {
  key: "guests",
  label: "Guests",
  searchHint: "Consumer name, phone number, scenario ID",
  priorityFor: (kind) => PRIORITY3[kind] ?? 0,
  // Guest moves ARE moves, so every move filter (vehicle included) reaches them.
  filterSupport: { status: true, window: true, vehicle: true },
  // Cross-entity matchScore (#823): a guest's defining fields are their phone
  // and name — exact digits or exact name = 10, prefix = 7, contains = 4.
  scoreItem: (item, query) => {
    if ((query.kind === "phone" || query.kind === "numeric") && query.phoneDigits) {
      const digits = (item.primaryLine ?? "").replace(/\D/g, "");
      if (digits === query.phoneDigits) return 10;
      if (digits.startsWith(query.phoneDigits)) return 7;
      if (digits.includes(query.phoneDigits)) return 4;
      return 2;
    }
    const name = item.title.toLowerCase();
    const term = query.term.toLowerCase();
    if (name === term) return 10;
    if (name.startsWith(term)) return 7;
    if (name.includes(term)) return 4;
    return 2;
  },
  useSearch: useSearch3,
  // #991: entity-owned renderer, composed from the shared shell. No payload:
  // the slim identity card (#1066) renders from generic item fields.
  Card: GuestSearchCard_default
};

// src/entities/invoices.tsx
import { useMemo as useMemo6 } from "react";

// src/gql/searchInvoices.query.generated.ts
import { gql as gql6 } from "@apollo/client";
import * as Apollo6 from "@apollo/client";
import { resolveExecutor as resolveExecutor6 } from "@hopdrive/sdk-core";
var defaultOptions6 = {};
var SearchInvoicesDocument = gql6`
    query searchInvoices($where: arinvoices_bool_exp!, $limit: Int!, $offset: Int!, $withCount: Boolean!) {
  arinvoices(where: $where, limit: $limit, offset: $offset, order_by: {id: desc}) {
    id
    status
    invoice_type
    start_datetime
    end_datetime
    customer {
      id
      name
      tier
    }
  }
  arinvoices_aggregate(where: $where) @include(if: $withCount) {
    aggregate {
      count
    }
  }
}
    `;
function useSearchInvoicesQuery(baseOptions) {
  const options = { ...defaultOptions6, ...baseOptions };
  return Apollo6.useQuery(SearchInvoicesDocument, options);
}

// src/items/invoices.ts
function invoiceTypeLabel(invoiceType) {
  switch (invoiceType) {
    case "standard":
      return "Moves";
    case "standard_charges":
      return "Charges";
    default:
      return titleCase(invoiceType);
  }
}
function formatBillingPeriod(start, end) {
  const startDate = new Date(start);
  const endDate = new Date(end);
  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return "";
  const sameYear = startDate.getUTCFullYear() === endDate.getUTCFullYear();
  const format = (date, withYear) => date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    ...withYear ? { year: "numeric" } : {},
    timeZone: "UTC"
  });
  return `${format(startDate, !sameYear)} \u2013 ${format(endDate, true)}`;
}
function invoiceToItem(invoice) {
  const footChips = [];
  if (invoice.customer?.name) footChips.push({ label: invoice.customer.name, tone: "neutral" });
  const tier = tierChip(invoice.customer?.tier);
  if (tier) footChips.push(tier);
  return {
    key: `invoices-${invoice.id}`,
    entityKey: "invoices",
    customerId: invoice.customer?.id ?? void 0,
    // The end of the billing period — when the invoice became (or becomes) due.
    recency: invoice.end_datetime,
    href: `/invoices/${invoice.id}`,
    title: `#${invoice.id}`,
    status: invoice.status,
    leadingIcon: "invoice",
    primaryLine: metaLine(
      formatBillingPeriod(invoice.start_datetime, invoice.end_datetime),
      invoiceTypeLabel(invoice.invoice_type)
    ),
    footChips
  };
}

// src/entities/invoices.tsx
function useSearch4(query, { limit, skip, offset = 0, withTotal = false, filters }) {
  const { options } = useGlobalSearchConfig();
  const useEnabled = options.invoices?.useEnabled ?? useAlwaysEnabled;
  const enabled = useEnabled();
  const where = useMemo6(() => buildInvoicesWhere(query, filters), [query, filters]);
  const skipped = skip || !enabled || !where;
  const canCount = useCanCount("invoices");
  const { data, loading, error: queryError } = useSearchInvoicesQuery({
    variables: pageVariables(where, { limit, offset, withTotal: withTotal && canCount }),
    skip: skipped,
    errorPolicy: "all"
  });
  const error = useCountFallback("invoices", { error: queryError, loading });
  return useEntityResult(
    { rows: data?.arinvoices, total: data?.arinvoices_aggregate?.aggregate?.count, skipped, limit, loading, error },
    invoiceToItem
  );
}
var PRIORITY4 = { numeric: 70 };
var invoicesEntity = {
  key: "invoices",
  label: "Invoices",
  // The id is the title, so the row needs its kind said for it.
  itemLabel: "Invoice",
  itemIcon: "invoice",
  searchHint: "Invoice ID",
  priorityFor: (kind) => PRIORITY4[kind] ?? 0,
  // Status buckets are move-shaped and the date window bounds pickup times;
  // neither means anything for a billing period.
  filterSupport: { status: false, window: false },
  // An exact id is a defining-field exact, as for moves (#823).
  scoreItem: (item, query) => item.title === `#${query.term}` ? 10 : 2,
  useSearch: useSearch4
};

// src/entities/lanes.tsx
import { useCallback as useCallback3 } from "react";

// src/gql/searchLanes.query.generated.ts
import { gql as gql7 } from "@apollo/client";
import * as Apollo7 from "@apollo/client";
import { resolveExecutor as resolveExecutor7 } from "@hopdrive/sdk-core";
var defaultOptions7 = {};
var SearchLanesDocument = gql7`
    query searchLanes($search: String!, $limit: Int!, $offset: Int!, $withCount: Boolean!, $where: lanes_bool_exp = {}) {
  search_lanes(
    args: {search: $search}
    where: $where
    order_by: {updatedat: desc}
    limit: $limit
    offset: $offset
  ) {
    id
    updatedat
    status
    distance_miles
    customer {
      id
      name
      tier
      organization {
        id
        name
      }
    }
    pickup {
      id
      name
      city
      state
    }
    delivery {
      id
      name
      city
      state
    }
  }
  search_lanes_aggregate(args: {search: $search}, where: $where) @include(if: $withCount) {
    aggregate {
      count
    }
  }
}
    `;
function useSearchLanesQuery(baseOptions) {
  const options = { ...defaultOptions7, ...baseOptions };
  return Apollo7.useQuery(SearchLanesDocument, options);
}

// src/components/LaneSearchCard.tsx
import { Box as Box7, Typography as Typography7 } from "@mui/material";
import { allTokens as allTokens6 } from "@hopdrive/ui/tokens";
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var { palette: palette6, typography: typography3 } = allTokens6;
var LaneSearchCard = ({ item, query, onNavigate, showRankDebug }) => {
  const payload = item.payload;
  if (!payload) return /* @__PURE__ */ jsx8(SearchResultCard_default, { item, query, onNavigate, showRankDebug });
  const endpoint = (name, place) => /* @__PURE__ */ jsxs7(Box7, { sx: { minWidth: 0 }, children: [
    /* @__PURE__ */ jsx8(Typography7, { noWrap: true, sx: { fontSize: 14, fontWeight: 600 }, children: /* @__PURE__ */ jsx8(HighlightedText, { text: name, query }) }),
    place && /* @__PURE__ */ jsx8(Typography7, { noWrap: true, sx: { fontSize: 12, color: "text.secondary" }, children: /* @__PURE__ */ jsx8(HighlightedText, { text: place, query }) })
  ] });
  return /* @__PURE__ */ jsx8(SearchResultCardShell, { item, onNavigate, children: /* @__PURE__ */ jsxs7(Box7, { sx: { display: "flex", alignItems: "center", gap: 2, p: 2, minWidth: 0 }, children: [
    /* @__PURE__ */ jsxs7(
      Box7,
      {
        sx: {
          width: LEADING_SLOT_WIDTH,
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          alignSelf: "stretch",
          py: 0.5
        },
        children: [
          /* @__PURE__ */ jsx8(Box7, { sx: { width: 10, height: 10, borderRadius: "50%", border: `2px solid ${palette6.grey[600]}`, flexShrink: 0 } }),
          /* @__PURE__ */ jsx8(Box7, { sx: { width: "2px", flex: 1, minHeight: 14, bgcolor: palette6.grey[300], my: 0.25 } }),
          /* @__PURE__ */ jsx8(Box7, { sx: { width: 10, height: 10, borderRadius: "50%", bgcolor: palette6.grey[600], flexShrink: 0 } })
        ]
      }
    ),
    /* @__PURE__ */ jsxs7(Box7, { sx: { flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 0.75 }, children: [
      endpoint(payload.pickupName, payload.pickupPlace),
      endpoint(payload.deliveryName, payload.deliveryPlace),
      item.footChips && item.footChips.length > 0 && /* @__PURE__ */ jsx8(Box7, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }, children: item.footChips.map((chip) => /* @__PURE__ */ jsx8(ToneChip, { chip }, chip.label)) }),
      showRankDebug && /* @__PURE__ */ jsx8(RankDebugLine, { item })
    ] }),
    /* @__PURE__ */ jsxs7(Box7, { sx: { display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0.75, flexShrink: 0 }, children: [
      /* @__PURE__ */ jsxs7(Box7, { sx: { display: "flex", alignItems: "center", gap: 0.75 }, children: [
        item.status && /* @__PURE__ */ jsx8(StatusChip, { status: item.status }),
        item.titleChips?.map((chip) => /* @__PURE__ */ jsx8(ToneChip, { chip }, chip.label))
      ] }),
      item.stat && /* @__PURE__ */ jsx8(Typography7, { sx: { fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", color: "text.secondary" }, children: item.stat }),
      item.badge && /* @__PURE__ */ jsxs7(
        Typography7,
        {
          sx: { fontSize: 11, fontFamily: typography3.fontFamily.mono, color: "text.disabled", whiteSpace: "nowrap" },
          children: [
            "#",
            item.badge
          ]
        }
      )
    ] })
  ] }) });
};
var LaneSearchCard_default = LaneSearchCard;

// src/items/lanes.ts
var STATUS_TONE = {
  ready: "saas",
  pending: "portal",
  enriching: "guest",
  failed: "fullservice",
  stale: "driver",
  new: "neutral"
};
function laneCityState(location) {
  return [location?.city, location?.state].filter(Boolean).join(", ");
}
function laneToItem(lane, { href, orgName = false } = {}) {
  const status = lane.status ?? "new";
  const titleChips = [{ label: titleCase(status), tone: STATUS_TONE[status] ?? "neutral" }];
  const footChips = [];
  if (lane.customer?.name) footChips.push({ label: lane.customer.name, tone: "neutral" });
  const tier = tierChip(lane.customer?.tier);
  if (tier) footChips.push(tier);
  const route = [laneCityState(lane.pickup), laneCityState(lane.delivery)].filter(Boolean).join(" \u2192 ");
  return {
    key: `lanes-${lane.id}`,
    entityKey: "lanes",
    customerId: lane.customer?.id ?? void 0,
    payload: {
      pickupName: lane.pickup?.name ?? "?",
      pickupPlace: laneCityState(lane.pickup) || void 0,
      deliveryName: lane.delivery?.name ?? "?",
      deliveryPlace: laneCityState(lane.delivery) || void 0
    },
    // search_lanes already trusts updatedat as its relevance order — adopt it as recency.
    recency: lane.updatedat ?? null,
    href: href?.(lane),
    title: `${lane.pickup?.name ?? "?"} \u2192 ${lane.delivery?.name ?? "?"}`,
    titleChips,
    badge: String(lane.id),
    primaryLine: orgName ? metaLine(lane.customer?.organization?.name, route) : route,
    footChips,
    stat: lane.distance_miles != null ? `${Number(lane.distance_miles).toFixed(1)} mi` : void 0
  };
}

// src/entities/lanes.tsx
var SEARCHABLE_KINDS = ["text", "numeric"];
function useSearch5(query, { limit, skip, offset = 0, withTotal = false, filters }) {
  const { options } = useGlobalSearchConfig();
  const { href: staticHref, orgName = false, useEnabled = useAlwaysEnabled, useHref = useNoHref } = options.lanes ?? {};
  const enabled = useEnabled();
  const href = useHref() ?? staticHref;
  const skipped = skip || !enabled || !SEARCHABLE_KINDS.includes(query.kind);
  const canCount = useCanCount("lanes");
  const { data, loading, error: queryError } = useSearchLanesQuery({
    variables: {
      // The raw term, not query.like: search_lanes builds its own ILIKE
      // patterns and escapes `%`/`_`/`\` itself (1788975596908), and its
      // exact-match branches (id, zip, state) need the term unescaped.
      search: query.term,
      limit: limit + 1,
      offset,
      withCount: withTotal && canCount,
      where: buildLanesWhere(filters)
    },
    skip: skipped,
    errorPolicy: "all"
  });
  const error = useCountFallback("lanes", { error: queryError, loading });
  const toItem3 = useCallback3((row) => laneToItem(row, { href, orgName }), [href, orgName]);
  return useEntityResult(
    { rows: data?.search_lanes, total: data?.search_lanes_aggregate?.aggregate?.count, skipped, limit, loading, error },
    toItem3
  );
}
var PRIORITY5 = { text: 55, numeric: 60 };
var lanesEntity = {
  key: "lanes",
  label: "Lanes",
  // Items don't self-identify (unlike guests/drivers/mobility) — chip them in the unified list.
  itemLabel: "Lane",
  itemIcon: "lane",
  // #991 pilot: the route-visual renderer, composed from the shared shell.
  Card: LaneSearchCard_default,
  cardRequiresPayload: true,
  searchHint: "Lane ID, pickup/delivery location, address, city, ZIP, customer",
  priorityFor: (kind) => PRIORITY5[kind] ?? 0,
  filterSupport: { status: false, window: false },
  useSearch: useSearch5
};

// src/entities/locations.tsx
import { useCallback as useCallback4, useMemo as useMemo7 } from "react";

// src/gql/searchLocations.query.generated.ts
import { gql as gql8 } from "@apollo/client";
import * as Apollo8 from "@apollo/client";
import { resolveExecutor as resolveExecutor8 } from "@hopdrive/sdk-core";
var defaultOptions8 = {};
var SearchLocationsDocument = gql8`
    query searchLocations($where: locations_bool_exp!, $limit: Int!, $offset: Int!, $withCount: Boolean!) {
  locations(where: $where, limit: $limit, offset: $offset, order_by: {name: asc}) {
    id
    updatedat
    name
    nickname
    address
    city
    state
    zip_code
    phone
    email
    customer_ref
    type
    active
    customer {
      id
      name
      tier
    }
    region {
      id
      name
    }
  }
  locations_aggregate(where: $where) @include(if: $withCount) {
    aggregate {
      count
    }
  }
}
    `;
function useSearchLocationsQuery(baseOptions) {
  const options = { ...defaultOptions8, ...baseOptions };
  return Apollo8.useQuery(SearchLocationsDocument, options);
}

// src/components/LocationSearchCard.tsx
import { Box as Box8, Chip as Chip4, Typography as Typography8 } from "@mui/material";
import { BiMap as BiMap2 } from "react-icons/bi";
import { allTokens as allTokens7 } from "@hopdrive/ui/tokens";
import { jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var { palette: palette7, typography: typography4, radius: radius4 } = allTokens7;
var LocationSearchCard = ({ item, query, onNavigate, showRankDebug }) => {
  const payload = item.payload;
  if (!payload) {
    return /* @__PURE__ */ jsx9(SearchResultCard_default, { item, query, onNavigate, showRankDebug });
  }
  return /* @__PURE__ */ jsx9(SearchResultCardShell, { item, onNavigate, children: /* @__PURE__ */ jsxs8(Box8, { sx: { display: "flex", alignItems: "center", gap: 2, p: 2, minWidth: 0 }, children: [
    /* @__PURE__ */ jsx9(
      Box8,
      {
        sx: {
          width: LEADING_SLOT_WIDTH,
          height: LEADING_SLOT_WIDTH,
          flexShrink: 0,
          borderRadius: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "rgba(32,36,48,0.06)",
          color: palette7.grey[600]
        },
        children: /* @__PURE__ */ jsx9(BiMap2, { size: 22 })
      }
    ),
    /* @__PURE__ */ jsxs8(Box8, { sx: { flex: 1, minWidth: 0 }, children: [
      /* @__PURE__ */ jsxs8(Box8, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }, children: [
        /* @__PURE__ */ jsx9(Typography8, { noWrap: true, sx: { fontSize: 15, fontWeight: 600 }, children: /* @__PURE__ */ jsx9(HighlightedText, { text: item.title, query }) }),
        item.titleChips?.map((chip) => /* @__PURE__ */ jsx9(ToneChip, { chip }, chip.label))
      ] }),
      payload.formalName && /* @__PURE__ */ jsx9(Typography8, { noWrap: true, sx: { fontSize: 12, color: "text.secondary", mt: 0.25 }, children: /* @__PURE__ */ jsx9(HighlightedText, { text: payload.formalName, query }) }),
      payload.address && /* @__PURE__ */ jsx9(Typography8, { noWrap: true, sx: { fontSize: 13, color: "text.secondary", mt: 0.25 }, children: /* @__PURE__ */ jsx9(HighlightedText, { text: payload.address, query }) }),
      payload.cityStateZip && /* @__PURE__ */ jsx9(Typography8, { noWrap: true, sx: { fontSize: 12, color: "text.secondary", mt: 0.25 }, children: /* @__PURE__ */ jsx9(HighlightedText, { text: payload.cityStateZip, query }) }),
      item.secondaryLine && /* @__PURE__ */ jsx9(Typography8, { noWrap: true, sx: { fontSize: 12, color: "text.disabled", mt: 0.25 }, children: /* @__PURE__ */ jsx9(HighlightedText, { text: item.secondaryLine, query }) }),
      item.footChips && item.footChips.length > 0 && /* @__PURE__ */ jsx9(Box8, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap", mt: 0.75 }, children: item.footChips.map((chip) => /* @__PURE__ */ jsx9(ToneChip, { chip }, chip.label)) }),
      showRankDebug && /* @__PURE__ */ jsx9(RankDebugLine, { item })
    ] }),
    /* @__PURE__ */ jsxs8(Box8, { sx: { display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0.75, flexShrink: 0 }, children: [
      payload.type && /* @__PURE__ */ jsx9(
        Chip4,
        {
          label: payload.type,
          size: "small",
          sx: {
            height: 20,
            fontSize: 11,
            fontWeight: 600,
            textTransform: "capitalize",
            borderRadius: `${radius4.full}px`,
            backgroundColor: palette7.grey[100],
            color: palette7.grey[600],
            border: "none",
            "& .MuiChip-label": { px: 1 }
          }
        }
      ),
      item.key.startsWith("locations-") && /* @__PURE__ */ jsxs8(
        Typography8,
        {
          sx: { fontSize: 11, fontFamily: typography4.fontFamily.mono, color: "text.disabled", whiteSpace: "nowrap" },
          children: [
            "#",
            item.key.slice("locations-".length)
          ]
        }
      )
    ] })
  ] }) });
};
var LocationSearchCard_default = LocationSearchCard;

// src/items/locations.ts
function locationCityStateZip(location) {
  const cityState = [location.city, location.state].filter(Boolean).join(", ");
  return [cityState, location.zip_code].filter(Boolean).join(" ");
}
function locationToItem(location, { region = false, customerRef = false } = {}) {
  const title = location.nickname || location.name || `Location #${location.id}`;
  const showFormalName = !!location.nickname && !!location.name && location.nickname !== location.name;
  const titleChips = [];
  if (!location.active) titleChips.push({ label: "Inactive", tone: "neutral" });
  const footChips = [];
  if (location.customer?.name) footChips.push({ label: location.customer.name, tone: "neutral" });
  const tier = tierChip(location.customer?.tier);
  if (tier) footChips.push(tier);
  if (region && location.region?.name) footChips.push({ label: location.region.name, tone: "neutral" });
  return {
    key: `locations-${location.id}`,
    entityKey: "locations",
    customerId: location.customer?.id ?? void 0,
    payload: {
      type: location.type ?? null,
      formalName: showFormalName ? location.name : null,
      address: location.address ?? null,
      cityStateZip: locationCityStateZip(location) || null
    },
    recency: location.updatedat ?? null,
    href: `/locations/${location.id}`,
    title,
    titleChips,
    avatar: { initials: initialsOf(title) },
    primaryLine: metaLine(location.address, locationCityStateZip(location)),
    secondaryLine: metaLine(
      showFormalName && location.name,
      formatPhone(location.phone),
      location.email,
      customerRef && location.customer_ref ? `Ref ${location.customer_ref}` : void 0
    ),
    footChips
  };
}

// src/entities/locations.tsx
function useSearch6(query, { limit, skip, offset = 0, withTotal = false, filters }) {
  const { options } = useGlobalSearchConfig();
  const { region = false, customerRef = false, useEnabled = useAlwaysEnabled } = options.locations ?? {};
  const enabled = useEnabled();
  const where = useMemo7(
    () => buildLocationsWhere(query, filters, { customerRef }),
    [query, filters, customerRef]
  );
  const skipped = skip || !enabled || !where;
  const canCount = useCanCount("locations");
  const { data, loading, error: queryError } = useSearchLocationsQuery({
    variables: pageVariables(where, { limit, offset, withTotal: withTotal && canCount }),
    skip: skipped,
    errorPolicy: "all"
  });
  const error = useCountFallback("locations", { error: queryError, loading });
  const toItem3 = useCallback4(
    (row) => locationToItem(row, { region, customerRef }),
    [region, customerRef]
  );
  return useEntityResult(
    { rows: data?.locations, total: data?.locations_aggregate?.aggregate?.count, skipped, limit, loading, error },
    toItem3
  );
}
var PRIORITY6 = { text: 65, numeric: 30, phone: 50, email: 40 };
var locationsEntity = {
  key: "locations",
  label: "Locations",
  // Items don't self-identify (unlike guests/drivers/mobility) — chip them in the unified list.
  itemLabel: "Location",
  itemIcon: "location",
  searchHint: "Name, nickname, address, city, ZIP, phone, email",
  priorityFor: (kind) => PRIORITY6[kind] ?? 0,
  filterSupport: { status: false, window: false },
  useSearch: useSearch6,
  // #991: entity-owned renderer, composed from the shared shell.
  Card: LocationSearchCard_default,
  cardRequiresPayload: true
};

// src/entities/mobility.tsx
import { useCallback as useCallback5, useMemo as useMemo8 } from "react";

// src/gql/searchMobility.query.generated.ts
import { gql as gql9 } from "@apollo/client";
import * as Apollo9 from "@apollo/client";
import { resolveExecutor as resolveExecutor9 } from "@hopdrive/sdk-core";
var defaultOptions9 = {};
var SearchMobilityDocument = gql9`
    query searchMobility($where: mobility_runs_bool_exp!, $limit: Int!, $offset: Int!, $withCount: Boolean!) {
  mobility_runs(
    where: $where
    limit: $limit
    offset: $offset
    order_by: {departure_time: desc_nulls_last}
  ) {
    id
    name
    product_type
    status
    departure_time
    estimated_distance_miles
    scenario_id
    customer {
      id
      name
      tier
    }
    driver {
      id
      user {
        display_name
      }
    }
    stops(order_by: {stop_order: asc}, limit: 3) {
      id
      stop_order
      status
      address
      location {
        id
        name
      }
    }
    stops_aggregate {
      aggregate {
        count
      }
    }
  }
  mobility_runs_aggregate(where: $where) @include(if: $withCount) {
    aggregate {
      count
    }
  }
}
    `;
function useSearchMobilityQuery(baseOptions) {
  const options = { ...defaultOptions9, ...baseOptions };
  return Apollo9.useQuery(SearchMobilityDocument, options);
}

// src/components/MobilitySearchCard.tsx
import { Box as Box9, Typography as Typography9 } from "@mui/material";
import { MdCheck } from "react-icons/md";
import { jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var PHASE_COLORS = {
  pending: "#cbd5e1",
  active: "#3b82f6",
  completed: "#22c55e",
  skipped: "#ef4444"
};
function classifyMobilityStopPhase(status) {
  if (status === "completed") return "completed";
  if (status === "skipped") return "skipped";
  if (status && ["in_transit_to", "arrived", "in_service", "service_in_progress"].includes(status)) return "active";
  return "pending";
}
var MobilitySearchCard = ({ item, query, onNavigate, showRankDebug }) => {
  const payload = item.payload;
  if (!payload) {
    return /* @__PURE__ */ jsx10(SearchResultCard_default, { item, query, onNavigate, showRankDebug });
  }
  return /* @__PURE__ */ jsx10(SearchResultCardShell, { item, onNavigate, children: /* @__PURE__ */ jsxs9(Box9, { sx: { display: "flex", alignItems: "center", gap: 2, p: 2, minWidth: 0 }, children: [
    /* @__PURE__ */ jsx10(SearchResultLeading, { item }),
    /* @__PURE__ */ jsxs9(Box9, { sx: { flex: 1, minWidth: 0 }, children: [
      /* @__PURE__ */ jsxs9(Box9, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }, children: [
        /* @__PURE__ */ jsx10(Typography9, { noWrap: true, sx: { fontSize: 15, fontWeight: 600 }, children: /* @__PURE__ */ jsx10(HighlightedText, { text: item.title, query }) }),
        item.status && /* @__PURE__ */ jsx10(StatusChip, { status: item.status }),
        item.titleChips?.map((chip) => /* @__PURE__ */ jsx10(ToneChip, { chip }, chip.label))
      ] }),
      item.secondaryLine && /* @__PURE__ */ jsx10(Typography9, { noWrap: true, sx: { fontSize: 12, color: "text.disabled", mt: 0.25 }, children: item.secondaryLine }),
      payload.stops.length > 0 && /* @__PURE__ */ jsxs9(Box9, { sx: { display: "flex", flexDirection: "column", gap: 0.5, mt: 0.75 }, children: [
        payload.stops.map((stop) => {
          const done = stop.phase === "completed";
          return /* @__PURE__ */ jsxs9(Box9, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [
            /* @__PURE__ */ jsx10(
              Box9,
              {
                sx: {
                  width: 18,
                  height: 18,
                  flexShrink: 0,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: PHASE_COLORS[stop.phase],
                  color: "#fff",
                  fontSize: 10,
                  fontWeight: 700
                },
                children: done ? /* @__PURE__ */ jsx10(MdCheck, { size: 12 }) : stop.order
              }
            ),
            /* @__PURE__ */ jsx10(
              Typography9,
              {
                noWrap: true,
                sx: {
                  fontSize: 12,
                  color: done ? "text.disabled" : "text.secondary",
                  textDecoration: done ? "line-through" : "none"
                },
                children: /* @__PURE__ */ jsx10(HighlightedText, { text: stop.name, query })
              }
            )
          ] }, stop.order);
        }),
        payload.moreCount > 0 && /* @__PURE__ */ jsxs9(Typography9, { sx: { fontSize: 11, color: "text.disabled", pl: "26px" }, children: [
          "+",
          payload.moreCount,
          " more ",
          payload.moreCount === 1 ? "stop" : "stops"
        ] })
      ] }),
      (item.footChips && item.footChips.length > 0 || hasMatchChips(item, query)) && /* @__PURE__ */ jsxs9(Box9, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap", mt: 0.75 }, children: [
        /* @__PURE__ */ jsx10(MatchChips, { item, query }),
        item.footChips?.map((chip) => /* @__PURE__ */ jsx10(ToneChip, { chip }, chip.label))
      ] }),
      showRankDebug && /* @__PURE__ */ jsx10(RankDebugLine, { item })
    ] }),
    item.stat && /* @__PURE__ */ jsx10(Typography9, { sx: { fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", color: "text.secondary" }, children: item.stat })
  ] }) });
};
var MobilitySearchCard_default = MobilitySearchCard;

// src/items/mobility.ts
var PRODUCT = {
  shuttle: { label: "Shuttle", tone: "shuttle" },
  mobile_service: { label: "Mobile Service", tone: "service" },
  parts_delivery: { label: "Parts Delivery", tone: "parts" }
};
function mobilityRunToItem(run, { href } = {}) {
  const product = PRODUCT[run.product_type] ?? { label: titleCase(run.product_type), tone: "neutral" };
  const footChips = [];
  if (run.customer?.name) footChips.push({ label: run.customer.name, tone: "neutral" });
  const tier = tierChip(run.customer?.tier);
  if (tier) footChips.push(tier);
  const stopCount = run.stops_aggregate?.aggregate?.count ?? 0;
  return {
    key: `mobility-${run.id}`,
    entityKey: "mobility",
    customerId: run.customer?.id ?? void 0,
    payload: {
      stops: (run.stops ?? []).map((stop) => ({
        order: stop.stop_order,
        name: stop.location?.name || stop.address || `Stop ${stop.stop_order}`,
        phase: classifyMobilityStopPhase(stop.status)
      })),
      moreCount: Math.max(0, stopCount - (run.stops?.length ?? 0))
    },
    recency: run.departure_time ?? null,
    matchFields: scenarioMatchFields([run.scenario_id]),
    href: href?.(run),
    title: run.name || product.label,
    titleChips: [{ label: product.label, tone: product.tone }],
    status: run.status,
    badge: String(run.id),
    primaryLine: metaLine(
      `${stopCount} ${stopCount === 1 ? "stop" : "stops"}`,
      run.estimated_distance_miles != null && `${Number(run.estimated_distance_miles).toFixed(1)} mi est`
    ),
    secondaryLine: metaLine(formatDateTime(run.departure_time), run.driver?.user?.display_name),
    footChips,
    stat: run.estimated_distance_miles != null ? `${Number(run.estimated_distance_miles).toFixed(1)} mi est` : void 0
  };
}

// src/entities/mobility.tsx
function useSearch7(query, { limit, skip, offset = 0, withTotal = false, filters }) {
  const { options } = useGlobalSearchConfig();
  const { useRunAccess = useOpenRunAccess, useEnabled = useAlwaysEnabled } = options.mobility ?? {};
  const enabled = useEnabled();
  const { products, href } = useRunAccess();
  const where = useMemo8(() => buildMobilityWhere(query, filters, products), [query, filters, products]);
  const skipped = skip || !enabled || !where;
  const canCount = useCanCount("mobility");
  const { data, loading, error: queryError } = useSearchMobilityQuery({
    variables: pageVariables(where, { limit, offset, withTotal: withTotal && canCount }),
    skip: skipped,
    errorPolicy: "all"
  });
  const error = useCountFallback("mobility", { error: queryError, loading });
  const toItem3 = useCallback5((run) => mobilityRunToItem(run, { href }), [href]);
  return useEntityResult(
    {
      rows: data?.mobility_runs,
      total: data?.mobility_runs_aggregate?.aggregate?.count,
      skipped,
      limit,
      loading,
      error
    },
    toItem3
  );
}
var PRIORITY7 = { numeric: 65, text: 55, phone: 45 };
var mobilityEntity = {
  key: "mobility",
  label: "Mobility",
  searchHint: "Run ID or name, stop address, parts recipient, service customer, RO #, phone",
  priorityFor: (kind) => PRIORITY7[kind] ?? 0,
  // Status buckets are move-shaped; runs carry the date dimension plus the
  // vehicle one (through the run's assigned mobility_vehicles row).
  filterSupport: { status: false, window: true, vehicle: true },
  useSearch: useSearch7,
  // #991: entity-owned renderer, composed from the shared shell.
  Card: MobilitySearchCard_default,
  cardRequiresPayload: true
};

// src/entities/moves.tsx
import { useMemo as useMemo9 } from "react";

// src/gql/searchMoves.query.generated.ts
import { gql as gql10 } from "@apollo/client";
import * as Apollo10 from "@apollo/client";
import { resolveExecutor as resolveExecutor10 } from "@hopdrive/sdk-core";
var defaultOptions10 = {};
var MoveSearchRowFragmentDoc = gql10`
    fragment MoveSearchRow on moves {
  id
  lite
  reference_num
  status
  cancel_status
  move_type
  consumer_name
  consumer_phone
  consumer_type
  consumer_at_pickup
  dealer_contact
  vehicle_vin
  pickup_workflow_data
  vehicle_stock
  vehicle_year
  vehicle_make
  vehicle_model
  vehicle_color
  driver_name
  vehiclephotos(
    where: {status: {_eq: "done"}}
    order_by: {createdat: asc}
    limit: 40
  ) {
    id
    url
    status
    step_id
    workflow_id
    createdat
  }
  workflowset {
    id
    pickupWorkflow {
      id
      steps
    }
    deliveryWorkflow {
      id
      steps
    }
  }
  lane {
    id
    pickup {
      id
      name
    }
    delivery {
      id
      name
    }
  }
  ready_by
  pickup_time
  delivery_time
  customer {
    id
    name
    tier
  }
}
    `;
var SearchMovesDocument = gql10`
    query searchMoves($whereIdx: moves_bool_exp!, $skipIdx: Boolean!, $whereSub: moves_bool_exp!, $skipSub: Boolean!, $fetch: Int!, $withIdxCount: Boolean!, $withSubCount: Boolean!, $withBothCount: Boolean!) {
  idxMatches: moves(where: $whereIdx, limit: $fetch, order_by: {id: desc}) @skip(if: $skipIdx) {
    ...MoveSearchRow
  }
  subMatches: moves(where: $whereSub, limit: $fetch, order_by: {id: desc}) @skip(if: $skipSub) {
    ...MoveSearchRow
  }
  idxCount: moves_aggregate(where: $whereIdx) @include(if: $withIdxCount) {
    aggregate {
      count
    }
  }
  subCount: moves_aggregate(where: $whereSub) @include(if: $withSubCount) {
    aggregate {
      count
    }
  }
  bothCount: moves_aggregate(where: {_and: [$whereIdx, $whereSub]}) @include(if: $withBothCount) {
    aggregate {
      count
    }
  }
}
    ${MoveSearchRowFragmentDoc}`;
function useSearchMovesQuery(baseOptions) {
  const options = { ...defaultOptions10, ...baseOptions };
  return Apollo10.useQuery(SearchMovesDocument, options);
}

// src/gql/searchScenarioMoves.query.generated.ts
import { gql as gql11 } from "@apollo/client";
import * as Apollo11 from "@apollo/client";
import { resolveExecutor as resolveExecutor11 } from "@hopdrive/sdk-core";
var defaultOptions11 = {};
var SearchScenarioMovesDocument = gql11`
    query searchScenarioMoves($where: moves_bool_exp!, $fetch: Int!, $withCount: Boolean!, $overlapWhere: moves_bool_exp!, $withOverlap: Boolean!) {
  moves(where: $where, limit: $fetch, order_by: {id: desc}) {
    ...MoveSearchRow
  }
  scenarioCount: moves_aggregate(where: $where) @include(if: $withCount) {
    aggregate {
      count
    }
  }
  overlapCount: moves_aggregate(where: {_and: [$where, $overlapWhere]}) @include(if: $withOverlap) {
    aggregate {
      count
    }
  }
}
    ${MoveSearchRowFragmentDoc}`;
function useSearchScenarioMovesQuery(baseOptions) {
  const options = { ...defaultOptions11, ...baseOptions };
  return Apollo11.useQuery(SearchScenarioMovesDocument, options);
}

// src/utils/workflowVins.ts
var FULL_VIN = /^[A-HJ-NPR-Z0-9]{17}$/;
function extractWorkflowVins(data) {
  const found = [];
  const seen = /* @__PURE__ */ new Set();
  const visit = (node) => {
    if (typeof node === "string") {
      const candidate = node.trim().toUpperCase();
      if (FULL_VIN.test(candidate) && /\d/.test(candidate) && !seen.has(candidate)) {
        seen.add(candidate);
        found.push(candidate);
      }
      return;
    }
    if (Array.isArray(node)) {
      node.forEach(visit);
      return;
    }
    if (node && typeof node === "object") Object.values(node).forEach(visit);
  };
  visit(data);
  return found;
}

// src/utils/movePhoto.ts
function asSteps(value) {
  return Array.isArray(value) ? value : null;
}
var STANDARD_ORDER = [
  "driver-front",
  "driver-front-wheel",
  "driver-rear",
  "driver-rear-wheel",
  "passenger-front",
  "passenger-front-wheel",
  "passenger-rear",
  "passenger-rear-wheel",
  "instrument-cluster",
  "interior-front",
  "interior-rear",
  "interior-trunk",
  "interior-vin",
  "vehicle-vin",
  "vehicle-weight-badge",
  "fuel-pump",
  "front-bumper",
  "windshield",
  "driver-side-full-view",
  "trunk-rear-bumper",
  "passenger-side-full-view",
  "engine-bay",
  "roof-photo",
  "license-plate-photo",
  "center-console",
  "backup-camera-photo",
  "vehicle-keys",
  "driver-carpet-photo",
  "third-row-photo",
  "vehicle-contents-photo",
  "exterior-damage-photos",
  "interior-damage-photos"
];
function standardOrderOf(stepId) {
  if (stepId === "damages") return 500;
  if (stepId === "signature") return 1e3;
  const index = stepId ? STANDARD_ORDER.indexOf(stepId) : -1;
  return index >= 0 ? index : 100;
}
var DOCUMENT_STEPS = /* @__PURE__ */ new Set(["vehicle-bol", "signature", "contact-signature", "pickup-signature"]);
function sortPhotosByStandardOrder(photos) {
  return [...photos].sort((a, b) => standardOrderOf(a.step_id) - standardOrderOf(b.step_id));
}
function findHeroStepId(steps) {
  if (!steps) return null;
  for (const step of steps) {
    if (step?.type === "photo" && step.config?.is_hero === true && step.id) return step.id;
    const nested = findHeroStepId(step?.steps);
    if (nested) return nested;
  }
  return null;
}
function resolveMoveHeroPhotoUrl(photos, workflowset) {
  const captured = (photos ?? []).filter((photo) => photo.status === "done");
  if (!captured.length) return null;
  const groups = /* @__PURE__ */ new Map();
  for (const photo of captured) {
    const key = String(photo.workflow_id ?? "ungrouped");
    groups.set(key, [...groups.get(key) ?? [], photo]);
  }
  const earliestOf = (group) => Math.min(...group.map((photo) => photo.createdat ? Date.parse(photo.createdat) : Number.MAX_SAFE_INTEGER));
  const ordered = [...groups.values()].sort((a, b) => earliestOf(a) - earliestOf(b));
  const groupForWorkflow = (id) => id == null ? void 0 : ordered.find((group) => group.some((photo) => photo.workflow_id === id));
  const pickupGroup = groupForWorkflow(workflowset?.pickupWorkflow?.id) ?? ordered[0];
  const deliveryGroup = groupForWorkflow(workflowset?.deliveryWorkflow?.id) ?? (ordered.length > 1 ? ordered[ordered.length - 1] : void 0);
  const heroIn = (group, steps) => {
    if (!group?.length) return void 0;
    const byStep = (stepId) => stepId ? group.find((photo) => photo.step_id === stepId) : void 0;
    return byStep(findHeroStepId(steps)) ?? byStep("driver-front");
  };
  const hero = heroIn(deliveryGroup, asSteps(workflowset?.deliveryWorkflow?.steps)) ?? heroIn(pickupGroup, asSteps(workflowset?.pickupWorkflow?.steps));
  if (hero?.url) return hero.url;
  const realCaptureIn = (group) => {
    const real = (group ?? []).filter((p) => !DOCUMENT_STEPS.has(p.step_id ?? ""));
    if (!real.length) return void 0;
    return sortPhotosByStandardOrder(real)[0] ?? real[0];
  };
  const preferred = realCaptureIn(deliveryGroup) ?? realCaptureIn(pickupGroup);
  return preferred?.url ?? null;
}

// src/items/moves.ts
function moveVehicleLine(move) {
  const vehicle = [move.vehicle_year, move.vehicle_make, move.vehicle_model].filter(Boolean).join(" ");
  return metaLine(
    vehicle,
    move.vehicle_vin && `VIN ${move.vehicle_vin}`,
    move.vehicle_stock && `Stock ${move.vehicle_stock}`
  );
}
function moveToItem(move) {
  const footChips = [];
  if (move.customer?.name) footChips.push({ label: move.customer.name, tone: "neutral" });
  const tier = tierChip(move.customer?.tier);
  if (tier) footChips.push(tier);
  return {
    key: `moves-${move.id}`,
    entityKey: "moves",
    customerId: move.customer?.id ?? void 0,
    payload: {
      moveId: move.id,
      lite: move.lite ?? false,
      typeIdentity: resolveMoveTypeIdentity(move),
      vehicle: [move.vehicle_year, move.vehicle_make, move.vehicle_model].filter(Boolean).join(" ") || null,
      vin: move.vehicle_vin ?? null,
      workflowVins: extractWorkflowVins(move.pickup_workflow_data),
      stock: move.vehicle_stock ?? null,
      reference: move.reference_num ?? null,
      pickupName: move.lane?.pickup?.name ?? null,
      deliveryName: move.lane?.delivery?.name ?? null,
      consumerName: move.consumer_name ?? null,
      consumerPhone: formatPhone(move.consumer_phone) || null,
      driverName: move.driver_name ?? null,
      photoUrl: resolveMoveHeroPhotoUrl(move.vehiclephotos, move.workflowset),
      readyBy: move.ready_by ?? null,
      pickupTime: move.pickup_time ?? null,
      status: move.status ?? null,
      cancelStatus: move.cancel_status ?? null
    },
    recency: move.pickup_time ?? null,
    matchFields: scenarioMatchFields([move.matchedScenarioId]),
    href: `/moves/${move.id}`,
    title: titleCase(move.move_type) || "Move",
    status: move.cancel_status ?? move.status ?? "not started",
    // The copy chip's exact text: `L-<id>` for Lite, bare id otherwise (#2324).
    badge: formatMoveIdLabel(move.id, move.lite),
    primaryLine: moveVehicleLine(move),
    secondaryLine: metaLine(
      formatDateTime(move.pickup_time),
      move.driver_name,
      move.consumer_name,
      move.dealer_contact,
      move.reference_num && `Ref ${move.reference_num}`
    ),
    footChips
  };
}

// src/entities/moves.tsx
function useSearch8(query, { limit, skip, offset = 0, withTotal = false, filters }) {
  const { options } = useGlobalSearchConfig();
  const useEnabled = options.moves?.useEnabled ?? useAlwaysEnabled;
  const enabled = useEnabled();
  const whereIdx = useMemo9(() => buildMovesIndexedWhere(query, filters), [query, filters]);
  const whereSub = useMemo9(() => buildMovesSubplanWhere(query, filters), [query, filters]);
  const scenarioReach2 = useScenarioReach();
  const whereScn = useMemo9(
    () => scenarioReach2 ? buildMovesScenarioWhere(query, filters) : null,
    [query, filters, scenarioReach2]
  );
  const hasMain = !!whereIdx || !!whereSub;
  const skipped = skip || !enabled || !hasMain && !whereScn;
  const fetch = offset + limit + 1;
  const canCount = useCanCount("moves");
  const withCount = withTotal && canCount && query.kind !== "vin";
  const { data, loading, error: queryError } = useSearchMovesQuery({
    variables: {
      whereIdx: whereIdx ?? {},
      skipIdx: !whereIdx,
      whereSub: whereSub ?? {},
      skipSub: !whereSub,
      fetch,
      withIdxCount: withCount && !!whereIdx,
      withSubCount: withCount && !!whereSub,
      withBothCount: withCount && !!whereIdx && !!whereSub
    },
    skip: skipped || !hasMain,
    errorPolicy: "all"
  });
  const error = useCountFallback("moves", { error: queryError, loading });
  const overlapWhere = useMemo9(
    () => ({ _or: [whereIdx, whereSub].filter((where) => !!where) }),
    [whereIdx, whereSub]
  );
  const scn = useSearchScenarioMovesQuery({
    variables: {
      where: whereScn ?? {},
      fetch,
      withCount,
      overlapWhere,
      withOverlap: withCount && hasMain
    },
    skip: skipped || !whereScn,
    errorPolicy: "all"
  });
  const scnReachError = useScenarioFallback(scn.error);
  const scnError = useCountFallback("moves", { error: scnReachError, loading: scn.loading });
  const scenarioId = scenarioIdOf(query);
  const merged = useMemo9(() => {
    const main = mergeBranchRows(data?.idxMatches ?? [], data?.subMatches ?? []);
    if (scenarioId == null || !scn.data?.moves.length) return main;
    const tagged = scn.data.moves.map((move) => ({ ...move, matchedScenarioId: scenarioId }));
    return mergeBranchRows(tagged, main);
  }, [data, scn.data, scenarioId]);
  const items = useMemo9(
    () => skipped ? [] : merged.slice(offset, offset + limit).map(moveToItem),
    [merged, skipped, limit, offset]
  );
  const mainTotal = combineBranchTotals(
    data?.idxCount?.aggregate?.count,
    data?.subCount?.aggregate?.count,
    data?.bothCount?.aggregate?.count
  );
  const scnTotal = scn.data?.scenarioCount?.aggregate?.count;
  return {
    items,
    loading: !skipped && (loading || scn.loading),
    hasMore: !skipped && merged.length > offset + limit,
    total: scnTotal == null ? mainTotal : (mainTotal ?? 0) + scnTotal - (scn.data?.overlapCount?.aggregate?.count ?? 0),
    error: error ?? scnError
  };
}
var PRIORITY8 = { numeric: 100, vin: 100, email: 60, phone: 60, text: 65 };
var movesEntity = {
  key: "moves",
  label: "Moves",
  // Items don't self-identify (unlike guests/drivers/mobility) — chip them in the unified list.
  itemLabel: "Move",
  itemIcon: "move",
  searchHint: "Move ID, scenario ID, {refLabel}, stock #, VIN (incl. driver-entered), dealer contact, pickup/delivery contacts",
  priorityFor: (kind) => PRIORITY8[kind] ?? 0,
  // withMoveFilters applies all three dimensions (vehicle via the move's own columns).
  filterSupport: { status: true, window: true, vehicle: true },
  // Cross-entity matchScore (#823): the entity owns what "exact" means for a
  // move — id, full VIN, stock, or reference are defining; other hits are weak.
  scoreItem: (item, query) => {
    const term = query.term.toLowerCase();
    if (item.badge && stripMoveIdPrefix(item.badge) === query.term) return 10;
    const detail = `${item.primaryLine ?? ""} ${item.secondaryLine ?? ""}`.toLowerCase();
    if (detail.includes(`vin ${term} `) || detail.endsWith(`vin ${term}`)) return 10;
    const workflowVins = item.payload?.workflowVins;
    if (workflowVins?.some((vin) => vin.toLowerCase() === term)) return 10;
    if (detail.includes(`stock ${term} `) || detail.endsWith(`stock ${term}`)) return 10;
    if (detail.includes(`ref ${term} `) || detail.endsWith(`ref ${term}`)) return 10;
    if (item.title.toLowerCase().includes(term) || detail.includes(term)) return 4;
    return 2;
  },
  useSearch: useSearch8,
  // #991: entity-owned renderer, composed from the shared shell.
  Card: MoveSearchCard_default,
  cardRequiresPayload: true
};

// src/entities/learningModules.tsx
import { useMemo as useMemo10 } from "react";

// src/gql/searchLearningModules.query.generated.ts
import { gql as gql12 } from "@apollo/client";
import * as Apollo12 from "@apollo/client";
import { resolveExecutor as resolveExecutor12 } from "@hopdrive/sdk-core";
var defaultOptions12 = {};
var LearningModuleSearchRowFragmentDoc = gql12`
    fragment LearningModuleSearchRow on learning_modules {
  id
  key
  name
  description
  audiences
  feature
  tiers
  driver_types
  hero_video_url
  thumbnail_url
  attachment_url
  begins_at
  ends_at
  status
  published_at
  updated_at
}
    `;
var SearchLearningModulesDocument = gql12`
    query searchLearningModules($where: learning_modules_bool_exp!, $limit: Int!) {
  learning_modules(where: $where, order_by: {begins_at: desc}, limit: $limit) {
    ...LearningModuleSearchRow
  }
}
    ${LearningModuleSearchRowFragmentDoc}`;
function useSearchLearningModulesQuery(baseOptions) {
  const options = { ...defaultOptions12, ...baseOptions };
  return Apollo12.useQuery(SearchLearningModulesDocument, options);
}

// src/components/LearningModuleSearchCard.tsx
import { useEffect as useEffect3, useState as useState2 } from "react";
import { Box as Box10, Typography as Typography10 } from "@mui/material";
import { BiCheck, BiFile, BiPlayCircle } from "react-icons/bi";
import { allTokens as allTokens8 } from "@hopdrive/ui/tokens";

// src/utils/learningModules.ts
function nextVersionBeginsAt(all, m) {
  const mBegins = new Date(m.begins_at).getTime();
  let min = null;
  for (const other of all) {
    if (other.id === m.id || other.key !== m.key || other.status === "draft") continue;
    if (new Date(other.begins_at).getTime() <= mBegins) continue;
    if (min == null || new Date(other.begins_at).getTime() < new Date(min).getTime()) min = other.begins_at;
  }
  return min;
}
function resolveEffectiveEnd(all, m) {
  const explicit = m.ends_at ?? null;
  const auto = nextVersionBeginsAt(all, m);
  if (explicit && auto) return new Date(explicit).getTime() <= new Date(auto).getTime() ? explicit : auto;
  return explicit ?? auto;
}
function resolveLiveModules(all, now = /* @__PURE__ */ new Date()) {
  const nowMs = now.getTime();
  const byKey = /* @__PURE__ */ new Map();
  for (const m of all) {
    if (m.status === "draft") continue;
    if (new Date(m.begins_at).getTime() > nowMs) continue;
    const arr = byKey.get(m.key) ?? [];
    arr.push(m);
    byKey.set(m.key, arr);
  }
  const live = [];
  for (const arr of byKey.values()) {
    arr.sort((a, b) => new Date(b.begins_at).getTime() - new Date(a.begins_at).getTime());
    const head = arr[0];
    if (!head || head.status !== "published") continue;
    const end = resolveEffectiveEnd(all, head);
    if (end && nowMs >= new Date(end).getTime()) continue;
    live.push(head);
  }
  return live;
}
var PRODUCT_FEATURES = ["mobile_service", "guest_ride", "appraisals", "appointments"];
var isProductFeature = (feature) => PRODUCT_FEATURES.includes(feature);
function filterForRooftop(modules, scope) {
  return modules.filter((m) => {
    const audienceOk = (m.audiences ?? []).some((a) => scope.audiences.includes(a));
    const tierOk = m.tiers == null || scope.tier != null && m.tiers.includes(scope.tier);
    const featureOk = !isProductFeature(m.feature) || scope.enabledFeatures.includes(m.feature);
    return audienceOk && tierOk && featureOk;
  });
}
var FEATURE_LABELS = {
  generic: "General",
  move: "Moves",
  mobile_service: "Mobile Service",
  guest_ride: "Guest Rides",
  appraisals: "Appraisals",
  appointments: "Appointments"
};
var featureLabel = (feature) => FEATURE_LABELS[feature] ?? titleCase(feature);
var AUDIENCE_LABELS = { admin: "Internal", dealer: "Dealer", driver: "Driver" };
var audienceLabel = (audience) => AUDIENCE_LABELS[audience] ?? titleCase(audience);
var tierLabel = (tier) => titleCase(tier);
var RECENT_MODULE_WINDOW_MS = 14 * 24 * 60 * 60 * 1e3;
function isRecentlyReleased(module, now) {
  const began = new Date(module.begins_at).getTime();
  if (Number.isNaN(began)) return false;
  const nowMs = now.getTime();
  return began <= nowMs && nowMs - began <= RECENT_MODULE_WINDOW_MS;
}
function extractYouTubeId(text) {
  if (!text) return null;
  const re = /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:[^#\s"'&]*&)*v=|(?:embed|shorts|live)\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = text.match(re);
  return match ? match[1] : null;
}
function youTubeThumbnailUrl(text) {
  const id = extractYouTubeId(text);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
}
function matchLearningModule(module, query) {
  if (query.kind !== "text") return null;
  const term = query.term.trim().toLowerCase();
  if (!term) return null;
  const name = module.name.toLowerCase();
  if (name === term) return { field: "name", score: 10 };
  if (name.startsWith(term)) return { field: "name", score: 8 };
  if (name.includes(term)) return { field: "name", score: 7 };
  if (module.description?.toLowerCase().includes(term)) return { field: "description", score: 5 };
  if (module.key.toLowerCase().includes(term)) return { field: "key", score: 5 };
  const feature = module.feature.toLowerCase();
  const label = featureLabel(module.feature).toLowerCase();
  if (label.includes(term) || feature.includes(term) || feature.replace(/_/g, " ").includes(term)) {
    return { field: "category", score: 4 };
  }
  return null;
}
function compareMatchedModules(a, b) {
  if (b.match.score !== a.match.score) return b.match.score - a.match.score;
  const began = new Date(b.module.begins_at).getTime() - new Date(a.module.begins_at).getTime();
  if (began !== 0) return began;
  return a.module.name.localeCompare(b.module.name);
}

// src/components/LearningModuleSearchCard.tsx
import { jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
var { palette: palette8 } = allTokens8;
var POSTER_GRADIENT = `linear-gradient(150deg, ${palette8.secondaryAccent.main} 0%, ${palette8.grounding.main} 100%)`;
function usePosterSrc(thumbnailUrl, heroVideoUrl, resolve) {
  const candidate = thumbnailUrl || youTubeThumbnailUrl(heroVideoUrl) || null;
  const [resolved, setResolved] = useState2({
    candidate: null,
    src: null
  });
  useEffect3(() => {
    if (!candidate || !resolve) return;
    let cancelled = false;
    resolve(candidate).then((url) => {
      if (!cancelled) setResolved({ candidate, src: url || null });
    }).catch(() => {
      if (!cancelled) setResolved({ candidate, src: null });
    });
    return () => {
      cancelled = true;
    };
  }, [candidate, resolve]);
  if (!candidate) return null;
  if (!resolve) return candidate;
  return resolved.candidate === candidate ? resolved.src : null;
}
var FormatMark = ({ icon: Icon, label }) => /* @__PURE__ */ jsxs10(Box10, { sx: { display: "inline-flex", alignItems: "center", gap: "4px", color: "text.secondary" }, children: [
  /* @__PURE__ */ jsx11(Box10, { component: "span", sx: { display: "inline-flex", color: "text.disabled" }, children: /* @__PURE__ */ jsx11(Icon, { size: 14 }) }),
  /* @__PURE__ */ jsx11(Typography10, { component: "span", sx: { fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" }, children: label })
] });
var LearningModuleSearchCard = ({ item, query, onNavigate, showRankDebug }) => {
  const payload = item.payload;
  const { options } = useGlobalSearchConfig();
  const src = usePosterSrc(
    payload?.thumbnailUrl ?? null,
    payload?.heroVideoUrl ?? null,
    options.training?.resolveAssetUrl
  );
  const [imgError, setImgError] = useState2(false);
  if (!payload) return /* @__PURE__ */ jsx11(SearchResultCard_default, { item, query, onNavigate, showRankDebug });
  const showImage = Boolean(src) && !imgError;
  const glyph = payload.hasVideo ? /* @__PURE__ */ jsx11(BiPlayCircle, { size: 20, "aria-hidden": true }) : !showImage && payload.hasDocument ? /* @__PURE__ */ jsx11(BiFile, { size: 20, "aria-hidden": true }) : null;
  return /* @__PURE__ */ jsx11(SearchResultCardShell, { item, onNavigate, children: /* @__PURE__ */ jsxs10(Box10, { sx: { display: "flex", alignItems: "center", gap: 2, p: 2, minWidth: 0 }, children: [
    /* @__PURE__ */ jsxs10(
      Box10,
      {
        "aria-hidden": true,
        sx: {
          position: "relative",
          flex: "none",
          width: LEADING_SLOT_WIDTH,
          height: LEADING_SLOT_WIDTH,
          borderRadius: "8px",
          background: POSTER_GRADIENT,
          color: "rgba(255,255,255,0.92)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "inset 0 0 4px rgba(0,0,0,0.18)"
        },
        children: [
          showImage && /* @__PURE__ */ jsx11(
            Box10,
            {
              component: "img",
              src,
              alt: "",
              loading: "lazy",
              onError: () => setImgError(true),
              sx: {
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "8px",
                display: "block"
              }
            }
          ),
          glyph && /* @__PURE__ */ jsx11(Box10, { sx: { position: "relative", display: "inline-flex", filter: showImage ? "drop-shadow(0 1px 2px rgba(0,0,0,0.4))" : "none" }, children: glyph }),
          payload.completed && /* @__PURE__ */ jsx11(
            Box10,
            {
              sx: {
                position: "absolute",
                top: -5,
                right: -5,
                width: 16,
                height: 16,
                borderRadius: "50%",
                bgcolor: palette8.success.main,
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0px 1px 3px rgba(0,0,0,0.2)"
              },
              children: /* @__PURE__ */ jsx11(BiCheck, { size: 11 })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxs10(Box10, { sx: { flex: 1, minWidth: 0 }, children: [
      /* @__PURE__ */ jsxs10(Box10, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }, children: [
        /* @__PURE__ */ jsx11(Typography10, { noWrap: true, sx: { fontSize: 15, fontWeight: 600 }, children: /* @__PURE__ */ jsx11(HighlightedText, { text: item.title, query }) }),
        item.status && /* @__PURE__ */ jsx11(StatusChip, { status: item.status }),
        payload.isNew && /* @__PURE__ */ jsx11(StatusChip, { status: "new" }),
        item.titleChips?.map((chip) => /* @__PURE__ */ jsx11(ToneChip, { chip }, chip.label))
      ] }),
      payload.description && /* @__PURE__ */ jsx11(Typography10, { noWrap: true, sx: { fontSize: 13, color: "text.secondary", mt: 0.25 }, children: /* @__PURE__ */ jsx11(HighlightedText, { text: payload.description, query }) }),
      (payload.hasVideo || payload.hasDocument || (item.footChips?.length ?? 0) > 0) && /* @__PURE__ */ jsxs10(Box10, { sx: { display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap", mt: 0.75 }, children: [
        payload.hasVideo && /* @__PURE__ */ jsx11(FormatMark, { icon: BiPlayCircle, label: "Video" }),
        payload.hasDocument && /* @__PURE__ */ jsx11(FormatMark, { icon: BiFile, label: "Document" }),
        item.footChips && item.footChips.length > 0 && /* @__PURE__ */ jsx11(Box10, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }, children: item.footChips.map((chip) => /* @__PURE__ */ jsx11(ToneChip, { chip }, chip.label)) })
      ] }),
      showRankDebug && /* @__PURE__ */ jsx11(RankDebugLine, { item })
    ] })
  ] }) });
};
var LearningModuleSearchCard_default = LearningModuleSearchCard;

// src/items/learningModules.ts
function learningModuleToItem(module, { href, completed = false, isNew = false, match } = {}) {
  const category = featureLabel(module.feature);
  const hasVideo = extractYouTubeId(module.hero_video_url) != null;
  const hasDocument = Boolean(module.attachment_url);
  const audiences = [...module.audiences ?? []];
  const tiers = module.tiers ? [...module.tiers] : null;
  const titleChips = [{ label: category, tone: "saas" }];
  const footChips = [
    ...audiences.map((audience) => ({ label: audienceLabel(audience), tone: "neutral" })),
    ...(tiers ?? []).map((tier) => ({ label: tierLabel(tier), tone: "neutral" }))
  ];
  return {
    key: `training-${module.key}`,
    entityKey: "training",
    // Feature-gate check (#1109): both portals' reader routes are auth-only —
    // no gate to mirror; the portal's href resolver still decides per row.
    href: href?.({ key: module.key }),
    title: module.name,
    status: completed ? "completed" : void 0,
    titleChips,
    primaryLine: module.description ?? void 0,
    // Refine (find-within-results) reads these lines, so the key and formats
    // are findable even though the card renders the payload instead.
    secondaryLine: metaLine(category, hasVideo && "Video", hasDocument && "Document", module.key),
    footChips,
    // Deliberately undated: a training module is a timeless record, so it takes
    // the neutral recency score (searchScoring UNDATED_RECENCY_SCORE) rather
    // than sinking to 0 after 90 days. "New" is the card's own 14-day chip.
    payload: {
      key: module.key,
      name: module.name,
      description: module.description ?? null,
      feature: module.feature,
      featureLabel: category,
      audiences,
      tiers,
      hasVideo,
      hasDocument,
      thumbnailUrl: module.thumbnail_url ?? null,
      heroVideoUrl: module.hero_video_url ?? null,
      completed,
      isNew,
      matchScore: match?.score ?? 2,
      matchField: match?.field
    }
  };
}

// src/entities/learningModules.tsx
var CATALOG_FETCH_CAP = 1e3;
function useSearch9(query, { limit, skip, offset = 0 }) {
  const { options } = useGlobalSearchConfig();
  const {
    href,
    useEnabled = useAlwaysEnabled,
    useScope = useOpenTrainingScope,
    useCompletedKeys = useNoCompletedKeys
  } = options.training ?? {};
  const enabled = useEnabled();
  const scope = useScope();
  const completed = useCompletedKeys();
  const where = useMemo10(() => buildLearningModulesWhere(query), [query]);
  const skipped = skip || !enabled || scope === null || where == null;
  const { data, loading, error } = useSearchLearningModulesQuery({
    variables: { where: where ?? {}, limit: CATALOG_FETCH_CAP },
    skip: skipped,
    errorPolicy: "all",
    fetchPolicy: "cache-first"
  });
  const matched = useMemo10(() => {
    if (skipped) return [];
    const live = resolveLiveModules(data?.learning_modules ?? [], /* @__PURE__ */ new Date());
    const scoped = scope ? filterForRooftop(live, scope) : live;
    return scoped.flatMap((module) => {
      const match = matchLearningModule(module, query);
      return match ? [{ module, match }] : [];
    }).sort(compareMatchedModules);
  }, [data, scope, query, skipped]);
  const items = useMemo10(() => {
    const now = /* @__PURE__ */ new Date();
    return matched.slice(offset, offset + limit).map(
      ({ module, match }) => learningModuleToItem(module, {
        href,
        match,
        completed: completed?.has(module.key) ?? false,
        isNew: isRecentlyReleased(module, now)
      })
    );
  }, [matched, offset, limit, href, completed]);
  return {
    items,
    loading: !skipped && loading,
    hasMore: matched.length > offset + limit,
    total: skipped ? void 0 : matched.length,
    error
  };
}
var PRIORITY9 = { text: 45 };
var trainingEntity = {
  key: "training",
  label: "Learning Center",
  // Items don't self-identify — chip them in the unified list.
  itemLabel: "Training",
  itemIcon: "book",
  searchHint: "Training title, description, category (Moves, Guest Rides, Mobile Service\u2026), module key",
  priorityFor: (kind) => PRIORITY9[kind] ?? 0,
  // Client-side matching over a term-independent catalog: no drill-down
  // dimension applies — no move status, no timestamp a date window means, no
  // vehicle, and the rooftop filter narrows tables by customer_id, which
  // modules do not carry (the portal's scope hook decides visibility instead).
  filterSupport: { status: false, window: false, customer: false, vehicle: false },
  // The entity owns what "exact" means: matchLearningModule scored it already.
  scoreItem: (item) => item.payload?.matchScore ?? 2,
  useSearch: useSearch9,
  // Direction B of the #2325 mockup: the library card as a row.
  Card: LearningModuleSearchCard_default,
  cardRequiresPayload: true
};

// src/entities/users.tsx
import { useMemo as useMemo11 } from "react";

// src/gql/searchUsers.query.generated.ts
import { gql as gql13 } from "@apollo/client";
import * as Apollo13 from "@apollo/client";
import { resolveExecutor as resolveExecutor13 } from "@hopdrive/sdk-core";
var defaultOptions13 = {};
var UserSearchRowFragmentDoc = gql13`
    fragment UserSearchRow on users {
  id
  updated_at
  display_name
  email
  phone
  avatar_url
  active
  default_role
  customer {
    id
    name
    tier
  }
  driver {
    id
    tax_class
  }
  users_usertoroles {
    roletype {
      id
      name
    }
  }
}
    `;
var SearchUsersDocument = gql13`
    query searchUsers($where: users_bool_exp!, $limit: Int!, $offset: Int!, $withCount: Boolean!) {
  users(
    where: $where
    limit: $limit
    offset: $offset
    order_by: {display_name: asc}
  ) {
    ...UserSearchRow
  }
  users_aggregate(where: $where) @include(if: $withCount) {
    aggregate {
      count
    }
  }
}
    ${UserSearchRowFragmentDoc}`;
function useSearchUsersQuery(baseOptions) {
  const options = { ...defaultOptions13, ...baseOptions };
  return Apollo13.useQuery(SearchUsersDocument, options);
}

// src/gql/privileged/searchUsersWithNotes.query.generated.ts
import { gql as gql14 } from "@apollo/client";
import * as Apollo14 from "@apollo/client";
import { resolveExecutor as resolveExecutor14 } from "@hopdrive/sdk-core";
var defaultOptions14 = {};
var SearchUsersWithNotesDocument = gql14`
    query searchUsersWithNotes($where: users_bool_exp!, $limit: Int!, $offset: Int!, $withCount: Boolean!) {
  users(
    where: $where
    limit: $limit
    offset: $offset
    order_by: {display_name: asc}
  ) {
    ...UserSearchRow
    dispatchnotes_aggregate {
      aggregate {
        count
      }
    }
    dispatchnotes(order_by: {id: desc}, limit: 5) {
      note
      createdat
      createdby
    }
  }
  users_aggregate(where: $where) @include(if: $withCount) {
    aggregate {
      count
    }
  }
}
    ${UserSearchRowFragmentDoc}`;
function useSearchUsersWithNotesQuery(baseOptions) {
  const options = { ...defaultOptions14, ...baseOptions };
  return Apollo14.useQuery(SearchUsersWithNotesDocument, options);
}

// src/gql/privileged/searchUserRecentMoves.query.generated.ts
import { gql as gql15 } from "@apollo/client";
import * as Apollo15 from "@apollo/client";
import { resolveExecutor as resolveExecutor15 } from "@hopdrive/sdk-core";
var defaultOptions15 = {};
var SearchUserRecentMovesDocument = gql15`
    query searchUserRecentMoves($emails: [String!]!) {
  moves(
    where: {createdBy: {_in: $emails}}
    distinct_on: createdBy
    order_by: [{createdBy: asc}, {id: desc}]
  ) {
    id
    createdBy
    status
    cancel_status
    move_type
    pickup_time
  }
}
    `;
function useSearchUserRecentMovesQuery(baseOptions) {
  const options = { ...defaultOptions15, ...baseOptions };
  return Apollo15.useQuery(SearchUserRecentMovesDocument, options);
}

// src/entities/users.tsx
var DEFAULT_INTERNAL_ROLES = ["admin", "dispatcher"];
var defaultIsInternalRole = (role) => DEFAULT_INTERNAL_ROLES.includes(role);
var defaultRoleLabel = (role) => titleCase(role.replace(/-/g, " "));
function roleChips(user, options) {
  const roleLabel = options.roleLabel ?? defaultRoleLabel;
  const isInternal = (options.isInternalRole ?? defaultIsInternalRole)(user.default_role);
  const chips = [];
  const isDriver = user.default_role === "driver" || (user.users_usertoroles ?? []).some((r) => r.roletype?.name === "driver");
  if (isInternal) chips.push({ label: roleLabel(user.default_role), tone: "internal", icon: "person" });
  else if (user.default_role !== "driver") chips.push({ label: roleLabel(user.default_role), tone: "portal", icon: "person" });
  if (isDriver) {
    if (options.driverChips) {
      if (user.customer?.tier === "lite") chips.push({ label: "SaaS Driver", tone: "driver", icon: "driver" });
      else if (user.driver?.tax_class === "W-2") chips.push({ label: "W-2 Driver", tone: "driver", icon: "driver" });
      else chips.push({ label: "Gig Driver", tone: "driver", icon: "driver" });
    } else {
      chips.push({ label: "Driver", tone: "driver", icon: "driver" });
    }
  }
  if (!user.active) chips.push({ label: "Inactive", tone: "neutral" });
  return chips;
}
function toItem2(user, options, recentMove, href) {
  const footChips = [];
  if (user.customer?.name) footChips.push({ label: user.customer.name, tone: "neutral" });
  const tier = tierChip(user.customer?.tier);
  if (tier) footChips.push(tier);
  const notes = user.dispatchnotes?.map((entry) => ({
    note: entry.note,
    createdat: entry.createdat,
    createdby: entry.createdby
  }));
  return {
    key: `users-${user.id}`,
    entityKey: "users",
    // Dispatcher notes (#803) — the shared hover chip; full history on the
    // user's Notes tab. Absent unless the portal has admin-role reach.
    notes,
    noteCount: user.dispatchnotes_aggregate?.aggregate?.count,
    // Activity beats edit-time: the enrichment move is a genuine "recently
    // active" signal, so it wins where the portal fetches it.
    recency: recentMove?.pickup_time ?? user.updated_at ?? null,
    customerId: user.customer?.id ?? void 0,
    href,
    title: user.display_name,
    titleChips: roleChips(user, options),
    avatar: { initials: initialsOf(user.display_name), src: user.avatar_url },
    primaryLine: metaLine(formatPhone(user.phone), user.email),
    secondaryLine: recentMove ? metaLine(
      titleCase(recentMove.move_type),
      recentMove.cancel_status ?? recentMove.status,
      formatDateTime(recentMove.pickup_time)
    ) : void 0,
    footChips
  };
}
var NO_EMAILS = [];
function useSearch10(query, { limit, skip, offset = 0, withTotal = false, filters }) {
  const { options } = useGlobalSearchConfig();
  const privileged = usePrivilegedReach();
  const userOptions = options.users ?? {};
  const useEnabled = userOptions.useEnabled ?? useAlwaysEnabled;
  const enabled = useEnabled();
  const useHref = userOptions.useHref ?? useNoHref;
  const hrefFromHook = useHref();
  const where = useMemo11(() => buildUsersWhere(query, filters), [query, filters]);
  const skipped = skip || !enabled || !where;
  const withNotes = privileged.dispatchNotes === true;
  const canCount = useCanCount("users");
  const variables = { where: where ?? {}, limit: limit + 1, offset, withCount: withTotal && canCount };
  const plain = useSearchUsersQuery({ variables, skip: skipped || withNotes, errorPolicy: "all" });
  const noted = useSearchUsersWithNotesQuery({ variables, skip: skipped || !withNotes, errorPolicy: "all" });
  const { data, loading, error: queryError } = withNotes ? noted : plain;
  const error = useCountFallback("users", { error: queryError, loading });
  const visible = useMemo11(
    () => skipped ? [] : (data?.users ?? []).slice(0, limit),
    [data, skipped, limit]
  );
  const emails = useMemo11(
    () => privileged.userRecentMoves ? visible.map((user) => user.email).filter((e) => !!e) : NO_EMAILS,
    [visible, privileged.userRecentMoves]
  );
  const { data: recentMovesData, loading: recentLoading } = useSearchUserRecentMovesQuery({
    variables: { emails },
    skip: skipped || emails.length === 0,
    errorPolicy: "all"
  });
  const items = useMemo11(() => {
    const recentByEmail = new Map((recentMovesData?.moves ?? []).map((move) => [move.createdBy, move]));
    const hrefFor = hrefFromHook ?? ((user) => userOptions.href?.(user) ?? `/users/${user.id}`);
    return visible.map(
      (user) => toItem2(user, userOptions, user.email ? recentByEmail.get(user.email) : void 0, hrefFor(user))
    );
  }, [visible, recentMovesData, userOptions, hrefFromHook]);
  return {
    items,
    // The second round counts as loading too: rows still render immediately,
    // and the section's flag flips once the enrichment lands so the merged
    // list picks up the new lines and recency (#755 review).
    loading: !skipped && (loading || recentLoading),
    hasMore: !skipped && (data?.users ?? []).length > limit,
    total: data?.users_aggregate?.aggregate?.count,
    error
  };
}
var PRIORITY10 = { email: 100, phone: 90, text: 90, numeric: 40 };
var usersEntity = {
  key: "users",
  label: "Users",
  searchHint: "Name, email address, phone number",
  priorityFor: (kind) => PRIORITY10[kind] ?? 0,
  filterSupport: { status: false, window: false },
  useSearch: useSearch10
};

// src/registry.ts
var BUILT_IN_ENTITIES = {
  users: usersEntity,
  guests: guestsEntity,
  moves: movesEntity,
  customers: customersEntity,
  drivers: driversEntity,
  locations: locationsEntity,
  lanes: lanesEntity,
  mobility: mobilityEntity,
  training: trainingEntity,
  invoices: invoicesEntity
};
var ALL_ENTITY_KEYS = Object.keys(BUILT_IN_ENTITIES);
function resolveSearchEntities(config) {
  return config.entities.map((registration) => {
    if (isEntityModule(registration)) return registration;
    const entity = BUILT_IN_ENTITIES[registration];
    if (!entity) {
      throw new Error(
        `Unknown search entity '${registration}'. Known entities: ${ALL_ENTITY_KEYS.join(", ")}. To register something else, pass a whole SearchEntityModule instead of a key.`
      );
    }
    const label = config.options[registration]?.label;
    return label ? { ...entity, label } : entity;
  });
}

// src/state.ts
function buildSearchState(query, active, entries) {
  const sections = entries.map(({ entity, result }) => ({ entity, ...result, items: rankItems(result.items, query) })).sort((a, b) => b.entity.priorityFor(query.kind) - a.entity.priorityFor(query.kind));
  return {
    query,
    active,
    // Typed-but-unsearchable, as opposed to nothing typed at all.
    tooShort: !active && query.kind !== "empty",
    sections,
    loading: active && sections.some((section) => section.loading),
    totalCount: sections.reduce((count, section) => count + section.items.length, 0),
    hasMore: sections.some((section) => section.hasMore)
  };
}

// src/useGlobalSearch.ts
function useGlobalSearch(rawTerm, options = {}) {
  const { limitPerSection = 25, limits, offsets, withTotals = false, filters, enabled = true } = options;
  const config = useGlobalSearchConfig();
  const entities = useMemo12(() => resolveSearchEntities(config), [config]);
  useAssertStableConfig(config, entities);
  const query = useMemo12(() => parseSearchQuery(rawTerm), [rawTerm]);
  const active = enabled && meetsMinLength(query);
  const optionsFor = (key) => ({
    limit: limits?.[key] ?? limitPerSection,
    offset: offsets?.[key] ?? 0,
    skip: !active,
    withTotal: withTotals,
    filters
  });
  const entries = entities.map((entity) => ({
    entity,
    // eslint-disable-next-line react-hooks/rules-of-hooks -- fixed-length, fixed-order list; see useAssertStableConfig
    result: entity.useSearch(query, optionsFor(entity.key))
  }));
  return buildSearchState(query, active, entries);
}
function useAssertStableConfig(config, entities) {
  const previous = useRef(null);
  const signature = entities.map((entity) => entity.key).join(",");
  if (previous.current && previous.current.config !== config) {
    const drifted = previous.current.signature === signature ? `The registered entities are unchanged ('${signature}'), so the difference is elsewhere in the config \u2014 most likely one of its use* hooks.` : `Registered entities changed: '${previous.current.signature}' \u2192 '${signature}'.`;
    throw new Error(
      `Global search received a different config object between renders. Every use* field on the config is called as a hook in a fixed order, so a config rebuilt per render breaks the rules of hooks. ${drifted} Build it once at module scope with defineGlobalSearch() and export the result, rather than constructing it inline in a component.`
    );
  }
  previous.current = { config, signature };
}

// src/useVehicleFilterOptions.ts
import { useCallback as useCallback6, useMemo as useMemo13, useState as useState3 } from "react";

// src/gql/vehicleMakeOptions.query.generated.ts
import { gql as gql16 } from "@apollo/client";
import * as Apollo16 from "@apollo/client";
import { resolveExecutor as resolveExecutor16 } from "@hopdrive/sdk-core";
var defaultOptions16 = {};
var VehicleMakeOptionsDocument = gql16`
    query vehicleMakeOptions {
  vehiclemakes(order_by: {name: asc}) {
    id
    name
  }
}
    `;
function useVehicleMakeOptionsQuery(baseOptions) {
  const options = { ...defaultOptions16, ...baseOptions };
  return Apollo16.useQuery(VehicleMakeOptionsDocument, options);
}

// src/gql/vehicleModelOptions.query.generated.ts
import { gql as gql17 } from "@apollo/client";
import * as Apollo17 from "@apollo/client";
import { resolveExecutor as resolveExecutor17 } from "@hopdrive/sdk-core";
var defaultOptions17 = {};
var VehicleModelOptionsDocument = gql17`
    query vehicleModelOptions($makeId: Int!) {
  vehiclemodels(
    where: {make_id: {_eq: $makeId}}
    distinct_on: name
    order_by: {name: asc}
  ) {
    id
    name
  }
}
    `;
function useVehicleModelOptionsQuery(baseOptions) {
  const options = { ...defaultOptions17, ...baseOptions };
  return Apollo17.useQuery(VehicleModelOptionsDocument, options);
}

// src/useVehicleFilterOptions.ts
var NO_MAKES = [];
var NO_MODELS = [];
function useVehicleFilterOptions(filters, tokenActive = false) {
  const [wanted, setWanted] = useState3(false);
  const active = filters.make != null || filters.model != null || filters.color != null;
  const { data: makesData, loading: makesLoading } = useVehicleMakeOptionsQuery({
    skip: !(wanted || active || tokenActive)
  });
  const makes = makesData?.vehiclemakes ?? NO_MAKES;
  const makeId = useMemo13(
    () => makes.find((make) => make.name.toLowerCase() === filters.make?.toLowerCase())?.id,
    [makes, filters.make]
  );
  const { data: modelsData, loading: modelsLoading } = useVehicleModelOptionsQuery({
    variables: { makeId: makeId ?? 0 },
    skip: makeId == null
  });
  const models = useMemo13(
    () => makeId == null ? NO_MODELS : (modelsData?.vehiclemodels ?? []).map((model) => model.name),
    [modelsData, makeId]
  );
  const onNeeded = useCallback6(() => setWanted(true), []);
  return { makes, makesLoading, models, modelsLoading, onNeeded };
}

// src/components/SearchFiltersRow.tsx
import { useEffect as useEffect4, useRef as useRef2, useState as useState4 } from "react";
import { Autocomplete, Box as Box11, Button, ListSubheader, Menu, MenuItem, TextField } from "@mui/material";
import { BiPlus } from "react-icons/bi";
import { Fragment as Fragment3, jsx as jsx12, jsxs as jsxs11 } from "react/jsx-runtime";
var ANY = "__any__";
var CUSTOM = "__custom__";
var SHELF_DIMENSIONS = FILTER_DIMENSIONS.filter((dimension) => !dimension.pinned);
var GROUP_HEADER_SX = { lineHeight: "32px", fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5 };
var SearchFiltersRow = ({ value, onChange, extraControls, vehicleOptions, sx }) => {
  const hasRange = value.from != null || value.to != null;
  const [customOpen, setCustomOpen] = useState4(false);
  const hadRange = useRef2(hasRange);
  const insideEdit = useRef2(false);
  useEffect4(() => {
    if (hadRange.current && !hasRange && !insideEdit.current) setCustomOpen(false);
    insideEdit.current = false;
    hadRange.current = hasRange;
  }, [hasRange, value.from, value.to]);
  const patchBound = (patch) => {
    insideEdit.current = true;
    onChange({ ...patch, window: void 0 });
  };
  const showRange = hasRange || customOpen;
  const dateValue = showRange ? CUSTOM : value.window ?? ANY;
  const handleDateSelect = (selected) => {
    if (selected === CUSTOM) {
      setCustomOpen(true);
      if (value.window) onChange({ window: void 0 });
      return;
    }
    setCustomOpen(false);
    onChange({
      window: selected === ANY ? void 0 : selected,
      from: void 0,
      to: void 0
    });
  };
  const [added, setAdded] = useState4([]);
  const shownShelf = SHELF_DIMENSIONS.filter(
    (dimension) => added.includes(dimension.key) || dimension.isActive(value)
  );
  const addable = SHELF_DIMENSIONS.filter((dimension) => !shownShelf.includes(dimension));
  const [menuAnchor, setMenuAnchor] = useState4(null);
  const openAddMenu = (event) => {
    vehicleOptions?.onNeeded();
    setMenuAnchor(event.currentTarget);
  };
  const addDimension = (key) => {
    setAdded((current) => current.includes(key) ? current : [...current, key]);
    setMenuAnchor(null);
  };
  const shelfControls = {
    status: /* @__PURE__ */ jsxs11(
      TextField,
      {
        select: true,
        size: "small",
        label: "Move status",
        value: value.status ?? ANY,
        onChange: (event) => onChange({ status: event.target.value === ANY ? void 0 : event.target.value }),
        sx: { width: 160 },
        children: [
          /* @__PURE__ */ jsx12(MenuItem, { value: ANY, children: "Any status" }),
          MOVE_STATUS_FILTER_OPTIONS.map((option) => /* @__PURE__ */ jsx12(MenuItem, { value: option.key, children: option.label }, option.key))
        ]
      },
      "status"
    ),
    make: /* @__PURE__ */ jsx12(
      Autocomplete,
      {
        size: "small",
        freeSolo: true,
        autoSelect: true,
        options: (vehicleOptions?.makes ?? []).map((make) => make.name),
        loading: vehicleOptions?.makesLoading,
        value: value.make ?? null,
        onChange: (_, selected) => onChange({ make: selected || void 0 }),
        renderInput: (params) => /* @__PURE__ */ jsx12(TextField, { ...params, label: "Make", placeholder: "Any make" }),
        sx: { width: 185 }
      },
      "make"
    ),
    model: /* @__PURE__ */ jsx12(
      Autocomplete,
      {
        size: "small",
        freeSolo: true,
        autoSelect: true,
        options: vehicleOptions?.models ?? [],
        loading: vehicleOptions?.modelsLoading,
        value: value.model ?? null,
        onChange: (_, selected) => onChange({ model: selected || void 0 }),
        renderInput: (params) => /* @__PURE__ */ jsx12(TextField, { ...params, label: "Model", placeholder: "Any model" }),
        sx: { width: 185 }
      },
      "model"
    ),
    color: /* @__PURE__ */ jsxs11(
      TextField,
      {
        select: true,
        size: "small",
        label: "Color",
        value: value.color ?? ANY,
        onChange: (event) => onChange({ color: event.target.value === ANY ? void 0 : event.target.value }),
        sx: { width: 150 },
        children: [
          /* @__PURE__ */ jsx12(MenuItem, { value: ANY, children: "Any color" }),
          VEHICLE_COLOR_FILTER_OPTIONS.map((option) => /* @__PURE__ */ jsx12(MenuItem, { value: option.key, children: option.label }, option.key))
        ]
      },
      "color"
    )
  };
  return /* @__PURE__ */ jsxs11(
    Box11,
    {
      sx: [
        { display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" },
        ...Array.isArray(sx) ? sx : sx ? [sx] : []
      ],
      children: [
        /* @__PURE__ */ jsxs11(TextField, { select: true, size: "small", label: "Date", value: dateValue, onChange: (event) => handleDateSelect(event.target.value), sx: { width: 185 }, children: [
          /* @__PURE__ */ jsx12(MenuItem, { value: ANY, children: "Any date" }),
          /* @__PURE__ */ jsx12(ListSubheader, { sx: GROUP_HEADER_SX, children: "Calendar" }),
          DATE_WINDOW_FILTER_OPTIONS.filter((option) => option.group === "calendar").map((option) => /* @__PURE__ */ jsx12(MenuItem, { value: option.key, children: option.label }, option.key)),
          /* @__PURE__ */ jsx12(ListSubheader, { sx: GROUP_HEADER_SX, children: "Rolling" }),
          DATE_WINDOW_FILTER_OPTIONS.filter((option) => option.group === "rolling").map((option) => /* @__PURE__ */ jsx12(MenuItem, { value: option.key, children: option.label }, option.key)),
          /* @__PURE__ */ jsx12(MenuItem, { value: CUSTOM, children: "Custom range\u2026" })
        ] }),
        showRange && /* @__PURE__ */ jsxs11(Fragment3, { children: [
          /* @__PURE__ */ jsx12(
            TextField,
            {
              type: "date",
              size: "small",
              label: "From",
              InputLabelProps: { shrink: true },
              value: value.from ?? "",
              inputProps: { max: value.to },
              onChange: (event) => patchBound({ from: event.target.value || void 0 }),
              sx: { width: 165 }
            }
          ),
          /* @__PURE__ */ jsx12(
            TextField,
            {
              type: "date",
              size: "small",
              label: "To",
              InputLabelProps: { shrink: true },
              value: value.to ?? "",
              inputProps: { min: value.from },
              onChange: (event) => patchBound({ to: event.target.value || void 0 }),
              sx: { width: 165 }
            }
          )
        ] }),
        extraControls,
        shownShelf.map((dimension) => shelfControls[dimension.key]),
        addable.length > 0 && /* @__PURE__ */ jsxs11(Fragment3, { children: [
          /* @__PURE__ */ jsx12(
            Button,
            {
              variant: "outlined",
              size: "small",
              startIcon: /* @__PURE__ */ jsx12(BiPlus, { size: 15 }),
              onClick: openAddMenu,
              sx: {
                height: 38,
                borderStyle: "dashed",
                color: "text.secondary",
                borderColor: "divider",
                fontWeight: 600,
                textTransform: "none",
                "&:hover": { borderStyle: "dashed" }
              },
              children: "Add filter"
            }
          ),
          /* @__PURE__ */ jsx12(Menu, { anchorEl: menuAnchor, open: menuAnchor != null, onClose: () => setMenuAnchor(null), children: [...new Set(addable.map((dimension) => dimension.group))].flatMap((group) => [
            /* @__PURE__ */ jsx12(ListSubheader, { sx: GROUP_HEADER_SX, children: group }, group),
            ...addable.filter((dimension) => dimension.group === group).map((dimension) => /* @__PURE__ */ jsx12(MenuItem, { onClick: () => addDimension(dimension.key), sx: { minWidth: 180 }, children: dimension.label }, dimension.key))
          ]) })
        ] })
      ]
    }
  );
};
var SearchFiltersRow_default = SearchFiltersRow;

// src/components/SearchResultsSummary.tsx
import { Box as Box12 } from "@mui/material";
import { jsxs as jsxs12 } from "react/jsx-runtime";
var SearchResultsSummary = ({
  loading,
  total,
  hasMore,
  scopeLabel,
  reachable,
  sx
}) => {
  const capped = reachable != null && reachable < total;
  return /* @__PURE__ */ jsxs12(
    Box12,
    {
      sx: [
        { fontSize: 13, color: "text.secondary" },
        ...Array.isArray(sx) ? sx : sx ? [sx] : []
      ],
      children: [
        loading ? "Searching\u2026" : `${total}${hasMore ? "+" : ""} ${total === 1 && !hasMore ? "result" : "results"} across ${scopeLabel}`,
        !loading && capped ? ` \u2014 showing the ${reachable} best matches. Narrow the search to reach the rest.` : null
      ]
    }
  );
};
var SearchResultsSummary_default = SearchResultsSummary;

// src/useSearchResultsView.ts
import { useCallback as useCallback7, useMemo as useMemo14, useState as useState5 } from "react";
function useSearchResultsView({
  state,
  filters,
  filtersSig,
  refine,
  page,
  rowsPerPage
}) {
  const { query, sections } = state;
  const { total: displayTotal, hasMore: displayHasMore } = computeDisplayTotals(sections);
  const refining = refine.trim().length > 0;
  const displaySections = refineSections(sections, refine);
  const sectionsSig = sectionsSignature(displaySections);
  const recencyAnchor = useMemo14(
    () => recencyAnchorDate(filters),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- filtersSig is filters' stable signature
    [filtersSig]
  );
  const merged = useMemo14(
    () => mergeSections(displaySections, query, recencyAnchor),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sectionsSig stands in for displaySections
    [sectionsSig, query, recencyAnchor]
  );
  const {
    reachableTotal,
    page: safePage,
    capped: fetchCapped
  } = reachableBounds({ displayTotal, pooledRows: merged.length, page, rowsPerPage });
  const items = normalizePagedStrips(
    refining ? merged : merged.slice(safePage * rowsPerPage, (safePage + 1) * rowsPerPage)
  );
  const [expandedRelated, setExpandedRelated] = useState5(/* @__PURE__ */ new Set());
  const rows = useMemo14(
    () => collapseRelatedRows(items, expandedRelated, refining ? Infinity : void 0),
    [items, expandedRelated, refining]
  );
  const toggleRelated = useCallback7((anchorKey) => {
    setExpandedRelated((prev) => {
      const next = new Set(prev);
      if (next.has(anchorKey)) next.delete(anchorKey);
      else next.add(anchorKey);
      return next;
    });
  }, []);
  const relatedStrip = useMemo14(
    () => refining ? null : { expandedAnchors: expandedRelated, onToggle: toggleRelated },
    [refining, expandedRelated, toggleRelated]
  );
  return {
    refining,
    rows,
    merged,
    displayTotal,
    displayHasMore,
    reachableTotal,
    page: safePage,
    fetchCapped,
    relatedStrip
  };
}

// src/utils/platform.ts
var isMac = typeof navigator !== "undefined" && /Mac/i.test(navigator.platform);
var SHORTCUT_LABEL = isMac ? "\u2318K" : "Ctrl+K";
function withShortcut(copy) {
  return copy.replace(/\{shortcut\}/g, SHORTCUT_LABEL);
}

// src/utils/filterTokens.ts
var MAX_SUGGESTIONS = 6;
var DIMENSION_BY_PREFIX = new Map(
  FILTER_DIMENSIONS.map((dimension) => [(dimension.tokenPrefix ?? dimension.key).toLowerCase(), dimension])
);
var TOKEN_AT_END = /(^|\s)([a-zA-Z]+):([^:]*)$/;
function detectFilterTokenDimension(refine) {
  const match = TOKEN_AT_END.exec(refine);
  return match ? DIMENSION_BY_PREFIX.get(match[2].toLowerCase()) ?? null : null;
}
function parseFilterToken(refine, sources) {
  const match = TOKEN_AT_END.exec(refine);
  if (!match) return null;
  const dimension = DIMENSION_BY_PREFIX.get(match[2].toLowerCase());
  if (!dimension) return null;
  const partial = match[3].trim();
  const needle = partial.toLowerCase();
  const options = sources.options[dimension.key] ?? [];
  const startsWith = options.filter(
    (option) => option.label.toLowerCase().startsWith(needle) || option.value.toLowerCase().startsWith(needle)
  );
  const contains = options.filter(
    (option) => !startsWith.includes(option) && (option.label.toLowerCase().includes(needle) || option.value.toLowerCase().includes(needle))
  );
  const suggestions = [...startsWith, ...contains].slice(0, MAX_SUGGESTIONS);
  const exact = needle ? options.find((option) => option.label.toLowerCase() === needle || option.value.toLowerCase() === needle) : void 0;
  return {
    dimension,
    partial,
    rest: refine.slice(0, match.index).trimEnd(),
    suggestions,
    exact,
    freeform: Boolean(partial && sources.freeform?.includes(dimension.key))
  };
}

// src/pages/GlobalSearchResultsPage.tsx
import { Fragment as Fragment4, jsx as jsx13, jsxs as jsxs13 } from "react/jsx-runtime";
var GlobalSearchResultsPage = () => {
  const config = useGlobalSearchConfig();
  const { page: pageConfig } = config;
  const { DataCard, PageShell, EmptyState, RooftopFilter } = pageConfig.slots;
  const [searchParams] = useSearchParams2();
  const q = searchParams.get("q") ?? "";
  const rankDebug = searchParams.get("rankdebug") === "1";
  const [rowsPerPage, storeRowsPerPage] = useStoredSearchPageSize();
  const [page, setPage] = useState6(0);
  const [refine, setRefine] = useState6("");
  const useScopeOptions = config.useScopeOptions ?? useNoScopeOptions;
  const scopeOptions = useScopeOptions();
  const [searchFilters, patchFilters, clearSearchFilters] = useSearchFilterParams();
  const effectiveFilters = useMemo15(
    () => sanitizeCustomerFilter(searchFilters, scopeOptions.length ? scopeOptions.map((o) => o.id) : void 0),
    [searchFilters, scopeOptions]
  );
  const filtersSig = filtersKey(effectiveFilters);
  const { query, active, tooShort, sections, loading, totalCount } = useGlobalSearch(q, {
    // Every entity fetches enough to cover the current page of the merged pool
    // (client-side slice over the relevance-ordered stream), bounded by
    // MAX_FETCH_PER_ENTITY. Cost grows with depth AND across every entity at
    // once — moves fetches two branches each carrying up to 40 vehiclephotos
    // and two workflow `steps` trees, guests overfetches 5x — so the rail
    // matters. Past it the pager reports what is reachable rather than
    // offering pages nothing can fill; the summary still reports the true
    // total. See useSearchResultsView.
    limitPerSection: fetchDepthFor(page, rowsPerPage),
    withTotals: true,
    filters: effectiveFilters
  });
  const useResultNavigate = config.useResultNavigate ?? useDefaultResultNavigate;
  const onResultNavigate = useResultNavigate();
  const entities = useMemo15(() => resolveSearchEntities(config), [config]);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect5(() => {
    setPage(0);
    setRefine("");
  }, [q]);
  useEffect5(() => {
    setPage(0);
  }, [filtersSig]);
  const handleBack = () => {
    if (location.key === "default") navigate(pageConfig.homeHref);
    else navigate(-1);
  };
  const {
    refining,
    rows,
    displayTotal,
    displayHasMore,
    reachableTotal,
    page: safePage,
    relatedStrip
  } = useSearchResultsView({
    state: { query, sections },
    filters: effectiveFilters,
    filtersSig,
    refine,
    page,
    rowsPerPage
  });
  const count = reachableTotal;
  const tokenDimension = detectFilterTokenDimension(refine);
  const vehicleOptions = useVehicleFilterOptions(effectiveFilters, tokenDimension?.group === "Vehicle");
  const tokenSources = useMemo15(
    () => ({
      options: {
        status: MOVE_STATUS_FILTER_OPTIONS.map((o) => ({ value: o.key, label: o.label })),
        date: DATE_WINDOW_FILTER_OPTIONS.map((o) => ({ value: o.key, label: o.label })),
        customer: scopeOptions.map((o) => ({ value: String(o.id), label: o.name })),
        make: vehicleOptions.makes.map((make) => ({ value: make.name, label: make.name })),
        model: vehicleOptions.models.map((name) => ({ value: name, label: name })),
        color: VEHICLE_COLOR_FILTER_OPTIONS.map((o) => ({ value: o.key, label: o.label }))
      },
      // Make and model filter free-text columns — any typed value applies.
      freeform: ["make", "model"]
    }),
    [scopeOptions, vehicleOptions.makes, vehicleOptions.models]
  );
  const token = useMemo15(() => parseFilterToken(refine, tokenSources), [refine, tokenSources]);
  const acceptToken = useCallback8(
    (patch, rest) => {
      patchFilters(patch);
      setRefine(rest);
    },
    [patchFilters]
  );
  useEffect5(() => {
    if (token?.exact && refine.endsWith(" ")) {
      acceptToken(token.dimension.applyToken(token.exact.value), token.rest);
    }
  }, [token, refine, acceptToken]);
  const customerFilterLabel = scopeOptions.find((option) => option.id === effectiveFilters.customerId)?.name ?? String(effectiveFilters.customerId ?? "");
  const activeFilters = useMemo15(() => {
    const chips = [];
    if (refine.trim()) chips.push({ key: "search", label: `"${refine.trim()}"` });
    const context = { customerName: customerFilterLabel };
    for (const dimension of FILTER_DIMENSIONS) {
      const label = dimension.chipLabel(effectiveFilters, context);
      if (label) chips.push({ key: dimension.key, label });
    }
    return chips;
  }, [refine, effectiveFilters, customerFilterLabel]);
  const handleClearFilter = useCallback8(
    (key) => {
      if (key === "search") {
        setRefine("");
        return;
      }
      const dimension = FILTER_DIMENSIONS.find((d) => d.key === key);
      if (dimension) patchFilters(dimension.clearPatch);
    },
    [patchFilters]
  );
  const handleClearAll = useCallback8(() => {
    setRefine("");
    clearSearchFilters();
  }, [clearSearchFilters]);
  const ignoredFilterEntities = sections.filter((section) => section.items.length > 0 && unfilteredHintFor(effectiveFilters, section.entity.filterSupport)).map((section) => section.entity.label);
  const failedSections = sections.filter((section) => section.error).map((section) => section.entity.label);
  const vehicleFilterOn = effectiveFilters.make != null || effectiveFilters.model != null || effectiveFilters.color != null;
  const emptyTitle = failedSections.length > 0 ? "Search couldn\u2019t complete" : `No results for \u201C${query.term}\u201D`;
  const emptyDescription = failedSections.length > 0 ? `${failedSections.join(", ")} search failed \u2014 these results may be incomplete. Try again, or narrow the search.` : vehicleFilterOn ? (
    // A vehicle filter that quietly hides rows is worse than no filter: a
    // large share of moves carry no make or color at all, and those can't
    // match while one is on. Say so.
    "Records with no vehicle details on file are excluded while a vehicle filter is on \u2014 many moves have no make or color recorded."
  ) : "Check the spelling, or try a phone number, move ID, VIN or stock number.";
  return /* @__PURE__ */ jsxs13(PageShell, { children: [
    /* @__PURE__ */ jsx13(
      Button2,
      {
        variant: "text",
        size: "small",
        startIcon: /* @__PURE__ */ jsx13(BiArrowBack, { size: 16 }),
        onClick: handleBack,
        sx: { mb: 1.5, ml: -1, color: "text.secondary", fontWeight: 600, textTransform: "none" },
        children: "Back"
      }
    ),
    active ? /* @__PURE__ */ jsxs13(Fragment4, { children: [
      /* @__PURE__ */ jsxs13(Typography11, { sx: { fontSize: 24, fontWeight: 700, lineHeight: 1.25 }, children: [
        "Search results for",
        " ",
        /* @__PURE__ */ jsxs13(Box13, { component: "span", sx: { color: "primary.main" }, children: [
          "\u201C",
          query.term,
          "\u201D"
        ] })
      ] }),
      /* @__PURE__ */ jsx13(
        SearchResultsSummary_default,
        {
          loading,
          total: displayTotal,
          hasMore: displayHasMore,
          scopeLabel: effectiveFilters.customerId != null ? customerFilterLabel : pageConfig.scopeLabel,
          reachable: reachableTotal,
          sx: { mt: 0.5 }
        }
      ),
      /* @__PURE__ */ jsxs13(
        DataCard,
        {
          search: refine,
          onSearchChange: setRefine,
          searchPlaceholder: "Refine results\u2026",
          filterControls: /* @__PURE__ */ jsx13(
            SearchFiltersRow_default,
            {
              value: effectiveFilters,
              onChange: patchFilters,
              vehicleOptions,
              extraControls: RooftopFilter && scopeOptions.length > 1 ? /* @__PURE__ */ jsx13(
                RooftopFilter,
                {
                  options: scopeOptions,
                  value: effectiveFilters.customerId,
                  onChange: (customerId) => patchFilters({ customerId })
                }
              ) : void 0
            }
          ),
          activeFilters,
          onClearFilter: handleClearFilter,
          onClearAllFilters: handleClearAll,
          loading,
          totalCount: count,
          page: safePage,
          rowsPerPage,
          onPageChange: (_, newPage) => setPage(newPage),
          onRowsPerPageChange: (e) => {
            storeRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          },
          showPagination: !refining,
          resource: "Results",
          emptyIcon: /* @__PURE__ */ jsx13(BiSearchAlt, {}),
          hasData: true,
          emptyTitle,
          emptyDescription,
          children: [
            token && (token.suggestions.length > 0 || token.freeform) && /* @__PURE__ */ jsxs13(Box13, { sx: { px: 3, pt: 1.5, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }, children: [
              /* @__PURE__ */ jsxs13(Typography11, { sx: { fontSize: 12, color: "text.secondary", fontWeight: 600 }, children: [
                "Filter ",
                token.dimension.label,
                ":"
              ] }),
              token.suggestions.map((suggestion) => /* @__PURE__ */ jsx13(
                Chip5,
                {
                  size: "small",
                  label: suggestion.label,
                  onClick: () => acceptToken(token.dimension.applyToken(suggestion.value), token.rest)
                },
                suggestion.value
              )),
              token.freeform && !token.exact && /* @__PURE__ */ jsx13(
                Chip5,
                {
                  size: "small",
                  variant: "outlined",
                  label: `\u201C${token.partial}\u201D`,
                  onClick: () => acceptToken(token.dimension.applyToken(token.partial), token.rest)
                }
              ),
              /* @__PURE__ */ jsx13(Typography11, { sx: { fontSize: 11, color: "text.disabled" }, children: token.exact ? "space applies" : "click to apply" })
            ] }),
            (sections.some((section) => section.error) || ignoredFilterEntities.length > 0 || safePage >= REFINE_NUDGE_PAGE) && /* @__PURE__ */ jsxs13(Box13, { sx: { px: 3, pt: 1.5 }, children: [
              safePage >= REFINE_NUDGE_PAGE && // Results are ranked exact-match-first, so this deep the rows
              // scored ~2 — they matched on a field the card doesn't show.
              // Narrowing finds the record; paging further mostly doesn't.
              /* @__PURE__ */ jsx13(Typography11, { sx: { fontSize: 12, color: "text.secondary" }, children: "Still looking? Results are ranked best-first, so a filter, a phone number or a move ID will usually beat paging further." }),
              sections.filter((section) => section.error).map((section) => /* @__PURE__ */ jsxs13(Typography11, { sx: { fontSize: 13, color: "error.main" }, children: [
                section.entity.label,
                " search failed \u2014 other results are unaffected."
              ] }, section.entity.key)),
              ignoredFilterEntities.length > 0 && /* @__PURE__ */ jsxs13(Typography11, { sx: { fontSize: 12, color: "text.disabled" }, children: [
                "Some active filters don\u2019t apply to: ",
                ignoredFilterEntities.join(", ")
              ] })
            ] }),
            rows.length === 0 ? /* @__PURE__ */ jsxs13(Typography11, { sx: { px: 3, py: 4, textAlign: "center", fontSize: 13, color: "text.secondary" }, children: [
              refining ? `Nothing in these results matches \u201C${refine.trim()}\u201D. Refine looks within the rows already on screen.` : "No results on this page.",
              !refining && (effectiveFilters.make != null || effectiveFilters.model != null || effectiveFilters.color != null) && /* @__PURE__ */ jsxs13(Fragment4, { children: [
                " ",
                "Records with no vehicle details on file are excluded while a vehicle filter is on \u2014 many moves have no make or color recorded."
              ] })
            ] }) : /* @__PURE__ */ jsx13(Box13, { sx: { px: 1, py: 0.5 }, children: /* @__PURE__ */ jsx13(RelatedStripContext.Provider, { value: relatedStrip, children: /* @__PURE__ */ jsx13(Stack, { children: rows.map((item, rowIndex) => {
              const divider = rowIndex > 0 ? /* @__PURE__ */ jsx13(Divider, { sx: { ml: item.relatedTo != null ? "52px" : 0 } }) : null;
              const ResultCard = resolveEntityCard(entities, item);
              return /* @__PURE__ */ jsxs13(React5.Fragment, { children: [
                divider,
                /* @__PURE__ */ jsx13(
                  ResultCard,
                  {
                    item,
                    query,
                    showRankDebug: rankDebug,
                    onNavigate: (event) => onResultNavigate(item, event)
                  }
                )
              ] }, item.key);
            }) }) }) })
          ]
        }
      )
    ] }) : /* @__PURE__ */ jsx13(
      EmptyState,
      {
        title: tooShort ? "Keep typing" : "Search everything",
        description: tooShort ? `\u201C${query.term}\u201D is too short to search \u2014 enter at least 3 characters, or a move ID.` : withShortcut(pageConfig.blankSlateDescription)
      }
    )
  ] });
};
var GlobalSearchResultsPage_default = GlobalSearchResultsPage;

// src/components/HeaderSearch.tsx
import { useMemo as useMemo16 } from "react";

// src/components/GlobalSearchBar.tsx
import { useEffect as useEffect6, useRef as useRef3, useState as useState7 } from "react";
import { useLocation as useLocation2, useNavigate as useNavigate2, useSearchParams as useSearchParams3 } from "react-router-dom";
import { Box as Box14, IconButton, InputBase, Paper, Popover, Tooltip as Tooltip3, Typography as Typography12 } from "@mui/material";
import { styled } from "@mui/material/styles";
import { BiSearch, BiSolidInfoCircle, BiX } from "react-icons/bi";

// src/utils/hintTerms.ts
var DEFAULT_HINT_TERMS = {
  refLabel: "reference #"
};
var resolveHintTerms = (hint, terms) => hint.replace(/\{(\w+)\}/g, (match, token) => terms?.[token] ?? DEFAULT_HINT_TERMS[token] ?? match);

// src/components/GlobalSearchBar.tsx
import { Fragment as Fragment5, jsx as jsx14, jsxs as jsxs14 } from "react/jsx-runtime";
var SearchContainer = styled(Box14)({
  position: "relative",
  width: 380
});
var InputWrapper = styled(Paper)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "0 12px",
  borderRadius: 8,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.default,
  boxShadow: "none",
  "&:focus-within": {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.background.paper
  }
}));
var SEARCH_TERM_MAX_LENGTH = 48;
var GlobalSearchBar = ({
  entities = [],
  hintTerms,
  placeholder = "Search",
  searchPath = "/search",
  inputName
}) => {
  const navigate = useNavigate2();
  const location = useLocation2();
  const [searchParams] = useSearchParams3();
  const inputRef = useRef3(null);
  const [term, setTerm] = useState7("");
  const urlQuery = location.pathname === searchPath ? searchParams.get("q") : null;
  useEffect6(() => {
    if (urlQuery) setTerm(urlQuery);
  }, [urlQuery]);
  const [anchorEl, setAnchorEl] = useState7(null);
  const mobileButtonRef = useRef3(null);
  useEffect6(() => {
    const onKey = (event) => {
      const modifier = isMac ? event.metaKey : event.ctrlKey;
      if (modifier && event.key.toLowerCase() === "k") {
        if (inputRef.current?.offsetParent) {
          event.preventDefault();
          inputRef.current.focus();
          inputRef.current.select();
        } else if (mobileButtonRef.current) {
          event.preventDefault();
          setAnchorEl(mobileButtonRef.current);
        }
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  const goToResults = () => {
    const value = term.trim();
    if (!value) return;
    inputRef.current?.blur();
    setAnchorEl(null);
    navigate(`${searchPath}?q=${encodeURIComponent(value)}`);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") goToResults();
    if (event.key === "Escape") inputRef.current?.blur();
  };
  const hinted = entities.filter((entity) => entity.searchHint);
  const criteriaIcon = hinted.length > 0 && /* @__PURE__ */ jsx14(
    Tooltip3,
    {
      arrow: true,
      placement: "bottom-end",
      title: /* @__PURE__ */ jsxs14(Box14, { sx: { display: "flex", flexDirection: "column", gap: 0.5, minWidth: 200, py: 0.5 }, children: [
        /* @__PURE__ */ jsx14(Typography12, { sx: { fontSize: 13, fontWeight: 600, mb: 0.5 }, children: "Search by criteria:" }),
        hinted.map((entity) => /* @__PURE__ */ jsxs14(Typography12, { sx: { fontSize: 11.5, lineHeight: 1.45 }, children: [
          /* @__PURE__ */ jsxs14(Box14, { component: "span", sx: { fontWeight: 600 }, children: [
            entity.label,
            ":"
          ] }),
          " ",
          resolveHintTerms(entity.searchHint ?? "", hintTerms)
        ] }, entity.key))
      ] }),
      children: /* @__PURE__ */ jsx14(Box14, { sx: { display: "flex", alignItems: "center", ml: 1, color: "text.disabled", cursor: "pointer" }, children: /* @__PURE__ */ jsx14(BiSolidInfoCircle, { size: 18 }) })
    }
  );
  return /* @__PURE__ */ jsxs14(Fragment5, { children: [
    /* @__PURE__ */ jsx14(SearchContainer, { sx: { display: { xs: "none", md: "block" }, mr: 2 }, children: /* @__PURE__ */ jsxs14(InputWrapper, { children: [
      /* @__PURE__ */ jsx14(Box14, { sx: { display: "flex", alignItems: "center", mr: 1, color: "text.disabled" }, children: /* @__PURE__ */ jsx14(BiSearch, { size: 20 }) }),
      /* @__PURE__ */ jsx14(
        InputBase,
        {
          name: inputName,
          inputRef,
          value: term,
          onChange: (event) => setTerm(event.target.value),
          onKeyDown: handleKeyDown,
          placeholder,
          fullWidth: true,
          sx: { fontSize: 14, "& input": { padding: "8px 0" } },
          inputProps: { "aria-label": "Global search", maxLength: SEARCH_TERM_MAX_LENGTH }
        }
      ),
      term ? /* @__PURE__ */ jsx14(IconButton, { size: "small", onClick: () => setTerm(""), sx: { p: 0.5 }, children: /* @__PURE__ */ jsx14(BiX, { size: 18 }) }) : /* @__PURE__ */ jsx14(
        Typography12,
        {
          sx: {
            fontSize: 11,
            color: "text.disabled",
            border: (theme) => `1px solid ${theme.palette.divider}`,
            borderRadius: 1,
            px: 0.75,
            lineHeight: "18px",
            whiteSpace: "nowrap"
          },
          children: SHORTCUT_LABEL
        }
      ),
      criteriaIcon
    ] }) }),
    /* @__PURE__ */ jsxs14(Box14, { sx: { display: { xs: "block", md: "none" } }, children: [
      /* @__PURE__ */ jsx14(Tooltip3, { title: "Search", placement: "bottom", children: /* @__PURE__ */ jsx14(IconButton, { ref: mobileButtonRef, sx: { p: 1, mr: 1 }, onClick: (event) => setAnchorEl(event.currentTarget), children: /* @__PURE__ */ jsx14(BiSearch, { size: 24 }) }) }),
      /* @__PURE__ */ jsx14(
        Popover,
        {
          open: Boolean(anchorEl),
          anchorEl,
          onClose: () => setAnchorEl(null),
          disableRestoreFocus: true,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          slotProps: { paper: { sx: { width: 300, p: 1 } } },
          children: /* @__PURE__ */ jsxs14(InputWrapper, { children: [
            /* @__PURE__ */ jsx14(Box14, { sx: { display: "flex", alignItems: "center", mr: 1, color: "text.disabled" }, children: /* @__PURE__ */ jsx14(BiSearch, { size: 20 }) }),
            /* @__PURE__ */ jsx14(
              InputBase,
              {
                name: inputName,
                autoFocus: true,
                value: term,
                onChange: (event) => setTerm(event.target.value),
                onKeyDown: (event) => {
                  if (event.key === "Enter") {
                    goToResults();
                  }
                },
                placeholder,
                fullWidth: true,
                sx: { fontSize: 14, "& input": { padding: "8px 0" } },
                inputProps: { "aria-label": "Global search", maxLength: SEARCH_TERM_MAX_LENGTH }
              }
            ),
            criteriaIcon
          ] })
        }
      )
    ] })
  ] });
};
var GlobalSearchBar_default = GlobalSearchBar;

// src/components/HeaderSearch.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var HeaderSearch = (props) => {
  const config = useGlobalSearchConfig();
  const entities = useMemo16(() => resolveSearchEntities(config), [config]);
  const useHintTerms = config.useHintTerms ?? useNoHintTerms;
  const hintTerms = useHintTerms();
  return /* @__PURE__ */ jsx15(GlobalSearchBar_default, { entities, hintTerms, ...props });
};
var HeaderSearch_default = HeaderSearch;
export {
  ALL_ENTITY_KEYS,
  BUILT_IN_ENTITIES,
  GlobalSearchBar_default as GlobalSearchBar,
  GlobalSearchProvider,
  GlobalSearchResultsPage_default as GlobalSearchResultsPage,
  HeaderSearch_default as HeaderSearch,
  HighlightedText,
  LEADING_SLOT_WIDTH,
  MAX_ID_DIGITS,
  RankDebugLine,
  SearchResultCard_default as SearchResultCard,
  SearchResultCardShell,
  SearchResultLeading,
  StatusChip,
  ToneChip,
  buildSearchState,
  customersEntity,
  defineGlobalSearch,
  driversEntity,
  escapeLikePattern,
  guestsEntity,
  isEntityModule,
  lanesEntity,
  locationsEntity,
  meetsMinLength,
  mobilityEntity,
  movesEntity,
  normalizePhoneDigits,
  pageVariables,
  parseSearchQuery,
  resolveMoveTypeIdentity,
  resolveSearchEntities,
  trainingEntity,
  useAlwaysEnabled,
  useDefaultResultNavigate,
  useEntityResult,
  useGlobalSearch,
  useGlobalSearchConfig,
  useNoCompletedKeys,
  useNoHintTerms,
  useNoHref,
  useNoScopeOptions,
  useOpenRunAccess,
  useOpenTrainingScope,
  usePrivilegedReach,
  usersEntity,
  withScope
};
//# sourceMappingURL=index.mjs.map